/** 由 scripts/gen-locales.mjs 生成，请勿手改；文案请编辑 src/locales/source/ */
export default {
  "aiFeedback.conversation_id": "លេខសន្ទនាសម្គាល់",
  "aiFeedback.created": "ពេលបញ្ជូន",
  "aiFeedback.detail": "ព័ត៌មានលម្អិត",
  "aiFeedback.kind": "ប្រភេទ",
  "aiFeedback.message_id": "លេខសារសម្គាល់",
  "aiFeedback.model": "ម៉ូដែល",
  "aiFeedback.platform": "ប្រព័ន្ធ",
  "aiFeedback.rating": "ការវាយតម្លៃ",
  "aiFeedback.result_id": "លេខលទ្ធផលសម្គាល់",
  "aiFeedback.result_text": "លទ្ធផល",
  "aiFeedback.role": "តួនាទី",
  "aiFeedback.source_language": "ភាសាដើម",
  "aiFeedback.source_text": "អត្ថបទដើម / អត្ថបទចម្លង",
  "aiFeedback.suggestion": "សំណើ",
  "aiFeedback.target": "ភាសាគោលដៅ",
  "aiFeedback.target_language": "ភាសាគោលដៅ",
  "aiFeedback.title": "មតិការបកប្រែនិងចម្លងសំឡេង",
  "aiFeedback.transcription": "ការចម្លងសំឡេង",
  "aiFeedback.translation": "ការបកប្រែ",
  "aiFeedback.user": "អ្នកប្រើប្រាស់",
  "Bot促活推送.保存成功": "បានរក្សាទុកការកំណត់",
  "Bot促活推送.保存生效": "រក្សាទុក",
  "Bot促活推送.最低岗位数": "ចំនួនការងារអប្បបរមា",
  "Bot促活推送.刷新": "ផ្ទុកឡើងវិញ",
  "Bot促活推送.历史文案未保存": "ខ្លឹមសារសារមិនត្រូវបានរក្សាទុកសម្រាប់កំណត់ត្រាចាស់នេះទេ។",
  "Bot促活推送.发送失败": "បរាជ័យ",
  "Bot促活推送.发送成功": "បានផ្ញើ",
  "Bot促活推送.发送日期": "កាលបរិច្ឆេទផ្ញើ",
  "Bot促活推送.发送时间": "ពេលផ្ញើ",
  "Bot促活推送.发送时间校验": "សូមជ្រើសម៉ោងពី 08:00 ដល់ 21:59។",
  "Bot促活推送.发送结果": "លទ្ធផល",
  "Bot促活推送.发送计划": "កាលវិភាគ និងខ្លឹមសារ",
  "Bot促活推送.发送记录": "ប្រវត្តិការផ្ញើ",
  "Bot促活推送.取数说明": "មិនផ្ញើបើតិចជាង 10 ការងារ។ 10–19 បង្ហាញ 15+; 20–49 បង្ហាញ 45+; 50–99 បង្ហាញ 80+; ចាប់ពី 100 បង្ហាញ 100+។ យកចំណុចកណ្ដាលនៃចន្លោះប្រាក់ខែប្រចាំខែ រួចគណនា P80។ មិនរាប់ប្រាក់ខែចរចា ទិន្នន័យខ្វះ ឬមិនត្រឹមត្រូវ។ បង្ហាញប្រាក់ខែប្រចាំខែ $XX+។",
  "Bot促活推送.变量说明": "អត្ថបទគាំទ្រ {count}、{position}、{location}។ បន្ទាត់ប្រាក់ខែគាំទ្រ {salary}។",
  "Bot促活推送.后台总开关": "បើកការជំរុញ Bot តាមពេលកំណត់",
  "Bot促活推送.启用": "បើកពេលនេះ",
  "Bot促活推送.夜间免打扰说明": "ម៉ោងប៉េកាំង។ មិនផ្ញើពី 22:00 ដល់ 08:00។",
  "Bot促活推送.失败原因": "មូលហេតុបរាជ័យ",
  "Bot促活推送.岗位取数规则": "ច្បាប់ទិន្នន័យការងារ",
  "Bot促活推送.岗位数量": "ចំនួនការងារ",
  "Bot促活推送.已点击": "បានចុច {count} ដង",
  "Bot促活推送.总开关关闭": "កុងតាក់មេរបស់ម៉ាស៊ីនមេត្រូវបានបិទ។ អាចរក្សាទុកការកំណត់បាន ប៉ុន្តែសារកំណត់ពេលនឹងមិនត្រូវបានផ្ញើទេ។",
  "Bot促活推送.打开试发": "បើកការសាកល្បង Bot",
  "Bot促活推送.接收用户": "អ្នកទទួល",
  "Bot促活推送.数量展示": "ការបង្ហាញចំនួនការងារ",
  "Bot促活推送.数量展示.exact": "ចំនួនជាក់លាក់",
  "Bot促活推送.数量展示.range": "កម្រិតចំនួន (15+ / 45+ / 80+ / 100+)",
  "Bot促活推送.新增策略": "បន្ថែមយុទ្ធសាស្ត្រ",
  "Bot促活推送.新策略默认名称": "យុទ្ធសាស្ត្រជំរុញថ្មី",
  "Bot促活推送.是否点击": "បានចុច",
  "Bot促活推送.未点击": "មិនទាន់ចុច",
  "Bot促活推送.未绑定用户": "មិនបានភ្ជាប់អ្នកប្រើ App",
  "Bot促活推送.正文": "អត្ថបទ Bot",
  "Bot促活推送.点击按钮": "ប៊ូតុង",
  "Bot促活推送.点击记录": "ការចុច",
  "Bot促活推送.策略.fallback": "ណែនាំឆានែលសម្រាប់អ្នកគ្មានប្រវត្តិ",
  "Bot促活推送.策略.generic_jobs": "ការងារទូទៅសម្រាប់អ្នកគ្មានប្រវត្តិ",
  "Bot促活推送.策略.jobs": "ណែនាំឆានែលតាមមុខរបរ និងតំបន់",
  "Bot促活推送.策略.location_jobs": "ការងារត្រូវតំបន់",
  "Bot促活推送.策略.matched_jobs": "ការងារត្រូវមុខរបរ និងតំបន់",
  "Bot促活推送.策略.position_jobs": "ការងារត្រូវមុខរបរ",
  "Bot促活推送.策略名称": "ឈ្មោះយុទ្ធសាស្ត្រ",
  "Bot促活推送.策略类型": "ប្រភេទអ្នកទទួល",
  "Bot促活推送.薪资取整": "ឯកតាបង្គត់ប្រាក់ខែ",
  "Bot促活推送.薪资文案": "បន្ទាត់ប្រាក់ខែ",
  "Bot促活推送.薪资文案说明": "អាចទុកទទេ។ ត្រូវមាន {salary} ហើយបន្ថែមតែពេលមានទិន្នន័យប្រាក់ខែ។",
  "Bot促活推送.薪资算法": "ការគណនាប្រាក់ខែ",
  "Bot促活推送.薪资算法.none": "មិនគណនាប្រាក់ខែ",
  "Bot促活推送.薪资算法.p80_midpoint": "P80 នៃចំណុចកណ្ដាលប្រាក់ខែការងារ",
  "Bot促活推送.记录ID": "លេខកំណត់ត្រា",
  "Bot促活推送.语言.en_US": "English",
  "Bot促活推送.语言.km_KH": "ភាសាខ្មែរ",
  "Bot促活推送.语言.zh_CN": "ភាសាចិន",
  "Bot促活推送.运行配置": "ការដំណើរការ",
  "Bot促活推送.页面标题": "ការជំរុញតាម Bot",
  "Bot促活推送.页面说明": "គ្រប់គ្រងសារជំរុញតាម Bot ទំនាក់ទំនងការងារ និង CV។ ការកែប្រែមានប្រសិទ្ធភាពក្នុងប្រហែល 20 វិនាទី ហើយប្រើម៉ោងប៉េកាំង។",
  "Bot促活推送.频控说明": "ការកំណត់ប្រេកង់នៅដដែល៖ សារត្រឡប់ទៅ App អតិបរមា 1 ដងក្នុងមួយថ្ងៃ និង 2 ដងក្នុង 7 ថ្ងៃ។ សារឆានែលមានចន្លោះ 7 ថ្ងៃ ហើយកើនដល់ 14 ថ្ងៃក្រោយមិនអើពើជាបន្តបន្ទាប់។",
  "menu.account": "គណនី",
  "menu.account.logout": "ចាកចេញ",
  "menu.account.settings": "ការកំណត់",
  "menu.ad-channels": "ឆាណែលផ្សព្វផ្សាយ",
  "menu.commercial": "ពាណិជ្ជកម្ម",
  "menu.commercial.commercial-benefits": "ការកំណត់អត្ថប្រយោជន៍",
  "menu.commercial.commercial-orders": "ការបញ្ជាទិញ",
  "menu.commercial.commercial-paywalls": "ទំព័រទិញ",
  "menu.commercial.commercial-products": "ផលិតផល",
  "menu.companies": "ក្រុមហ៊ុន",
  "menu.companies.companies-config": "ការកំណត់",
  "menu.companies.companies-list": "បញ្ជីក្រុមហ៊ុន",
  "menu.config": "ការកំណត់",
  "menu.config.benefit-guarantee-tags": "ឃ្លាំងស្លាក",
  "menu.config.employer-sales-contacts": "ទំនាក់ទំនងផ្នែកលក់",
  "menu.config.hot-job-groups": "ការកំណត់ក្រុមពេញនិយម",
  "menu.config.hot-search-words": "ពាក្យស្វែងរកពេញនិយម",
  "menu.config.jd-complaint-types": "ប្រភេទបរិហារ",
  "menu.config.jd-feedback-types": "ប្រភេទមតិយោបល់ការងារ",
  "menu.config.job-groups": "ការកំណត់ក្រុមការងារ",
  "menu.config.job-positions": "តួនាទី",
  "menu.config.job-relations": "ការកំណត់ការងារពាក់ព័ន្ធ",
  "menu.config.locations": "ទីតាំង",
  "menu.config.visitor-contact-limit": "កំណត់ការទាក់ទងភ្ញៀវ",
  "menu.content": "មាតិកា",
  "menu.content.content-articles": "អត្ថបទ",
  "menu.content.content-media-partners": "ដៃគូមេឌៀ",
  "menu.facebook": "Facebook Matrix",
  "menu.facebook.facebook-entities": "ការកំណត់ប្រភពទិន្នន័យ",
  "menu.feedback": "មតិកែលម្អ",
  "menu.feedback.account-appeals-list": "បញ្ជីបណ្តឹងឧទ្ធរណ៍គណនី",
  "menu.feedback.feedback-list": "បញ្ជីមតិ",
  "menu.feedback.im-presets": "ឃ្លាប្រើញឹកញាប់ IM",
  "menu.feedback.jd-feedback-records-list": "កំណត់ត្រាមតិយោបល់ការងារ",
  "menu.feedback.job-complaints-list": "បញ្ជីបរិហារ",
  "menu.feedback.job-taxonomy-search-feedbacks": "មតិស្វែងរកការងារ",
  "menu.feedback.match-feedback": "មតិយោបល់ភាពសមស្រប IM",
  "menu.feedback.resume-complaints-list": "បញ្ជីបរិហារប្រវត្តិរូប",
  "menu.home": "ទំព័រដើម",
  "menu.job-seekers": "អ្នកស្វែងរកការងារ",
  "menu.job-seekers.job-seekers-job-intention-detail": "ព័ត៌មានចំណង់ចិត្ត",
  "menu.job-seekers.job-seekers-job-intentions": "ចំណង់ចិត្តការងារ",
  "menu.job-seekers.job-seekers-resume-detail": "ព័ត៌មានប្រវត្តិរូប",
  "menu.job-seekers.job-seekers-resume-source-files": "ពិនិត្យឯកសារប្រវត្តិរូប",
  "menu.job-seekers.job-seekers-resumes": "ប្រវត្តិរូប",
  "menu.job-seekers.job-seekers-user-detail": "ព័ត៌មានអ្នកប្រើ",
  "menu.job-seekers.job-seekers-users": "អ្នកប្រើ",
  "menu.jobs": "ការងារ",
  "menu.jobs.jobs-blacklist": "បញ្ជីខ្មៅការងារ",
  "menu.jobs.jobs-generation": "បង្កើត",
  "menu.jobs.jobs-generation-dashboard": "ផ្ទាំងទិន្នន័យការងារ",
  "menu.jobs.jobs-list": "បញ្ជីការងារ",
  "menu.jobs.jobs-review-records": "កំណត់ត្រាពិនិត្យ",
  "menu.login": "ចូល",
  "menu.staff": "បុគ្គលិក",
  "menu.staff.staff-detail": "ព័ត៌មានបុគ្គលិក",
  "menu.staff.staff-list": "បញ្ជីបុគ្គលិក",
  "menu.staff.staff-operation-logs": "កំណត់ត្រាប្រតិបត្តិការ",
  "menu.staff.staff-roles-permissions": "តួនាទី និងសិទ្ធិ",
  "menu.telegram": "Telegram",
  "menu.telegram.telegram-accounts": "គណនី",
  "menu.telegram.telegram-dashboard": "Dashboard",
  "menu.telegram.telegram-entities": "អង្គភាព",
  "menu.test": "តេស្ត",
  "menu.test.google-map": "តេស្តផែនទី Google",
  "menu.tools": "ឧបករណ៍ប្រតិបត្តិការ",
  "menu.tools.bot-activation-push": "ការជំរុញតាម Bot",
  "menu.tools.facebook-reauth-push": "សាកល្បងការជូនដំណឹង Facebook",
  "menu.tools.home-marquee-banners": "បដារមូរទំព័រដើម",
  "menu.tools.home-shortcuts": "ផ្លូវកាត់ទំព័រដើម",
  "menu.tools.marketing-push": "ការផ្ញើទីផ្សារ",
  "menu.tools.mobile-push": "សាកល្បងការជូនដំណឹង",
  "menu.tools.telegram-push": "សាកល្បងសាររំលឹក Bot",
  "menu.welcome": "សូមស្វាគមន៍",
  "navBar.lang": "ភាសា",
  "匹配反馈.ignored": "បានរំលង",
  "匹配反馈.pending": "រង់ចាំ",
  "匹配反馈.processed": "បានដំណើរការ",
  "匹配反馈.会话": "ការសន្ទនា",
  "匹配反馈.保存": "រក្សាទុក",
  "匹配反馈.候选人": "បេក្ខជន",
  "匹配反馈.允许补充说明": "អនុញ្ញាតព័ត៌មានបន្ថែម",
  "匹配反馈.原因": "មូលហេតុ",
  "匹配反馈.原因配置": "កំណត់មូលហេតុ",
  "匹配反馈.发起人": "អ្នកដាក់ស្នើ",
  "匹配反馈.否": "ទេ",
  "匹配反馈.启用": "បើក",
  "匹配反馈.处理状态": "ស្ថានភាពដំណើរការ",
  "匹配反馈.岗位": "ការងារ",
  "匹配反馈.已保存": "បានរក្សាទុក",
  "匹配反馈.已取消": "បានបោះបង់",
  "匹配反馈.招聘者": "អ្នកជ្រើសរើសបុគ្គលិក",
  "匹配反馈.排序": "លំដាប់",
  "匹配反馈.操作": "សកម្មភាព",
  "匹配反馈.新增": "បន្ថែម",
  "匹配反馈.时间": "ពេលវេលា",
  "匹配反馈.是": "បាទ/ចាស",
  "匹配反馈.标题": "មតិយោបល់ភាពសមស្រប IM",
  "匹配反馈.求职者": "អ្នកស្វែងរកការងារ",
  "匹配反馈.生效": "មានប្រសិទ្ធភាព",
  "匹配反馈.编码": "កូដ",
  "匹配反馈.编辑": "កែប្រែ",
  "匹配反馈.补充说明": "ព័ត៌មានបន្ថែម",
  "匹配反馈.记录": "កំណត់ត្រា",
  "匹配反馈.详情": "ព័ត៌មានលម្អិត",
  "匹配反馈.说明限制": "ជម្រើសព័ត៌មានបន្ថែមមួយក្នុងតួនាទីនីមួយៗ អតិបរមា 500 តួអក្សរ។ ការបិទរក្សាប្រវត្តិ។",
  "匹配反馈.身份": "តួនាទី",
  "匹配反馈.运营备注": "កំណត់ចំណាំប្រតិបត្តិករ",
  "布局.用户.帮助": "ជំនួយ",
  "布局.用户.条款": "លក្ខខណ្ឌ",
  "布局.用户.隐私": "ភាពឯកជន",
  "布局.页脚.版权": "2026 dodojob ប្រព័ន្ធគ្រប់គ្រងប្រតិបត្តិការ",
  "常用语.availability": "ពេលទំនាក់ទំនង",
  "常用语.decline": "បដិសេធដោយសុភាព",
  "常用语.first_contact": "ទំនាក់ទំនងដំបូង",
  "常用语.follow_up": "តាមដានបន្ត",
  "常用语.interview": "ការសម្ភាសន៍",
  "常用语.resume": "ប្រវត្តិរូប",
  "常用语.保存发布": "រក្សាទុកនិងផ្សព្វផ្សាយ",
  "常用语.内容": "ខ្លឹមសារ",
  "常用语.场景": "ស្ថានភាព",
  "常用语.标题": "ឃ្លាប្រើញឹកញាប់ IM",
  "常用语.长度限制": "អតិបរមា 200 តួអក្សរ",
  "应用.PWA.刷新": "ធ្វើឱ្យស្រស់",
  "应用.PWA.刷新提示": "ចុចធ្វើឱ្យស្រស់ ឬផ្ទុកឡើងវិញ",
  "应用.PWA.有新内容": "មានមាតិកាថ្មី",
  "应用.PWA.离线": "អ្នកកំពុង offline",
  "组件.地区与字典.一级": "កម្រិត ១",
  "组件.地区与字典.三级": "កម្រិត ៣",
  "组件.地区与字典.二级": "កម្រិត ២",
  "组件.地区与字典.地区不存在显示原始code": "គ្មានតំបន់ code: {code}",
  "组件.地区与字典.字典项不存在显示原始id": "គ្មានធាតុ id: {id}",
  "组件.地区与字典.当前": "(បច្ចុប្បន្ន)",
  "组件.地区与字典.暂无多语言": "គ្មានពាក្យបក",
  "组件.地区与字典.第N级": "កម្រិត {n}",
  "组件.地址.关闭": "បិទ",
  "组件.地址.加载地图中": "កំពុងផ្ទុកផែនទី...",
  "组件.地址.在地图中查看地址": "មើលអាសយដ្ឋានលើផែនទី",
  "组件.地址.在地图中编辑地址": "កែអាសយដ្ឋានលើផែនទី",
  "组件.地址.在地图中选择地址": "ជ្រើសរើសអាសយដ្ឋានលើផែនទី",
  "组件.地址.地区": "តំបន់",
  "组件.地址.地图显示": "ផែនទី",
  "组件.地址.地址预览": "មើលអាសយដ្ឋាន",
  "组件.地址.地点已选择": "បានជ្រើសរើសទីតាំង",
  "组件.地址.地点选择": "ទីតាំង",
  "组件.地址.当前地址": "អាសយដ្ឋានបច្ចុប្បន្ន៖ ",
  "组件.地址.搜索地址": "ស្វែងរកអាសយដ្ឋាន",
  "组件.地址.未找到地址": "រកមិនឃើញអាសយដ្ឋានដែលផ្គូផ្គង",
  "组件.地址.未配置GoogleMapsAPIKey": "មិនបានកំណត់ Google Maps API Key។ កំណត់ GOOGLE_MAPS_API_KEY ក្នុង env។",
  "组件.地址.标准地址": "អាសយដ្ឋានស្តង់ដារ៖ ",
  "组件.地址.生成地图图片": "បង្កើតរូបផែនទី",
  "组件.地址.详细地址": "អាសយដ្ឋានលម្អិត",
  "组件.地址.语言": "ភាសា",
  "组件.地址.请先选择地点": "ជ្រើសរើសទីតាំងមុន",
  "组件.地址.请输入地点名称或地址": "បញ្ចូលឈ្មោះទីតាំង ឬអាសយដ្ឋាន",
  "组件.地址.请输入详细地址如3楼301室": "ឧ. បន្ទប់ 301 ជាន់ 3",
  "组件.地址.预览图生成中": "រូបមើលផែនទីកំពុងផ្ទុកឡើង។ សូមដាក់ស្នើបន្តិចទៀត។",
  "组件.地址.预览图生成失败": "បង្កើតរូបមើលផែនទីមិនបាន។ សូមជ្រើសរើសទីតាំងម្ដងទៀត ហើយសាកល្បងម្តងទៀត។",
  "组件.地址.预览图生成成功": "បានបង្កើតរូបផែនទី",
  "组件.标签选择.全部": "ទាំងអស់",
  "组件.标签选择.展开": "ពង្រីក",
  "组件.标签选择.收起": "បិទ",
  "组件.顶栏.使用文档": "ឯកសារ",
  "组件.顶栏.站内搜索": "ស្វែងរក",
  "组件.顶栏.通知": "ការជូនដំណឹង",
  "菜单.Facebook矩阵": "Facebook Matrix",
  "菜单.Facebook矩阵.数据源配置": "ការកំណត់ប្រភពទិន្នន័យ",
  "菜单.Telegram矩阵": "Telegram",
  "菜单.Telegram矩阵.Dashboard": "Dashboard",
  "菜单.Telegram矩阵.会话管理": "អង្គភាព",
  "菜单.Telegram矩阵.账号管理": "គណនី",
  "菜单.个人页": "គណនី",
  "菜单.个人页.个人设置": "ការកំណត់",
  "菜单.企业管理": "ក្រុមហ៊ុន",
  "菜单.企业管理.企业管理": "បញ្ជីក្រុមហ៊ុន",
  "菜单.企业管理.配置管理": "ការកំណត់",
  "菜单.内容管理": "មាតិកា",
  "菜单.内容管理.合作媒体": "ដៃគូមេឌៀ",
  "菜单.内容管理.资讯发布": "អត្ថបទ",
  "菜单.反馈与投诉": "មតិកែលម្អ",
  "菜单.反馈与投诉.岗位反馈记录": "កំណត់ត្រាមតិយោបល់ការងារ",
  "菜单.反馈与投诉.岗位投诉列表": "បញ្ជីបរិហារ",
  "菜单.反馈与投诉.工种搜索反馈": "មតិស្វែងរកការងារ",
  "菜单.反馈与投诉.意见反馈列表": "បញ្ជីមតិ",
  "菜单.反馈与投诉.简历投诉列表": "បញ្ជីបរិហារប្រវត្តិរូប",
  "菜单.反馈与投诉.账号申诉列表": "បញ្ជីបណ្តឹងឧទ្ធរណ៍គណនី",
  "菜单.员工管理": "បុគ្គលិក",
  "菜单.员工管理.员工列表": "បញ្ជីបុគ្គលិក",
  "菜单.员工管理.员工详情": "ព័ត៌មានបុគ្គលិក",
  "菜单.员工管理.操作记录": "កំណត់ត្រាប្រតិបត្តិការ",
  "菜单.员工管理.角色和权限": "តួនាទី និងសិទ្ធិ",
  "菜单.商业化管理": "ពាណិជ្ជកម្ម",
  "菜单.商业化管理.商品管理": "ផលិតផល",
  "菜单.商业化管理.权益配置": "ការកំណត់អត្ថប្រយោជន៍",
  "菜单.商业化管理.订单管理": "ការបញ្ជាទិញ",
  "菜单.商业化管理.页面配置": "ទំព័រទិញ",
  "菜单.岗位管理": "ការងារ",
  "菜单.岗位管理.审核记录": "កំណត់ត្រាពិនិត្យ",
  "菜单.岗位管理.岗位生成": "បង្កើត",
  "菜单.岗位管理.岗位生成数据看板": "ផ្ទាំងទិន្នន័យការងារ",
  "菜单.岗位管理.岗位管理": "បញ្ជីការងារ",
  "菜单.岗位管理.岗位黑名单": "បញ្ជីខ្មៅការងារ",
  "菜单.推广渠道管理": "ឆាណែលផ្សព្វផ្សាយ",
  "菜单.欢迎": "សូមស្វាគមន៍",
  "菜单.求职用户": "អ្នកស្វែងរកការងារ",
  "菜单.求职用户.求职意向": "ចំណង់ចិត្តការងារ",
  "菜单.求职用户.求职意向详情": "ព័ត៌មានចំណង់ចិត្ត",
  "菜单.求职用户.用户管理": "អ្នកប្រើ",
  "菜单.求职用户.用户详情": "ព័ត៌មានអ្នកប្រើ",
  "菜单.求职用户.简历管理": "ប្រវត្តិរូប",
  "菜单.求职用户.简历详情": "ព័ត៌មានប្រវត្តិរូប",
  "菜单.求职用户.简历附件审核": "ពិនិត្យឯកសារប្រវត្តិរូប",
  "菜单.测试页面": "តេស្ត",
  "菜单.测试页面.Google地图测试": "តេស្តផែនទី Google",
  "菜单.登录": "ចូល",
  "菜单.运营工具": "ឧបករណ៍ប្រតិបត្តិការ",
  "菜单.运营工具.Bot促活推送": "ការជំរុញតាម Bot",
  "菜单.运营工具.Bot促活测试": "សាកល្បងសាររំលឹក Bot",
  "菜单.运营工具.Facebook重新授权推送测试": "សាកល្បងការជូនដំណឹង Facebook",
  "菜单.运营工具.移动推送测试": "សាកល្បងការជូនដំណឹង",
  "菜单.运营工具.营销推送": "ការផ្ញើទីផ្សារ",
  "菜单.运营工具.首页跑马灯": "បដារមូរទំព័រដើម",
  "菜单.运营工具.首页金刚位": "ផ្លូវកាត់ទំព័រដើម",
  "菜单.退出登录": "ចាកចេញ",
  "菜单.配置管理": "ការកំណត់",
  "菜单.配置管理.关联工种配置": "ការកំណត់ការងារពាក់ព័ន្ធ",
  "菜单.配置管理.地区管理": "ទីតាំង",
  "菜单.配置管理.岗位分组配置": "ការកំណត់ក្រុមការងារ",
  "菜单.配置管理.岗位反馈类型": "ប្រភេទមតិយោបល់ការងារ",
  "菜单.配置管理.岗位投诉类型": "ប្រភេទបរិហារ",
  "菜单.配置管理.岗位标签": "តួនាទី",
  "菜单.配置管理.游客联系限制": "កំណត់ការទាក់ទងភ្ញៀវ",
  "菜单.配置管理.热搜词配置": "ពាក្យស្វែងរកពេញនិយម",
  "菜单.配置管理.热门分组配置": "ការកំណត់ក្រុមពេញនិយម",
  "菜单.配置管理.福利与保障标签": "ឃ្លាំងស្លាក",
  "菜单.配置管理.销售联系方式": "ទំនាក់ទំនងផ្នែកលក់",
  "菜单.首页": "ទំព័រដើម",
  "营销推送.Bot媒体": "មេឌា Bot",
  "营销推送.Bot按钮": "ប៊ូតុង Bot",
  "营销推送.Bot按钮文字": "អត្ថបទប៊ូតុង",
  "营销推送.Bot按钮类型": "ប្រភេទប៊ូតុង",
  "营销推送.Bot按钮类型.app_page": "បើកទំព័រ App",
  "营销推送.Bot按钮类型.channel": "ឆានែល Telegram",
  "营销推送.Bot按钮类型.mini_app": "Telegram Mini App",
  "营销推送.Bot按钮说明": "អាចបន្ថែមបានរហូតដល់ 3 ប៊ូតុង មួយក្នុងមួយជួរ។ អត្ថបទប៊ូតុងប្តូរតាមភាសា។",
  "营销推送.Bot按钮链接": "តំណ Telegram",
  "营销推送.Bot按钮页面": "ទំព័រ App",
  "营销推送.Bot正文": "សារ Bot",
  "营销推送.Bot消息类型": "ប្រភេទសារ Bot",
  "营销推送.Bot消息类型.image": "រូបភាព និងអត្ថបទ",
  "营销推送.Bot消息类型.text": "អត្ថបទ",
  "营销推送.Bot消息类型.video": "វីដេអូ និងអត្ថបទ",
  "营销推送.broadcast": "ទីផ្សារទូទៅ",
  "营销推送.generic_jobs": "ការងារសម្រាប់អ្នកមិនមានទិន្នន័យចំណូលចិត្ត",
  "营销推送.location_jobs": "ការងារតាមទីតាំង",
  "营销推送.matched_jobs": "ការងារតាមតួនាទី និងទីតាំង",
  "营销推送.position_jobs": "ការងារតាមតួនាទី",
  "营销推送.resume_incomplete": "រំលឹកបំពេញប្រវត្តិរូប",
  "营销推送.resume_missing": "រំលឹកបង្កើតប្រវត្តិរូប",
  "营销推送.下次发送": "ពេលផ្ញើបន្ទាប់",
  "营销推送.人群": "ក្រុមគោលដៅ",
  "营销推送.仅限HTTPS": "បញ្ចូលតំណ HTTPS ពេញលេញ",
  "营销推送.保存为暂停": "រក្សាទុកដោយផ្អាក",
  "营销推送.保存生效": "រក្សាទុកការកែប្រែ",
  "营销推送.全部用户": "អ្នកប្រើ App ទាំងអស់ (បានចូល និងភ្ញៀវ)",
  "营销推送.全部用户说明": "ផ្ញើទៅអ្នកប្រើដែលបានចូល និងភ្ញៀវដែលមានឧបករណ៍ជូនដំណឹងសកម្ម។ មើលជាមុន និងសាកល្បងមុនបើក។",
  "营销推送.删除": "លុប",
  "营销推送.刷新": "ផ្ទុកឡើងវិញ",
  "营销推送.加载岗位失败": "មិនអាចផ្ទុកការងារបាន",
  "营销推送.区域": "ទីតាំងគំរូ",
  "营销推送.历史文案未保存": "កំណត់ត្រាចាស់មិនបានរក្សាទុកខ្លឹមសារសារ",
  "营销推送.历史记录": "កំណត់ត្រាចាស់",
  "营销推送.历史记录说明": "កំណត់ត្រាចាស់មិនមានស្លាកបរិស្ថានទេ ហើយបង្ហាញតែក្នុងបរិស្ថានផលិតកម្ម។",
  "营销推送.参数.apply_job_id": "ID ការងារដាក់ពាក្យ (មិនចាំបាច់)",
  "营销推送.参数.benefit_tags": "កូដអត្ថប្រយោជន៍ (បំបែកដោយសញ្ញាក្បៀស)",
  "营销推送.参数.category_id": "កូដប្រភេទការងារ",
  "营销推送.参数.company_id": "ID ក្រុមហ៊ុន",
  "营销推送.参数.job_category_code": "កូដតួនាទី (មិនចាំបាច់)",
  "营销推送.参数.job_id": "ID ការងារ",
  "营销推送.参数.job_position_tags": "កូដតួនាទី (បំបែកដោយសញ្ញាក្បៀស)",
  "营销推送.参数.keyword": "ពាក្យស្វែងរក",
  "营销推送.参数.locations": "កូដទីតាំង (បំបែកដោយសញ្ញាក្បៀស)",
  "营销推送.参数.source_job_id": "ID ការងារប្រភព (មិនចាំបាច់)",
  "营销推送.参数.title": "ចំណងជើងទំព័រ (មិនចាំបាច់)",
  "营销推送.参数.url": "តំណគេហទំព័រ",
  "营销推送.发送失败": "បរាជ័យ",
  "营销推送.发送成功": "បានផ្ញើ",
  "营销推送.发送日期": "កាលបរិច្ឆេទផ្ញើ",
  "营销推送.发送时间": "ពេលផ្ញើ (ប៉េកាំង)",
  "营销推送.发送测试": "ផ្ញើទៅអ្នកប្រើសាកល្បង",
  "营销推送.发送类型": "ប្រភេទការផ្ញើ",
  "营销推送.发送结果": "លទ្ធផល",
  "营销推送.发送记录": "ប្រវត្តិការផ្ញើ",
  "营销推送.发送记录说明": "កំណត់ត្រានីមួយៗបង្ហាញការផ្ញើទៅឧបករណ៍មួយ ហើយការព្យាយាមឡើងវិញត្រូវបានបញ្ចូលគ្នា។ បានផ្ញើមានន័យថាសេវាជូនដំណឹងបានទទួល មិនមែនអ្នកប្រើបានមើលទេ។",
  "营销推送.变量说明": "អថេរ៖ '{count}', '{position}', '{location}', '{salary}'។ ប្រើតែទិន្នន័យដែលក្រុមនេះមាន។ រក្សាគំរូមួយមិនប្រើប្រាក់ខែក្នុងភាសានីមួយៗ។ គំរូប្តូរតាមថ្ងៃ។",
  "营销推送.后台试发": "ការផ្ញើសាកល្បង",
  "营销推送.启用": "បើក",
  "营销推送.固定文案说明": "ការផ្ញើទាំងអស់ប្រើសារថេរ មិនប្រើតួនាទី ទីតាំង ឬប្រាក់ខែផ្ទាល់ខ្លួន។",
  "营销推送.处理中": "កំពុងដំណើរការ",
  "营销推送.失败原因": "មូលហេតុបរាជ័យ",
  "营销推送.定时发送": "ការផ្ញើតាមកាលវិភាគ",
  "营销推送.尝试次数": "ចំនួនសាកល្បង",
  "营销推送.岗位数量": "ចំនួនការងារ",
  "营销推送.工种": "តួនាទីគំរូ",
  "营销推送.已保存": "បានរក្សាទុក។ ការកែប្រែនឹងមានប្រសិទ្ធភាពដោយស្វ័យប្រវត្តិ។",
  "营销推送.已跳过": "បានរំលង",
  "营销推送.当前绑定": "គណនីឧបករណ៍បច្ចុប្បន្ន",
  "营销推送.当前绑定说明": "កំណត់ត្រាចាស់មិនបានរក្សាទុកគណនីពេលផ្ញើទេ។ នេះជាគណនីឧបករណ៍បច្ចុប្បន្ន ដែលអាចខុសពីអ្នកទទួលដើម។",
  "营销推送.总开关关闭": "ការផ្ញើទីផ្សារស្វ័យប្រវត្តិត្រូវបានបិទ។ អាចរក្សាទុក និងសាកល្បង ប៉ុន្តែសារកំណត់ពេលមិនផ្ញើ។",
  "营销推送.执行星期": "ថ្ងៃផ្ញើ",
  "营销推送.按原策略跳转": "ប្រើគោលដៅដើម",
  "营销推送.按现有策略": "តាមច្បាប់ក្រុមគោលដៅបច្ចុប្បន្ន",
  "营销推送.接收用户": "អ្នកទទួល",
  "营销推送.搜索岗位": "ស្វែងរកឈ្មោះ ឬលេខការងារ",
  "营销推送.操作": "សកម្មភាព",
  "营销推送.操作失败": "ប្រតិបត្តិការបរាជ័យ។ ពិនិត្យទិន្នន័យ ហើយផ្ទុកឡើងវិញមុនសាកល្បងម្តងទៀត។",
  "营销推送.新增说明": "អាចមើលជាមុន និងផ្ញើទៅគណនីសាកល្បងមុនពេលរក្សាទុក។ ផែនការថ្មីត្រូវបានរក្សាទុកដោយផ្អាក។ បើកក្នុងបញ្ជី ដើម្បីផ្ញើតាមកាលវិភាគ។",
  "营销推送.时间范围": "ជ្រើសរើស 08:00–20:59",
  "营销推送.时间说明": "ម៉ោងប៉េកាំង 08:00–20:59។ ការកែប្រែមានប្រសិទ្ធភាពក្នុង 30 វិនាទី។ សារមួយប្រភេទផ្ញើអតិបរមាម្តងក្នុងមួយថ្ងៃ។",
  "营销推送.星期0": "ចន្ទ",
  "营销推送.星期1": "អង្គារ",
  "营销推送.星期2": "ពុធ",
  "营销推送.星期3": "ព្រហស្បតិ៍",
  "营销推送.星期4": "សុក្រ",
  "营销推送.星期5": "សៅរ៍",
  "营销推送.星期6": "អាទិត្យ",
  "营销推送.标题": "ចំណងជើង",
  "营销推送.模板": "គំរូ",
  "营销推送.模板序号": "លេខគំរូ",
  "营销推送.模板数量": "ចំនួនគំរូ",
  "营销推送.正文": "ខ្លឹមសារ",
  "营销推送.测试账号": "ID អ្នកប្រើសាកល្បង",
  "营销推送.添加Bot按钮": "បន្ថែមប៊ូតុង Bot",
  "营销推送.添加模板": "បន្ថែមគំរូ",
  "营销推送.添加营销推送": "បន្ថែមការជូនដំណឹងទីផ្សារ",
  "营销推送.游客": "ភ្ញៀវ",
  "营销推送.登录用户": "អ្នកប្រើកម្មវិធី",
  "营销推送.策略配置": "ការកំណត់ផែនការ",
  "营销推送.编辑": "កែប្រែ",
  "营销推送.联系Bot说明": "ពេលចុច វាបើក Bot សម្រាប់ទាក់ទងការងារ/ប្រវត្តិរូប មិនមែន Bot ចូលប្រព័ន្ធទេ។ ខ្លឹមសារថ្មីបង្កើតតំណថ្មី។",
  "营销推送.落地页.company_homepage": "ទំព័រក្រុមហ៊ុន",
  "营销推送.落地页.external_web": "កម្មវិធីរុករកខាងក្រៅ",
  "营销推送.落地页.internal_web": "ទំព័របណ្ដាញក្នុង App",
  "营销推送.落地页.job_category": "ប្រភេទការងារ",
  "营销推送.落地页.job_detail": "ព័ត៌មានលម្អិតការងារ",
  "营销推送.落地页.job_search": "ស្វែងរកការងារ",
  "营销推送.落地页.jobs_home": "ទំព័រដើមការងារ",
  "营销推送.落地页.profile_home": "ប្រវត្តិរូបរបស់ខ្ញុំ",
  "营销推送.落地页.resume_card_form": "បំពេញប្រវត្តិរូប",
  "营销推送.落地页.resume_manage": "គ្រប់គ្រងប្រវត្តិរូប",
  "营销推送.落地页.talent_pool_home": "បញ្ជីបេក្ខជន",
  "营销推送.落地页.telegram_contact_bot": "ការផ្ញើសារតាម Bot",
  "营销推送.薪资": "ប្រាក់ខែប្រចាំខែ (USD)",
  "营销推送.计划": "ផែនការ",
  "营销推送.计划列表": "ផែនការផ្ញើ",
  "营销推送.计划名称": "ឈ្មោះផែនការ",
  "营销推送.记录ID": "លេខសម្គាល់កំណត់ត្រា",
  "营销推送.设备ID": "លេខសម្គាល់ឧបករណ៍",
  "营销推送.设备平台": "ប្រព័ន្ធឧបករណ៍",
  "营销推送.试发结果": "ឧបករណ៍៖ {total} ទទួលយក៖ {success} បរាជ័យ៖ {failed}។ សូមពិនិត្យសារលើឧបករណ៍សាកល្បង។",
  "营销推送.语言": "ភាសា",
  "营销推送.请上传Bot媒体": "សូមបញ្ចូលរូបភាព ឬវីដេអូ",
  "营销推送.跳转目标": "ទំព័រគោលដៅ",
  "营销推送.跳转说明": "ចុចការជូនដំណឹងដើម្បីបើកទំព័រនេះ។ បំពេញប៉ារ៉ាម៉ែត្រឡើងវិញបន្ទាប់ពីប្តូរគោលដៅ។",
  "营销推送.身份未知": "មិនមានព័ត៌មានអត្តសញ្ញាណ",
  "营销推送.选择工种": "ជ្រើសរើសប្រភេទការងារ",
  "营销推送.页面标题": "ការជូនដំណឹងទីផ្សារ App",
  "营销推送.页面说明": "កំណត់គំរូ ពេលវេលា និងទំព័រគោលដៅនៃការជូនដំណឹង App។",
  "营销推送.预览": "មើលជាមុន",
  "营销推送.预览与试发": "មើលជាមុន និងសាកល្បង",
  "营销推送.默认跳转说明": "ការណែនាំការងារបើកទំព័រការងារតាមតួនាទីអ្នកប្រើ។ ការរំលឹកប្រវត្តិរូបបើកទម្រង់ប្រវត្តិរូប។ ការមើលជាមុនបង្ហាញទំព័រដើម។",
  "设置.基本信息.昵称": "ឈ្មោះហៅ",
  "设置.菜单.基本设置": "មូលដ្ឋាន",
  "设置抽屉.主题色": "ពណ៌",
  "设置抽屉.整体风格": "រចនាប័ទ្ម",
  "通用.上传中": "កំពុងផ្ទុកឡើង...",
  "通用.上传失败": "ផ្ទុកឡើងបរាជ័យ",
  "通用.上传成功": "ផ្ទុកឡើងជោគជ័យ",
  "通用.中文": "ចិន",
  "通用.保存": "រក្សាទុក",
  "通用.保存失败": "រក្សាទុកបរាជ័យ",
  "通用.保存失败重试": "រក្សាទុកបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "通用.保存成功": "រក្សាទុកជោគជ័យ",
  "通用.停用": "អសកម្ម",
  "通用.创建失败": "បង្កើតបរាជ័យ",
  "通用.创建失败重试": "បង្កើតបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "通用.创建成功": "បង្កើតជោគជ័យ",
  "通用.删除": "លុប",
  "通用.删除失败": "លុបបរាជ័យ",
  "通用.删除失败重试": "លុបបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "通用.删除成功": "លុបជោគជ័យ",
  "通用.加载中": "កំពុងផ្ទុក...",
  "通用.取消": "បោះបង់",
  "通用.同步失败": "ធ្វើឱ្យរួមបញ្ចូលគ្នាបរាជ័យ",
  "通用.同步失败重试": "ធ្វើឱ្យរួមបញ្ចូលគ្នាបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "通用.同步成功": "ធ្វើឱ្យរួមបញ្ចូលគ្នាជោគជ័យ",
  "通用.名称": "ឈ្មោះ",
  "通用.名称不能为空": "ឈ្មោះត្រូវតែបំពេញ",
  "通用.启用": "សកម្ម",
  "通用.备注": "កំណត់សម្គាល់",
  "通用.导出": "នាំចេញ",
  "通用.导出失败": "នាំចេញបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "通用.导出成功": "នាំចេញជោគជ័យ",
  "通用.展开": "ពង្រីក",
  "通用.批量删除": "លុបជាក្រុម",
  "通用.操作": "សកម្មភាព",
  "通用.收起": "បិទ",
  "通用.新建": "ថ្មី",
  "通用.暂无可导出数据": "គ្មានទិន្នន័យសម្រាប់នាំចេញ",
  "通用.更换图片": "ជំនួសរូបភាព",
  "通用.更新失败": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ",
  "通用.更新失败重试": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "通用.更新成功": "ធ្វើបច្ចុប្បន្នភាពជោគជ័យ",
  "通用.查询": "ស្វែងរក",
  "通用.添加失败": "បន្ថែមបរាជ័យ",
  "通用.添加失败重试": "បន្ថែមបរាជ័យ សូមព្យាយាមម្តងទៀត។",
  "通用.添加成功": "បន្ថែមជោគជ័យ",
  "通用.状态": "ស្ថានភាព",
  "通用.确定": "យល់ព្រម",
  "通用.禁用": "បិទ",
  "通用.系统": "ប្រព័ន្ធ",
  "通用.编辑": "កែសម្រួល",
  "通用.英文": "អង់គ្លេស",
  "通用.请输入": "សូមបញ្ចូល",
  "通用.请输入备注": "កំណត់សម្គាល់ (ជម្រើស)",
  "通用.请选择": "សូមជ្រើសរើស",
  "通用.选择图片": "ជ្រើសរើសរូបភាព",
  "通用.重置": "កំណត់ឡើងវិញ",
  "通用.重置失败": "កំណត់ឡើងវិញបរាជ័យ",
  "通用.重置成功": "កំណត់ឡើងវិញជោគជ័យ",
  "通用.重试": "ព្យាយាមម្តងទៀត",
  "通用.高棉语": "ខ្មែរ",
  "错误.登录已过期": "ចូលផុតកំណត់ សូមចូលម្តងទៀត",
  "错误.网络错误": "កំហុសបណ្តាញ សូមពិនិត្យ",
  "错误.请求失败": "ស្នើបរាជ័យ",
  "错误.请求错误": "កំហុសស្នើ សូមព្យាយាមម្តងទៀត",
  "页面.403.无权限": "អ្នកគ្មានសិទ្ធិចូលទំព័រនេះទេ។",
  "页面.403.返回首页": "ត្រលប់ទៅផ្ទះ",
  "页面.404.抱歉": "សូមអភ័យទោស ទំព័រនេះមិនមានទេ។",
  "页面.404.返回首页": "ត្រលប់ទៅផ្ទះ",
  "页面.Bot测试.ID格式": "បញ្ចូលលេខសម្គាល់ Telegram ត្រឹមត្រូវ",
  "页面.Bot测试.TGID": "លេខសម្គាល់អ្នកប្រើ Telegram",
  "页面.Bot测试.兜底": "ឆានែល · គ្មានប្រវត្តិរូប",
  "页面.Bot测试.分组": "ក្រុមអត្ថបទ",
  "页面.Bot测试.分组.A": "A · មានទីតាំង",
  "页面.Bot测试.分组.auto": "ស្វ័យប្រវត្តិ",
  "页面.Bot测试.分组.B": "B · គ្មានទីតាំង",
  "页面.Bot测试.参数": "ការកំណត់សាកល្បង",
  "页面.Bot测试.发送": "ផ្ញើសាកល្បង",
  "页面.Bot测试.发送未知": "មិនទាន់បញ្ជាក់ការផ្ញើ។ សូមពិនិត្យ Telegram មុនផ្ញើម្ដងទៀត។",
  "页面.Bot测试.场景": "ប្រភេទសារ",
  "页面.Bot测试.场景.generic_jobs": "App · ការងារទូទៅ",
  "页面.Bot测试.场景.im": "រំលឹកសារ IM មិនទាន់អាន",
  "页面.Bot测试.场景.jd_contact": "កាតទំនាក់ទំនងការងារ (គំរូ)",
  "页面.Bot测试.场景.location_jobs": "App · តំបន់",
  "页面.Bot测试.场景.matched_jobs": "App · មុខរបរ និងតំបន់",
  "页面.Bot测试.场景.onboarding": "សារស្វាគមន៍",
  "页面.Bot测试.场景.position_jobs": "App · មុខរបរ",
  "页面.Bot测试.场景.reply": "ឆ្លើយតបសារអ្នកប្រើ",
  "页面.Bot测试.场景.resume_contact": "កាតទំនាក់ទំនងប្រវត្តិរូប (គំរូ)",
  "页面.Bot测试.填写工种": "បញ្ចូលប្រភេទការងារ",
  "页面.Bot测试.填写接收人": "បញ្ចូលលេខសម្គាល់អ្នកទទួល",
  "页面.Bot测试.就绪": "រួចរាល់",
  "页面.Bot测试.岗位": "ឆានែល · មានប្រវត្តិរូប",
  "页面.Bot测试.岗位数": "ចំនួនការងារសាកល្បង",
  "页面.Bot测试.工种": "ប្រភេទការងារ",
  "页面.Bot测试.工种编码": "លេខកូដមុខរបរ (ជាជម្រើស)",
  "页面.Bot测试.平台ID": "លេខសម្គាល់អ្នកប្រើ",
  "页面.Bot测试.接收人": "អ្នកទទួល",
  "页面.Bot测试.接收身份": "តួនាទីអ្នកទទួល",
  "页面.Bot测试.未就绪": "មិនទាន់រួចរាល់",
  "页面.Bot测试.标题": "សាកល្បងសាររំលឹក Bot",
  "页面.Bot测试.模式": "របៀបសាកល្បង",
  "页面.Bot测试.模拟": "ប្រើប៉ារ៉ាម៉ែត្រសាកល្បង",
  "页面.Bot测试.模拟地区": "ទីតាំងគំរូ",
  "页面.Bot测试.模拟姓名": "ឈ្មោះគំរូ",
  "页面.Bot测试.模拟描述": "លក្ខខណ្ឌ / ជំនាញ",
  "页面.Bot测试.模拟说明": "ផ្ញើសារពិតដោយប្រើប៉ារ៉ាម៉ែត្រសាកល្បង មិនប្រើកូតាពិត។ អ្នកទទួលត្រូវបានចាប់ផ្ដើម Bot នេះ។",
  "页面.Bot测试.求职者": "អ្នកស្វែងរកការងារ",
  "页面.Bot测试.状态.activation_disabled": "សាររំលឹកពិតមិនទាន់បើក។ អាចប្រើប៉ារ៉ាម៉ែត្រសាកល្បង។",
  "页面.Bot测试.状态.already_in_channel": "បានចូលឆានែលរួចហើយ",
  "页面.Bot测试.状态.ambiguous_user": "មានគណនីច្រើន សូមប្រើលេខសម្គាល់ Telegram",
  "页面.Bot测试.状态.app_url_missing": "មិនបានកំណត់តំណត្រឡប់ App",
  "页面.Bot测试.状态.bot_unavailable": "Bot មិនទាន់រួចរាល់",
  "页面.Bot测试.状态.channel_membership_unknown": "មិនអាចពិនិត្យសមាជិក។ សូមបន្ថែម Bot ជាអ្នកគ្រប់គ្រងឆានែល។",
  "页面.Bot测试.状态.channel_missing": "មិនទាន់កំណត់ឆានែលគោលដៅ",
  "页面.Bot测试.状态.duplicate": "បានដំណើរការសាកល្បងនេះរួច",
  "页面.Bot测试.状态.failed": "ការផ្ញើបរាជ័យ ឬមិនទាន់បញ្ជាក់។ ពិនិត្យ Telegram និងកំណត់ហេតុ។",
  "页面.Bot测试.状态.frequency_limited": "បានប្រើកូតាសាររំលឹកថ្ងៃនេះ",
  "页面.Bot测试.状态.insufficient_jobs": "ចំនួនការងារមិនគ្រប់សម្រាប់ផ្ញើ",
  "页面.Bot测试.状态.no_candidate": "មិនត្រូវគ្នា។ ពិនិត្យស្ថានភាពអ្នកស្វែងរកការងារ ប្រវត្តិរូប និងការងារថ្ងៃនេះ។",
  "页面.Bot测试.状态.rate_limited": "ផ្ញើញឹកញាប់ពេក សូមមើលជាមុនម្ដងទៀតបន្តិចទៀត",
  "页面.Bot测试.状态.ready": "អាចផ្ញើបាន",
  "页面.Bot测试.状态.recent_campaign": "បានទទួលសារពីយុទ្ធនាការផ្សេងថ្មីៗ",
  "页面.Bot测试.状态.sent": "បានផ្ញើទៅ Telegram",
  "页面.Bot测试.状态.tracking_missing": "មិនទាន់កំណត់តំណតាមដានការចុច",
  "页面.Bot测试.状态.unreachable": "អ្នកប្រើមិនទាន់ចាប់ផ្ដើម Bot នេះ ឬការសន្ទនាអសកម្ម",
  "页面.Bot测试.状态.unsubscribed": "បានបិទការរំលឹកការងារ",
  "页面.Bot测试.状态.user_not_found": "រកមិនឃើញអ្នកប្រើ Telegram ដែលបានភ្ជាប់",
  "页面.Bot测试.真实": "ប្រើលក្ខខណ្ឌពិត",
  "页面.Bot测试.真实说明": "ប្រើប្រវត្តិរូប និងការងារថ្ងៃនេះ។ ការផ្ញើប្រើកូតាសារថ្ងៃនេះ។",
  "页面.Bot测试.空预览": "ជ្រើសអ្នកទទួល ដើម្បីមើលសារ និងលក្ខខណ្ឌ",
  "页面.Bot测试.触发测试说明": "សាកល្បងតែគំរូសារ មិនបង្កើត IM ឬសិទ្ធិប្រវត្តិរូបពិត។ កាតប្រើទិន្នន័យគំរូ និងតំណទៅអ្នកទទួលសាកល្បង។",
  "页面.Bot测试.语言": "ភាសាសារ",
  "页面.Bot测试.请求失败": "មិនអាចផ្ទុកបាន សូមព្យាយាមម្ដងទៀត",
  "页面.Bot测试.连接": "ស្ថានភាព Bot",
  "页面.Bot测试.重试": "ព្យាយាមម្ដងទៀត",
  "页面.Bot测试.门槛": "ចំនួនការងារអប្បបរមា",
  "页面.Bot测试.雇主": "និយោជក",
  "页面.Bot测试.预览": "មើលសារជាមុន",
  "页面.Facebook推送测试.页面标题": "សាកល្បងការជូនដំណឹង Facebook",
  "页面.Facebook推送测试.页面说明": "សាកល្បងការអនុញ្ញាត Facebook ឡើងវិញតាមលេខសម្គាល់អ្នកប្រើ ដោយមិនកំណត់ Facebook App ID ហើយផ្ញើតែទៅឧបករណ៍សកម្មចុងក្រោយ។",
  "页面.Facebook矩阵.数据源配置.分类": "ប្រភេទ",
  "页面.Facebook矩阵.数据源配置.分类名称": "ឈ្មោះប្រភេទ",
  "页面.Facebook矩阵.数据源配置.分类名称占位": "ឧ. ក្រុមការងារ",
  "页面.Facebook矩阵.数据源配置.分类名称必填": "សូមបញ្ចូលឈ្មោះប្រភេទ",
  "页面.Facebook矩阵.数据源配置.创建时间": "បង្កើតនៅ",
  "页面.Facebook矩阵.数据源配置.名称": "ឈ្មោះ",
  "页面.Facebook矩阵.数据源配置.名称必填": "សូមបញ្ចូលឈ្មោះ",
  "页面.Facebook矩阵.数据源配置.名称说明": "ឈ្មោះគ្រប់គ្រង",
  "页面.Facebook矩阵.数据源配置.备注": "ការពិពណ៌នា",
  "页面.Facebook矩阵.数据源配置.备注占位": "ការពិពណ៌នាជម្រើស",
  "页面.Facebook矩阵.数据源配置.外部实体ID": "ID អង្គភាពខាងក្រៅ",
  "页面.Facebook矩阵.数据源配置.外部实体ID占位": "ជម្រើស ID ក្នុងសេវាខាងក្រៅ",
  "页面.Facebook矩阵.数据源配置.实体类型": "ប្រភេទអង្គភាព",
  "页面.Facebook矩阵.数据源配置.实体类型主页": "ទំព័រ",
  "页面.Facebook矩阵.数据源配置.实体类型帖子": "ប្រកាស",
  "页面.Facebook矩阵.数据源配置.实体类型群组": "ក្រុម",
  "页面.Facebook矩阵.数据源配置.实体类型频道": "ឆានែល",
  "页面.Facebook矩阵.数据源配置.实体链接": "ភ្ជាប់អង្គភាព",
  "页面.Facebook矩阵.数据源配置.实体链接必填": "សូមបញ្ចូល URL",
  "页面.Facebook矩阵.数据源配置.实体链接说明": "Facebook permalink",
  "页面.Facebook矩阵.数据源配置.成功删除N个": "លុបរួច {n}",
  "页面.Facebook矩阵.数据源配置.成功删除部分失败": "លុបរួច {ok} បរាជ័យ {fail}",
  "页面.Facebook矩阵.数据源配置.按分类查看": "ប្រភពទិន្នន័យតាមប្រភេទ",
  "页面.Facebook矩阵.数据源配置.按实体类型查看": "ប្រភពទិន្នន័យតាមប្រភេទអង្គភាព",
  "页面.Facebook矩阵.数据源配置.数据源数": "ប្រភពទិន្នន័យ",
  "页面.Facebook矩阵.数据源配置.新建分类": "ប្រភេទថ្មី",
  "页面.Facebook矩阵.数据源配置.新建数据源": "ប្រភពថ្មី",
  "页面.Facebook矩阵.数据源配置.更新时间": "ធ្វើបច្ចុប្បន្នភាពនៅ",
  "页面.Facebook矩阵.数据源配置.未分类": "មិនមានប្រភេទ",
  "页面.Facebook矩阵.数据源配置.标题": "ការកំណត់ប្រភព FB",
  "页面.Facebook矩阵.数据源配置.正在删除N个": "កំពុងលុប {n}...",
  "页面.Facebook矩阵.数据源配置.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.Facebook矩阵.数据源配置.正在添加": "កំពុងបន្ថែម...",
  "页面.Facebook矩阵.数据源配置.状态已拒绝": "បានបដិសេធ",
  "页面.Facebook矩阵.数据源配置.状态待审核": "រង់ចាំពិនិត្យ",
  "页面.Facebook矩阵.数据源配置.确定删除": "លុបប្រភពនេះ?",
  "页面.Facebook矩阵.数据源配置.确定删除分类": "លុបប្រភេទនេះ? ប្រភពទិន្នន័យនឹងក្លាយជាមិនមានប្រភេទ។",
  "页面.Facebook矩阵.数据源配置.管理分类": "គ្រប់គ្រងប្រភេទ",
  "页面.Facebook矩阵.数据源配置.编辑分类": "កែប្រភេទ",
  "页面.Facebook矩阵.数据源配置.编辑数据源": "កែប្រភព",
  "页面.Facebook矩阵.数据源配置.选择分类": "សូមជ្រើសរើសប្រភេទ",
  "页面.Telegram矩阵.ClientKey创建": "Client Key",
  "页面.Telegram矩阵.云端托管": "ឧបត្ថម្ភពពក",
  "页面.Telegram矩阵.创建方式": "វិធីសាងសង់",
  "页面.Telegram矩阵.客户端上报": "របាយការណ៍អតិថិជន",
  "页面.Telegram矩阵.扫码授权云端托管": "អនុញ្ញាត QR (ឧបត្ថម្ភពពក)",
  "页面.Telegram矩阵.新增授权账号": "បន្ថែមគណនីអនុញ្ញាត",
  "页面.Telegram矩阵.账号类型": "ប្រភេទគណនី",
  "页面.Telegram矩阵.通过ClientKey创建客户端上报": "បង្កើតដោយ Client Key (របាយការណ៍អតិថិជន)",
  "页面.企业.Logo": "ឡូហ្គោ",
  "页面.企业.Logo说明": "ឡូហ្គោក្រុមហ៊ុន",
  "页面.企业.Telegram用户ID": "ID អ្នកប្រើ Telegram",
  "页面.企业.Telegram用户名": "ឈ្មោះអ្នកប្រើ Telegram",
  "页面.企业.上传Logo": "ផ្ទុកឡូហ្គោ",
  "页面.企业.上传媒体": "ផ្ទុកមេឌៀ",
  "页面.企业.上传认证材料": "ផ្ទុកសម្ភារៈផ្ទៀងផ្ទាត់",
  "页面.企业.代发岗位": "ប្រកាសមុខងារ",
  "页面.企业.企业ID": "ID ក្រុមហ៊ុន",
  "页面.企业.企业ID点击详情": "ID ក្រុមហ៊ុន ចុចមើល",
  "页面.企业.企业Logo": "ឡូហ្គោក្រុមហ៊ុន",
  "页面.企业.企业Logoextra": "JPG/PNG អតិបរមា 5MB",
  "页面.企业.企业Logotooltip": "កាត់ 1:1",
  "页面.企业.企业信息": "ព័ត៌មានក្រុមហ៊ុន",
  "页面.企业.企业全称": "ឈ្មោះពេញ",
  "页面.企业.企业全称说明": "ឈ្មោះពេញ (មួយគត់)",
  "页面.企业.企业全称长度2到50": "ឈ្មោះពេញ 2-50 តួអក្សរ",
  "页面.企业.企业简称": "ឈ្មោះខ្លី",
  "页面.企业.企业简称不能超过20": "ឈ្មោះខ្លីអតិបរមា 20 តួអក្សរ",
  "页面.企业.企业管理": "គ្រប់គ្រងក្រុមហ៊ុន",
  "页面.企业.企业规模": "ទំហំ",
  "页面.企业.企业详情": "ព័ត៌មានក្រុមហ៊ុន",
  "页面.企业.信任背书": "ចិត្តទុកចិត្ត",
  "页面.企业.修改者": "កែប្រែដោយ",
  "页面.企业.公司地址": "អាសយដ្ឋានក្រុមហ៊ុន",
  "页面.企业.公司地址tooltip": "ផែនទី ឬដៃ",
  "页面.企业.公司环境媒体": "មេឌៀបរិស្ថាន",
  "页面.企业.公司环境媒体extra": "JPG/PNG/MP4/MOV អតិបរមា 50MB",
  "页面.企业.公司环境媒体tooltip": "អតិបរមា 9 ឯកសារ",
  "页面.企业.公司简介": "ការពិពណ៌នា",
  "页面.企业.公司简介placeholder": "គាំទ្រ AI",
  "页面.企业.关键词搜索": "ពាក្យគន្លឹះ",
  "页面.企业.关键词搜索说明": "ស្វែងរកឈ្មោះក្រុមហ៊ុន",
  "页面.企业.创建失败": "បង្កើតបរាជ័យ",
  "页面.企业.创建失败请重试": "បង្កើតបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.企业.创建成功": "បង្កើតជោគជ័យ",
  "页面.企业.创建时间": "បង្កើតនៅ",
  "页面.企业.创建时间说明": "បង្កើតនៅ",
  "页面.企业.删除": "លុប",
  "页面.企业.删除后可以恢复": "អាចស្តារបាន ប៉ុន្តែមិនបង្ហាញក្នុងបញ្ជី។",
  "页面.企业.删除失败请重试": "លុបបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.企业.发布岗位数量": "ចំនួនការងារបានផ្សព្វផ្សាយ",
  "页面.企业.取消": "បោះបង់",
  "页面.企业.在招岗位": "ការងារកំពុងជ្រើសរើស",
  "页面.企业.基础信息": "ព័ត៌មានមូលដ្ឋាន",
  "页面.企业.备注": "ចំណាំ",
  "页面.企业.备注placeholder": "មើលខាងក្នុងប៉ុណ្ណោះ",
  "页面.企业.备注不能超过500": "ចំណាំអតិបរមា 500 តួអក្សរ",
  "页面.企业.已认证": "ផ្ទៀងផ្ទាត់រួច",
  "页面.企业.成功删除N个企业": "លុបរួច {count} ក្រុមហ៊ុន",
  "页面.企业.成功删除N个失败M个": "លុបរួច {success} បរាជ័យ {fail}",
  "页面.企业.所属行业": "ឧស្សាហកម្ម",
  "页面.企业.手动填写地址": "អាសយដ្ឋានដៃ៖ ",
  "页面.企业.手动填写非标地址": "បញ្ចូលអាសយដ្ឋានដៃ",
  "页面.企业.批量删除": "លុបជាក្រុម",
  "页面.企业.提交": "ដាក់ស្នើ",
  "页面.企业.提交失败请重试": "ដាក់ស្នើបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.企业.操作": "សកម្មភាព",
  "页面.企业.支持国际区号格式": "ឧ. +855",
  "页面.企业.收起手动填写": "បិទបញ្ចូលដៃ",
  "页面.企业.新建企业": "ក្រុមហ៊ុនថ្មី",
  "页面.企业.无Logo": "គ្មានឡូហ្គោ",
  "页面.企业.时间信息": "ព័ត៌មានពេលវេលា",
  "页面.企业.是否有Logo": "មានឡូហ្គោក្រុមហ៊ុន",
  "页面.企业.更新失败": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ",
  "页面.企业.更新失败请重试": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.企业.更新成功": "ធ្វើបច្ចុប្បន្នភាពជោគជ័យ",
  "页面.企业.更新时间": "ធ្វើបច្ចុប្បន្នភាពនៅ",
  "页面.企业.更新时间范围": "ពេលកែប្រែ",
  "页面.企业.有Logo": "មានឡូហ្គោ",
  "页面.企业.未认证": "មិនផ្ទៀងផ្ទាត់",
  "页面.企业.正在创建": "កំពុងបង្កើត...",
  "页面.企业.正在删除N个企业": "កំពុងលុប {count} ក្រុមហ៊ុន...",
  "页面.企业.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.企业.确定要删除这个企业吗": "លុបក្រុមហ៊ុននេះ?",
  "页面.企业.编辑": "កែសម្រួល",
  "页面.企业.编辑企业": "កែក្រុមហ៊ុន",
  "页面.企业.联系人": "ទំនាក់ទំនង",
  "页面.企业.联系人信息": "ព័ត៌មានទំនាក់ទំនង",
  "页面.企业.联系人姓名": "ឈ្មោះទំនាក់ទំនង",
  "页面.企业.联系人姓名不能超过50": "ឈ្មោះទំនាក់ទំនងអតិបរមា 50 តួអក្សរ",
  "页面.企业.联系人职位": "តួនាទីទំនាក់ទំនង",
  "页面.企业.联系人职位不能超过50": "តួនាទីអតិបរមា 50 តួអក្សរ",
  "页面.企业.联系电话": "ទូរស័ព្ទ",
  "页面.企业.联系电话不能超过20": "ទូរស័ព្ទអតិបរមា 20 តួអក្សរ",
  "页面.企业.获取详情失败": "ផ្ទុកព័ត៌មានបរាជ័យ",
  "页面.企业.获取详情失败请重试": "ផ្ទុកព័ត៌មានបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.企业.裁剪Logo": "កាត់ឡូហ្គោ",
  "页面.企业.认证材料": "សម្ភារៈផ្ទៀងផ្ទាត់",
  "页面.企业.认证材料extra": "ឯកសារតែមួយអតិបរមា 10MB",
  "页面.企业.认证材料格式说明": "JPG/PNG/PDF អតិបរមា 10 ឯកសារ",
  "页面.企业.认证状态": "ផ្ទៀងផ្ទាត់",
  "页面.企业.认证状态开启说明": "បង្ហាញសញ្ញាផ្ទៀងផ្ទាត់",
  "页面.企业.请输入企业全称": "បញ្ចូលឈ្មោះពេញ",
  "页面.企业.请输入企业简称可选": "បញ្ចូលឈ្មោះខ្លី (ជម្រើស)",
  "页面.企业.请输入公司地址非标地址": "បញ្ចូលអាសយដ្ឋានក្រុមហ៊ុន",
  "页面.企业.请输入联系人姓名": "បញ្ចូលឈ្មោះទំនាក់ទំនង",
  "页面.企业.请输入联系人职位": "បញ្ចូលតួនាទី",
  "页面.企业.请选择企业规模": "ជ្រើសរើសទំហំ",
  "页面.企业.请选择所属行业": "ជ្រើសរើសឧស្សាហកម្ម",
  "页面.企业.选择修改员工": "ជ្រើសរើសបុគ្គលិក",
  "页面.企业配置.企业规模": "ទំហំក្រុមហ៊ុន",
  "页面.企业配置.创建时间": "បង្កើតនៅ",
  "页面.企业配置.创建时间说明": "បង្កើតនៅ",
  "页面.企业配置.删除": "លុប",
  "页面.企业配置.删除失败请重试": "លុបបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.企业配置.名称": "ឈ្មោះ",
  "页面.企业配置.名称value字段": "ឈ្មោះ (value)",
  "页面.企业配置.名称不能为空": "ឈ្មោះត្រូវតែបំពេញ",
  "页面.企业配置.启用": "បើក",
  "页面.企业配置.成功删除N个": "លុបរួច {count} {typeLabel}",
  "页面.企业配置.成功删除部分失败": "លុបរួច {ok} បរាជ័យ {fail}",
  "页面.企业配置.批量删除": "លុបជាក្រុម",
  "页面.企业配置.排序": "លំដាប់",
  "页面.企业配置.排序顺序说明": "តូចជាង = ខ្ពស់ជាង",
  "页面.企业配置.操作": "សកម្មភាព",
  "页面.企业配置.新建": "{typeLabel}ថ្មី",
  "页面.企业配置.新建行业": "ឧស្សាហកម្មថ្មី",
  "页面.企业配置.是否启用": "សកម្ម",
  "页面.企业配置.更新失败": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ",
  "页面.企业配置.更新失败请重试": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.企业配置.更新成功": "ធ្វើបច្ចុប្បន្នភាពជោគជ័យ",
  "页面.企业配置.正在删除N个": "កំពុងលុប {count} {typeLabel}...",
  "页面.企业配置.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.企业配置.正在添加": "កំពុងបន្ថែម...",
  "页面.企业配置.添加失败": "បន្ថែមបរាជ័យ",
  "页面.企业配置.添加失败请重试": "បន្ថែមបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.企业配置.添加子级": "បន្ថែមករណីរង",
  "页面.企业配置.添加成功": "បន្ថែមជោគជ័យ",
  "页面.企业配置.状态": "ស្ថានភាព",
  "页面.企业配置.确定删除行业项": "លុបធាតុឧស្សាហកម្មនេះ? ករណីរងនឹងត្រូវលុបផង។",
  "页面.企业配置.确定要删除这个吗": "លុប{typeLabel}នេះ?",
  "页面.企业配置.禁用": "បិទ",
  "页面.企业配置.管理": "គ្រប់គ្រង{typeLabel}",
  "页面.企业配置.编辑": "កែសម្រួល",
  "页面.企业配置.编辑类型": "កែ{typeLabel}",
  "页面.企业配置.行业": "ឧស្សាហកម្ម",
  "页面.企业配置.配置": "កំណត់",
  "页面.内容.创建时间": "ពេលបង្កើត",
  "页面.内容.合作媒体.Logo图片": "Logo",
  "页面.内容.合作媒体.Logo链接": "តំណ Logo",
  "页面.内容.合作媒体.上传Logo": "ផ្ទុក Logo",
  "页面.内容.合作媒体.媒体名称": "ឈ្មោះមេឌៀ",
  "页面.内容.合作媒体.媒体名称占位": "បញ្ចូលឈ្មោះមេឌៀ",
  "页面.内容.合作媒体.官网链接": "គេហទំព័រ",
  "页面.内容.合作媒体.展示名称": "ឈ្មោះបង្ហាញ",
  "页面.内容.合作媒体.成功删除N个": "បានលុបដៃគូ {n}",
  "页面.内容.合作媒体.成功删除部分失败": "បានលុប {ok}; បរាជ័យ {fail}",
  "页面.内容.合作媒体.新建": "ដៃគូថ្មី",
  "页面.内容.合作媒体.新建标题": "បង្កើតដៃគូមេឌៀ",
  "页面.内容.合作媒体.正在删除N个": "កំពុងលុបដៃគូ {n}...",
  "页面.内容.合作媒体.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.内容.合作媒体.正在添加": "កំពុងបន្ថែម...",
  "页面.内容.合作媒体.确定删除": "លុបដៃគូមេឌៀនេះ?",
  "页面.内容.合作媒体.确定删除N个": "លុបដៃគូមេឌៀដែលបានជ្រើស {n}?",
  "页面.内容.合作媒体.编辑标题": "កែសម្រួលដៃគូមេឌៀ",
  "页面.内容.合作媒体.联系人": "អ្នកទំនាក់ទំនង",
  "页面.内容.合作媒体.联系电话": "ទូរស័ព្ទ",
  "页面.内容.合作媒体.裁剪Logo": "កាត់ Logo",
  "页面.内容.合作媒体.请输入媒体名称": "ត្រូវបញ្ចូលឈ្មោះមេឌៀ",
  "页面.内容.合作媒体.页面标题": "ដៃគូមេឌៀ",
  "页面.内容.排序": "លំដាប់",
  "页面.内容.请补全多语言": "សូមបំពេញគ្រប់ភាសា",
  "页面.内容.资讯.上传封面": "ផ្ទុកគម្រប",
  "页面.内容.资讯.价格": "តម្លៃ",
  "页面.内容.资讯.加载合作媒体失败": "បរាជ័យក្នុងការផ្ទុកដៃគូមេឌៀ",
  "页面.内容.资讯.原文链接": "តំណប្រភព",
  "页面.内容.资讯.发布平台": "វេទិកា",
  "页面.内容.资讯.发布时间": "ពេលផ្សព្វផ្សាយ",
  "页面.内容.资讯.发布状态": "ស្ថានភាព",
  "页面.内容.资讯.发布链接": "តំណដែលបានផ្សព្វផ្សាយ",
  "页面.内容.资讯.合作媒体": "ដៃគូមេឌៀ",
  "页面.内容.资讯.封面图片": "រូបភាពគម្រប",
  "页面.内容.资讯.封面链接": "តំណរូបគម្រប",
  "页面.内容.资讯.已下架": "បានដកចេញ",
  "页面.内容.资讯.已发布": "បានផ្សព្វផ្សាយ",
  "页面.内容.资讯.成功删除N个": "បានលុបអត្ថបទ {n}",
  "页面.内容.资讯.成功删除部分失败": "បានលុប {ok}; បរាជ័យ {fail}",
  "页面.内容.资讯.摘要": "សង្ខេប",
  "页面.内容.资讯.文章链接": "តំណអត្ថបទ",
  "页面.内容.资讯.新建": "អត្ថបទថ្មី",
  "页面.内容.资讯.新建标题": "បង្កើតអត្ថបទ",
  "页面.内容.资讯.标题": "ចំណងជើង",
  "页面.内容.资讯.正在删除N个": "កំពុងលុបអត្ថបទ {n}...",
  "页面.内容.资讯.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.内容.资讯.正在添加": "កំពុងបន្ថែម...",
  "页面.内容.资讯.正文": "ខ្លឹមសារ",
  "页面.内容.资讯.添加文章链接": "បន្ថែមតំណអត្ថបទ",
  "页面.内容.资讯.确定删除": "លុបអត្ថបទនេះ?",
  "页面.内容.资讯.确定删除N个": "លុបអត្ថបទដែលបានជ្រើស {n}?",
  "页面.内容.资讯.编辑标题": "កែសម្រួលអត្ថបទ",
  "页面.内容.资讯.草稿": "ព្រាង",
  "页面.内容.资讯.裁剪封面": "កាត់គម្រប",
  "页面.内容.资讯.请输入发布平台": "ត្រូវបញ្ចូលវេទិកា",
  "页面.内容.资讯.请输入发布链接": "ត្រូវបញ្ចូលតំណដែលបានផ្សព្វផ្សាយ",
  "页面.内容.资讯.请输入正文": "ត្រូវបញ្ចូលខ្លឹមសារ",
  "页面.内容.资讯.请选择合作媒体": "ជ្រើសរើសដៃគូមេឌៀ",
  "页面.内容.资讯.页面标题": "អត្ថបទ",
  "页面.反馈.举报人ID": "ID អ្នករាយការណ៍",
  "页面.反馈.举报人ID说明": "ID អ្នកប្រើដែលបានដាក់របាយការណ៍ប្រវត្តិរូបនេះ",
  "页面.反馈.举报原因": "មូលហេតុបរិហារ",
  "页面.反馈.举报原因说明": "មកពីវចនានុក្រម resume_complaint_type និងអាចចម្រោះតាមមូលហេតុ",
  "页面.反馈.举报说明": "សេចក្តីពណ៌នាបរិហារ",
  "页面.反馈.举报说明说明": "ព័ត៌មានដែលអ្នកប្រើបានបញ្ចូល តម្រូវឱ្យបំពេញពេលជ្រើសរើស ផ្សេងទៀត",
  "页面.反馈.内容": "ខ្លឹមសារ",
  "页面.反馈.内容说明": "ខ្លឹមសារមតិ",
  "页面.反馈.创建时间": "ពេលបង្កើត",
  "页面.反馈.创建时间说明": "ពេលបង្កើត ដាក់ mouse ពីលើដើម្បីមើលតម្លៃដើម",
  "页面.反馈.加载详情中": "កំពុងផ្ទុកព័ត៌មានលម្អិតមតិ...",
  "页面.反馈.反馈ID": "ID មតិ",
  "页面.反馈.反馈ID说明": "ID មតិ ចុចមើលព័ត៌មានលម្អិត",
  "页面.反馈.岗位反馈记录.创建开始时间": "ពេលចាប់ផ្តើមបង្កើត",
  "页面.反馈.岗位反馈记录.创建时间": "ពេលបង្កើត",
  "页面.反馈.岗位反馈记录.创建时间说明": "ពេលបង្កើត ដាក់ mouse ពីលើដើម្បីមើលតម្លៃដើម",
  "页面.反馈.岗位反馈记录.创建结束时间": "ពេលបញ្ចប់បង្កើត",
  "页面.反馈.岗位反馈记录.加载详情中": "កំពុងផ្ទុកព័ត៌មានលម្អិតកំណត់ត្រាមតិយោបល់...",
  "页面.反馈.岗位反馈记录.匿名ID": "ID អនាមិក",
  "页面.反馈.岗位反馈记录.匿名ID说明": "anonymous_id ដែលប្រើពេលភ្ញៀវផ្ញើមតិយោបល់",
  "页面.反馈.岗位反馈记录.反馈内容": "ខ្លឹមសារមតិយោបល់",
  "页面.反馈.岗位反馈记录.反馈内容说明": "ខ្លឹមសារមតិយោបល់ការងារដែលអ្នកប្រើបានបញ្ចូល",
  "页面.反馈.岗位反馈记录.反馈记录ID": "ID កំណត់ត្រាមតិយោបល់",
  "页面.反馈.岗位反馈记录.反馈记录ID说明": "ID កំណត់ត្រាមតិយោបល់ ចុចដើម្បីមើលព័ត៌មានលម្អិត",
  "页面.反馈.岗位反馈记录.反馈项": "ធាតុមតិយោបល់",
  "页面.反馈.岗位反馈记录.反馈项说明": "ធាតុមតិយោបល់ការងារដែលអ្នកប្រើ C-end បានផ្ញើ ពីវចនានុក្រម jd_feedback_type",
  "页面.反馈.岗位反馈记录.岗位ID": "ID ការងារ",
  "页面.反馈.岗位反馈记录.岗位ID说明": "ID ការងារដែលត្រូវបានផ្តល់មតិយោបល់ ចុចដើម្បីមើលព័ត៌មានលម្អិតការងារ",
  "页面.反馈.岗位反馈记录.暂无数据": "មិនមានទិន្នន័យ",
  "页面.反馈.岗位反馈记录.用户ID": "ID អ្នកប្រើ",
  "页面.反馈.岗位反馈记录.用户ID说明": "ID អ្នកប្រើ C-end ដែលបានផ្ញើមតិយោបល់ ចុចដើម្បីមើលព័ត៌មានអ្នកប្រើ",
  "页面.反馈.岗位反馈记录.用户详情": "ព័ត៌មានអ្នកប្រើ",
  "页面.反馈.岗位反馈记录.获取详情失败": "បរាជ័យក្នុងការផ្ទុកព័ត៌មានលម្អិត",
  "页面.反馈.岗位反馈记录.详情标题": "ព័ត៌មានលម្អិតកំណត់ត្រាមតិយោបល់ការងារ",
  "页面.反馈.岗位反馈记录.请求失败": "សំណើបរាជ័យ",
  "页面.反馈.岗位反馈记录.请选择反馈项": "សូមជ្រើសរើសធាតុមតិយោបល់",
  "页面.反馈.岗位反馈记录.页面标题": "កំណត់ត្រាមតិយោបល់ការងារ",
  "页面.反馈.岗位投诉列表.页面标题": "បញ្ជីបរិហារការងារ",
  "页面.反馈.意见反馈列表.页面标题": "បញ្ជីមតិ",
  "页面.反馈.投诉对象ID": "ID គោលដៅ",
  "页面.反馈.投诉对象ID说明": "ID គោលដៅបរិហារ",
  "页面.反馈.投诉对象类型": "ប្រភេទគោលដៅ",
  "页面.反馈.投诉对象类型说明": "ឧទាហរណ៍ jd",
  "页面.反馈.投诉类型": "ប្រភេទបរិហារ",
  "页面.反馈.投诉类型说明": "ប្រភេទបរិហារការងារ អាចចម្រោះក្នុងបញ្ជីបរិហារ",
  "页面.反馈.操作": "ប្រតិបត្តិការ",
  "页面.反馈.暂无数据": "មិនមានទិន្នន័យ",
  "页面.反馈.用户ID": "ID អ្នកប្រើ",
  "页面.反馈.用户ID说明": "ID អ្នកប្រើដែលបានដាក់ស្នើ ចុចមើលព័ត៌មានអ្នកប្រើ",
  "页面.反馈.用户详情": "ព័ត៌មានអ្នកប្រើ",
  "页面.反馈.简历ID": "ID ប្រវត្តិរូប",
  "页面.反馈.简历ID说明": "ID ប្រវត្តិរូបដែលត្រូវបានបរិហារ ចុចដើម្បីមើលព័ត៌មានលម្អិត",
  "页面.反馈.简历投诉列表.页面标题": "បញ្ជីបរិហារប្រវត្តិរូប",
  "页面.反馈.简历投诉详情": "ព័ត៌មានលម្អិតបរិហារប្រវត្តិរូប",
  "页面.反馈.类别": "ប្រភេទ",
  "页面.反馈.类别.岗位投诉": "បរិហារការងារ",
  "页面.反馈.类别.意见反馈": "មតិ",
  "页面.反馈.类别.简历投诉": "បរិហារប្រវត្តិរូប",
  "页面.反馈.类别说明": "ប្រភេទមតិ",
  "页面.反馈.类型.全部": "ទាំងអស់",
  "页面.反馈.缺少详情参数": "ខ្វះប៉ារ៉ាម៉ែត្រព័ត៌មានលម្អិតមតិ",
  "页面.反馈.获取详情失败": "បរាជ័យក្នុងការផ្ទុកព័ត៌មានលម្អិតមតិ",
  "页面.反馈.被举报用户ID": "ID អ្នកប្រើដែលត្រូវបានរាយការណ៍",
  "页面.反馈.被举报用户ID说明": "កំណត់តាមម្ចាស់ប្រវត្តិរូបដែលត្រូវបានរាយការណ៍ ចុចដើម្បីមើលព័ត៌មានអ្នកប្រើ",
  "页面.反馈.详情标题": "ព័ត៌មានលម្អិតមតិ",
  "页面.反馈.请求失败": "សំណើបរាជ័យ",
  "页面.反馈.请选择举报原因": "សូមជ្រើសមូលហេតុបរិហារ",
  "页面.反馈.请选择投诉类型": "សូមជ្រើសប្រភេទបរិហារ",
  "页面.反馈.账号申诉.凭证文件": "ឯកសារភស្តុតាង",
  "页面.反馈.账号申诉.加载详情中": "កំពុងផ្ទុកព័ត៌មានបណ្តឹង...",
  "页面.反馈.账号申诉.处理失败": "បរាជ័យក្នុងការដោះស្រាយបណ្តឹងគណនី",
  "页面.反馈.账号申诉.处理成功": "បានអនុម័តបណ្តឹង និងដោះការរឹតបន្តឹង",
  "页面.反馈.账号申诉.审核人ID": "ID អ្នកពិនិត្យ",
  "页面.反馈.账号申诉.审核回复": "ការឆ្លើយតបពិនិត្យ",
  "页面.反馈.账号申诉.审核时间": "ពេលពិនិត្យ",
  "页面.反馈.账号申诉.提交时间": "ពេលដាក់ស្នើ",
  "页面.反馈.账号申诉.暂无数据": "មិនមានទិន្នន័យបណ្តឹង",
  "页面.反馈.账号申诉.状态": "ស្ថានភាពបណ្តឹងឧទ្ធរណ៍",
  "页面.反馈.账号申诉.状态.审核中": "កំពុងពិនិត្យ",
  "页面.反馈.账号申诉.状态.已提交": "បានដាក់ស្នើ",
  "页面.反馈.账号申诉.状态.已通过": "បានអនុម័ត",
  "页面.反馈.账号申诉.状态.已驳回": "បានបដិសេធ",
  "页面.反馈.账号申诉.用户": "អ្នកប្រើដាក់បណ្តឹង",
  "页面.反馈.账号申诉.用户ID": "ID អ្នកប្រើ",
  "页面.反馈.账号申诉.申诉ID": "ID បណ្តឹងឧទ្ធរណ៍",
  "页面.反馈.账号申诉.申诉原因": "មូលហេតុបណ្តឹងឧទ្ធរណ៍",
  "页面.反馈.账号申诉.申诉编号": "លេខបណ្តឹងឧទ្ធរណ៍",
  "页面.反馈.账号申诉.申诉说明": "ព័ត៌មានបណ្តឹងឧទ្ធរណ៍",
  "页面.反馈.账号申诉.确认解除封禁": "អនុម័តបណ្តឹង និងដោះការហាមឃាត់គណនីមែនទេ?",
  "页面.反馈.账号申诉.确认解除禁言": "អនុម័តបណ្តឹង និងដោះការបិទសំឡេង IM មែនទេ?",
  "页面.反馈.账号申诉.确认解除说明": "បណ្តឹងនឹងត្រូវបានអនុម័ត ហើយការរឹតបន្តឹងដែលត្រូវគ្នានឹងត្រូវដោះភ្លាមៗ",
  "页面.反馈.账号申诉.获取详情失败": "បរាជ័យក្នុងការផ្ទុកព័ត៌មានបណ្តឹង",
  "页面.反馈.账号申诉.解除封禁": "ដោះការហាមឃាត់",
  "页面.反馈.账号申诉.解除时间": "ពេលដោះលែង",
  "页面.反馈.账号申诉.解除禁言": "ដោះការបិទសំឡេង",
  "页面.反馈.账号申诉.详情标题": "ព័ត៌មានលម្អិតបណ្តឹងឧទ្ធរណ៍គណនី",
  "页面.反馈.账号申诉.账号": "គណនី",
  "页面.反馈.账号申诉.限制原因": "មូលហេតុការរឹតបន្តឹង",
  "页面.反馈.账号申诉.限制开始时间": "ពេលចាប់ផ្តើមការរឹតបន្តឹង",
  "页面.反馈.账号申诉.限制状态": "ស្ថានភាពការរឹតបន្តឹង",
  "页面.反馈.账号申诉.限制状态.已到期": "បានផុតកំណត់",
  "页面.反馈.账号申诉.限制状态.已解除": "បានដោះលែង",
  "页面.反馈.账号申诉.限制状态.生效中": "កំពុងមានប្រសិទ្ធភាព",
  "页面.反馈.账号申诉.限制类型": "ប្រភេទការរឹតបន្តឹង",
  "页面.反馈.账号申诉.限制类型.封禁": "ហាមឃាត់គណនី",
  "页面.反馈.账号申诉.限制类型.禁言": "បិទសំឡេង IM",
  "页面.反馈.账号申诉.限制结束时间": "ពេលបញ្ចប់ដែលបានកំណត់",
  "页面.反馈.账号申诉.限制说明": "ព័ត៌មានការរឹតបន្តឹង",
  "页面.反馈.账号申诉.页面标题": "បញ្ជីបណ្តឹងឧទ្ធរណ៍គណនី",
  "页面.反馈.账号限制.匿名简历": "ប្រវត្តិរូបអនាមិក",
  "页面.反馈.账号限制.封禁": "ហាមឃាត់",
  "页面.反馈.账号限制.封禁成功": "បានហាមឃាត់អ្នកប្រើ",
  "页面.反馈.账号限制.已封禁": "បានហាមឃាត់",
  "页面.反馈.账号限制.已禁言": "បានបិទសំឡេង",
  "页面.反馈.账号限制.操作失败": "បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាពការរឹតបន្តឹងគណនី",
  "页面.反馈.账号限制.无账号": "គ្មានគណនី",
  "页面.反馈.账号限制.正常": "ធម្មតា",
  "页面.反馈.账号限制.状态": "ការរឹតបន្តឹងគណនី",
  "页面.反馈.账号限制.状态说明": "ស្ថានភាពបិទសំឡេង ឬហាមឃាត់បច្ចុប្បន្នរបស់អ្នកប្រើដែលត្រូវបានរាយការណ៍",
  "页面.反馈.账号限制.确认封禁": "ហាមឃាត់អ្នកប្រើនេះមែនទេ?",
  "页面.反馈.账号限制.确认封禁说明": "អ្នកប្រើនឹងមិនអាចចូលប្រើ API ដែលត្រូវការចូលគណនី ប៉ុន្តែអាចដាក់បណ្តឹងឧទ្ធរណ៍បាន",
  "页面.反馈.账号限制.确认禁言": "បិទសំឡេងអ្នកប្រើនេះមែនទេ?",
  "页面.反馈.账号限制.确认禁言说明": "អ្នកប្រើនឹងមិនអាចផ្ញើសារ IM ប៉ុន្តែអាចប្រើមុខងារចូលគណនីផ្សេងទៀតបាន",
  "页面.反馈.账号限制.确认解除": "ដោះលែងការរឹតបន្តឹងបច្ចុប្បន្នមែនទេ?",
  "页面.反馈.账号限制.禁言": "បិទសំឡេង",
  "页面.反馈.账号限制.禁言成功": "បានបិទសំឡេងអ្នកប្រើ",
  "页面.反馈.账号限制.解除": "ដោះលែង",
  "页面.反馈.账号限制.解除成功": "បានដោះលែងការរឹតបន្តឹងគណនី",
  "页面.员工.APIKey名称": "ឈ្មោះ API Key",
  "页面.员工.HTTP方法": "វិធីសាស្ត្រ HTTP",
  "页面.员工.Trace ID": "Trace ID",
  "页面.员工.User-Agent": "User-Agent",
  "页面.员工.仅支持小写字母数字下划线": "អក្សរតូច លេខ និង _ ប៉ុណ្ណោះ",
  "页面.员工.保存角色权限": "រក្សាទុកសិទ្ធិតួនាទី",
  "页面.员工.全部操作记录": "កំណត់ត្រាទាំងអស់",
  "页面.员工.关联账号": "គណនីភ្ជាប់",
  "页面.员工.关联账号占位": "ឧ. អ៉ីមែលចូលមជ្ឈមណ្ឌលហៅទូរស័ព្ទ",
  "页面.员工.关联账号说明": "ត្រូវនឹងគណនីចូលមជ្ឈមណ្ឌលហៅទូរស័ព្ទ (ឧ. OMICall) សម្រាប់ហៅចេញម្នាក់មួយលេខ",
  "页面.员工.关键词搜索": "ពាក្យគន្លឹះ",
  "页面.员工.分配角色": "ចាត់ចែងតួនាទី",
  "页面.员工.创建失败": "បង្កើតបរាជ័យ",
  "页面.员工.创建失败重试": "បង្កើតបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.员工.创建成功": "បង្កើតជោគជ័យ",
  "页面.员工.创建时间": "បង្កើតនៅ",
  "页面.员工.删除后该账号将无法登录": "គណនីមិនអាចចូលបន្ទាប់ពីលុប។",
  "页面.员工.删除失败": "លុបបរាជ័យ",
  "页面.员工.删除失败重试": "លុបបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.员工.删除成功": "លុបជោគជ័យ",
  "页面.员工.删除角色不可恢复": "សកម្មភាពនេះមិនអាចត្រឡប់វិញបាន។",
  "页面.员工.刷新": "ធ្វើឱ្យស្រស់",
  "页面.员工.加载权限目录失败": "ផ្ទុកសិទ្ធិបរាជ័យ",
  "页面.员工.加载权限目录失败重试": "ផ្ទុកសិទ្ធិបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.员工.加载角色失败": "ផ្ទុកតួនាទីបរាជ័យ",
  "页面.员工.加载角色失败重试": "ផ្ទុកតួនាទីបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.员工.同步Manifest": "ធ្វើឱ្យរួមបញ្ចូលគ្នា Manifest",
  "页面.员工.同步失败": "ធ្វើឱ្យរួមបញ្ចូលគ្នាបរាជ័យ",
  "页面.员工.同步失败重试": "ធ្វើឱ្យរួមបញ្ចូលគ្នាបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.员工.同步完成": "រួមបញ្ចូលគ្នារួច: +{created}, ~{updated}, ={unchanged}",
  "页面.员工.员工列表": "បញ្ជីបុគ្គលិក",
  "页面.员工.客户端IP": "IP អតិថិជន",
  "页面.员工.密码已重置": "លេខសម្ងាត់បានកំណត់ឡើងវិញ",
  "页面.员工.当前可分配N项权限": "អាចកំណត់សិទ្ធិបាន {n}។",
  "页面.员工.当前角色": "តួនាទីបច្ចុប្បន្ន",
  "页面.员工.我的操作记录": "កំណត់ត្រារបស់ខ្ញុំ",
  "页面.员工.按权限key搜索": "ស្វែងរកតាម key សិទ្ធិ",
  "页面.员工.接口摘要": "សង្ខេប",
  "页面.员工.搜索用户名昵称": "ស្វែងរកឈ្មោះ និយម",
  "页面.员工.操作": "សកម្មភាព",
  "页面.员工.操作人ID": "ID អ្នកប្រតិបត្តិការ",
  "页面.员工.操作时间": "ពេល",
  "页面.员工.操作时间范围": "ជួរពេល",
  "页面.员工.新密码": "លេខសម្ងាត់ថ្មី",
  "页面.员工.新建角色": "តួនាទីថ្មី",
  "页面.员工.昵称": "ឈ្មោះនិយម",
  "页面.员工.暂无可分配权限": "គ្មានសិទ្ធិដែលអាចកំណត់បាន",
  "页面.员工.暂无角色": "គ្មានតួនាទី",
  "页面.员工.更新失败": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ",
  "页面.员工.更新失败重试": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.员工.更新成功": "ធ្វើបច្ចុប្បន្នភាពជោគជ័យ",
  "页面.员工.更新时间": "ធ្វើបច្ចុប្បន្នភាពនៅ",
  "页面.员工.未激活": "អសកម្ម",
  "页面.员工.权限可见即可编辑": "សិទ្ធិដែលឃើញអាចកែបាន",
  "页面.员工.权限可见即可编辑说明": "អ្នកអាចមើលនិងកែសិទ្ធិដែលអ្នកមានប៉ុណ្ណោះ។",
  "页面.员工.权限树配置": "ដើមឈើសិទ្ធិ",
  "页面.员工.查看": "មើល",
  "页面.员工.正在保存角色权限": "កំពុងរក្សាទុកសិទ្ធិតួនាទី...",
  "页面.员工.正在创建": "កំពុងបង្កើត...",
  "页面.员工.正在创建角色": "កំពុងបង្កើតតួនាទី...",
  "页面.员工.正在删除": "កំពុងលុប...",
  "页面.员工.正在删除角色": "កំពុងលុបតួនាទី...",
  "页面.员工.正在加载该角色权限": "កំពុងផ្ទុកសិទ្ធិតួនាទី…",
  "页面.员工.正在同步权限清单": "កំពុងធ្វើឱ្យរួមបញ្ចូលគ្នាសិទ្ធិ...",
  "页面.员工.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.员工.正在更新角色": "កំពុងធ្វើបច្ចុប្បន្នភាពតួនាទី...",
  "页面.员工.活跃": "សកម្ម",
  "页面.员工.状态": "ស្ថានភាព",
  "页面.员工.状态码": "កូដស្ថានភាព",
  "页面.员工.用户ID": "ID អ្នកប្រើ",
  "页面.员工.用户ID点击详情": "ID ចុចមើល",
  "页面.员工.用户名": "ឈ្មោះអ្នកប្រើ",
  "页面.员工.确定要删除该员工吗": "លុបបុគ្គលិកនេះ?",
  "页面.员工.确认删除角色": "លុបតួនាទីនេះ?",
  "页面.员工.系统内置角色不允许删除": "តួនាទីរចនាសម្ព័ន្ធមិនអាចលុបបាន",
  "页面.员工.系统管理员不可修改": "តួនាទីគ្រប់គ្រងប្រព័ន្ធមិនអាចកែបាន",
  "页面.员工.编辑": "កែសម្រួល",
  "页面.员工.编辑角色": "កែតួនាទី",
  "页面.员工.至少8字符": "យ៉ាងហោចណាស់ 8 តួអក្សរ",
  "页面.员工.获取详情失败": "ផ្ទុកព័ត៌មានបរាជ័យ",
  "页面.员工.获取详情失败请重试": "ផ្ទុកព័ត៌មានបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.员工.角色": "តួនាទី",
  "页面.员工.角色名称": "ឈ្មោះតួនាទី",
  "页面.员工.角色已更新": "តួនាទីបានធ្វើបច្ចុប្បន្នភាព",
  "页面.员工.角色权限保存失败": "រក្សាទុកសិទ្ធិតួនាទីបរាជ័យ",
  "页面.员工.角色权限保存失败重试": "រក្សាទុកសិទ្ធិបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.员工.角色权限保存成功": "រក្សាទុកសិទ្ធិតួនាទីជោគជ័យ",
  "页面.员工.角色权限只读": "សិទ្ធិតួនាទីអានតែប៉ុណ្ណោះ",
  "页面.员工.角色管理": "គ្រប់គ្រងតួនាទី",
  "页面.员工.角色编码": "កូដតួនាទី",
  "页面.员工.角色编码占位": "ឧ. operation_manager",
  "页面.员工.认证方式": "ប្រភេទផ្ទៀងផ្ទាត់",
  "页面.员工.记录ID": "ID កំណត់ត្រា",
  "页面.员工.请先在左侧选择角色": "ជ្រើសរើសតួនាទីនៅខាងឆ្វេង",
  "页面.员工.请先选择角色": "សូមជ្រើសរើសតួនាទីមុន",
  "页面.员工.请求路径": "ផ្លូវ",
  "页面.员工.请输入新密码": "សូមបញ្ចូលលេខសម្ងាត់ថ្មី",
  "页面.员工.请输入角色名称": "សូមបញ្ចូលឈ្មោះតួនាទី",
  "页面.员工.请输入角色编码": "សូមបញ្ចូលកូដតួនាទី",
  "页面.员工.请选择状态": "សូមជ្រើសរើសស្ថានភាព",
  "页面.员工.请选择角色": "ជ្រើសរើសតួនាទី (ច្រើន)",
  "页面.员工.路径关键词": "ពាក្យគន្លឹះផ្លូវ",
  "页面.员工.重置密码": "កំណត់ឡើងវិញលេខសម្ងាត់",
  "页面.商业化.拖拽调整权益顺序": "អូសដើម្បីរៀបលំដាប់អត្ថប្រយោជន៍",
  "页面.审核记录.不通过原因": "មូលហេតុបដិសេធ",
  "页面.审核记录.不通过原因.ID说明": "ID មូលហេតុបដិសេធ",
  "页面.审核记录.不通过原因.创建时间": "បង្កើតនៅ",
  "页面.审核记录.不通过原因.名称说明": "ឈ្មោះមូលហេតុ",
  "页面.审核记录.不通过原因.成功删除N个": "លុបរួច {n}",
  "页面.审核记录.不通过原因.成功删除部分失败": "លុបរួច {ok} បរាជ័យ {fail}",
  "页面.审核记录.不通过原因.排序": "តម្រៀប",
  "页面.审核记录.不通过原因.新建": "មូលហេតុថ្មី",
  "页面.审核记录.不通过原因.正在删除N个": "កំពុងលុប {n}...",
  "页面.审核记录.不通过原因.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.审核记录.不通过原因.正在添加": "កំពុងបន្ថែម...",
  "页面.审核记录.不通过原因.确定删除": "លុបមូលហេតុបដិសេធនេះ?",
  "页面.审核记录.不通过原因.管理标题": "គ្រប់គ្រងមូលហេតុបដិសេធ",
  "页面.审核记录.不通过原因筛选": "ចម្រោះតាមមូលហេតុបដិសេធ",
  "页面.审核记录.不通过原因管理": "គ្រប់គ្រងមូលហេតុបដិសេធ",
  "页面.审核记录.最近7天": "៧ ថ្ងៃចុងក្រោយ",
  "页面.审核记录.最近一个月": "៣០ ថ្ងៃចុងក្រោយ",
  "页面.审核记录.审核备注": "កំណត់សម្គាល់ពិនិត្យ",
  "页面.审核记录.审核记录": "កំណត់ត្រាពិនិត្យ",
  "页面.审核记录.岗位视角": "តាមការងារ",
  "页面.审核记录.当天": "ថ្ងៃនេះ",
  "页面.审核记录.时间": "ពេល",
  "页面.审核记录.查看岗位": "មើលការងារ",
  "页面.审核记录.记录视角": "តាមកំណត់ត្រា",
  "页面.审核记录.选择审核人": "ជ្រើសរើសអ្នកពិនិត្យ",
  "页面.岗位.AI评分": "ពិន្ទុ AI",
  "页面.岗位.AI评分说明": "បង្ហាញកម្រិត ពិន្ទុ និងសេចក្ដីសង្ខេបមូលហេតុរបស់ AI",
  "页面.岗位.Boost状态": "ស្ថានភាព Boost",
  "页面.岗位.C端联系记录": "កំណត់ត្រាទំនាក់ទំនង C-side",
  "页面.岗位.N个文件上传失败": "{n} ឯកសារបរាជ័យ",
  "页面.岗位.Urgent": "Urgent",
  "页面.岗位.Urgent使用成功": "បានប្រើឧបករណ៍ Urgent",
  "页面.岗位.上传岗位文件或图片": "ផ្ទុកឯកសារ ឬរូបភាព",
  "页面.岗位.上午": "ព្រឹក",
  "页面.岗位.下午": "រសៀល",
  "页面.岗位.下架": "ដកចេញ",
  "页面.岗位.下架失败": "ដកចេញបរាជ័យ",
  "页面.岗位.下架失败重试": "ដកចេញបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.下架成功": "ដកចេញជោគជ័យ",
  "页面.岗位.不通过原因必选": "មូលហេតុបដិសេធ (យ៉ាងហោចណាស់មួយ)",
  "页面.岗位.不限": "ណាក៏បាន",
  "页面.岗位.中文标签": "ចិន (zh_CN)",
  "页面.岗位.临时工": "រយៈពេលកំណត់",
  "页面.岗位.仅周末": "តែចុងសប្តាហ៍",
  "页面.岗位.仅工作日": "តែថ្ងៃធ្វើការ",
  "页面.岗位.从输入定位圈定": "អនុវត្តជួរពីការបញ្ចូល",
  "页面.岗位.付费岗位": "ការងារបង់ប្រាក់",
  "页面.岗位.代发岗位场景企业不可修改": "ក្រុមហ៊ុនបានកំណត់",
  "页面.岗位.任务ID": "ID កិច្ចការ",
  "页面.岗位.任务ID说明": "ID កិច្ចការ",
  "页面.岗位.任务列表": "បញ្ជីភារកិច្ច",
  "页面.岗位.任务已提交正在生成": "បានដាក់ជូន...",
  "页面.岗位.任务正在后台生成中": "កំពុងបង្កើត",
  "页面.岗位.任务详情": "ព័ត៌មានកិច្ចការ",
  "页面.岗位.任职要求": "តម្រូវការ",
  "页面.岗位.企业ID": "ID ក្រុមហ៊ុន",
  "页面.岗位.企业关键词搜索": "ស្វែងរកក្រុមហ៊ុន",
  "页面.岗位.企业创建成功": "បង្កើតក្រុមហ៊ុនជោគជ័យ និងជ្រើសរើសរួច",
  "页面.岗位.企业名称": "ក្រុមហ៊ុន",
  "页面.岗位.企业名称只读说明": "ជាឈ្មោះក្រុមហ៊ុនដើមពីប្រភព សម្រាប់យោងប៉ុណ្ណោះ មិនអាចកែបាន។ ការបង្ហាញផ្អែកលើក្រុមហ៊ុនភ្ជាប់ខាងលើ សូមជ្រើសរើស ឬកែនៅទីនោះ។",
  "页面.岗位.企业名称表单说明": "ឈ្មោះក្រុមហ៊ុននៅលើការងារ",
  "页面.岗位.企业名称说明": "ឈ្មោះក្រុមហ៊ុន",
  "页面.岗位.优先级": "អាទិភាព",
  "页面.岗位.使用Urgent": "ប្រើ Urgent",
  "页面.岗位.使用Urgent扣减说明": "វានឹងកាត់ឧបករណ៍ Urgent 1 ពីអ្នកប្រើដែលភ្ជាប់ និងធ្វើឱ្យលំដាប់ការងារថ្មី។ បន្តឬ?",
  "页面.岗位.全职": "ពេញម៉ោង",
  "页面.岗位.全选": "ជ្រើសទាំងអស់",
  "页面.岗位.全部": "ទាំងអស់",
  "页面.岗位.全部岗位": "ការងារទាំងអស់",
  "页面.岗位.全部语言不传": "ភាសាទាំងអស់",
  "页面.岗位.公海池": "អាងហែលទឹក",
  "页面.岗位.共N条": "សរុប {total}",
  "页面.岗位.关联企业": "ក្រុមហ៊ុន",
  "页面.岗位.关联企业搜索说明": "ស្វែងរកតាមឈ្មោះ",
  "页面.岗位.关联企业说明": "ID ក្រុមហ៊ុន",
  "页面.岗位.关键词匹配说明": "ផ្គូផ្គងឈ្មោះ កាតព្វកិច្ច និងអត្ថប្រយោជន៍",
  "页面.岗位.关键词搜索": "ពាក្យគន្លឹះ",
  "页面.岗位.关闭": "បិទ",
  "页面.岗位.兼职": "ធ្វើការផ្នែក",
  "页面.岗位.内容文件": "ឯកសារ",
  "页面.岗位.内容文本": "អត្ថបទ",
  "页面.岗位.最大年龄": "អាយុអតិបរមា",
  "页面.岗位.最大薪资美元": "ប្រាក់ខែអតិបរមា",
  "页面.岗位.最小年龄": "អាយុអប្បបរមា",
  "页面.岗位.最小年龄不能大于最大年龄": "អាយុអប្បបរមាមិនអាចធំជាងអាយុអតិបរមាបានទេ",
  "页面.岗位.最小薪资美元": "ប្រាក់ខែអប្បបរមា",
  "页面.岗位.最近7天": "៧ ថ្ងៃចុងក្រោយ",
  "页面.岗位.最近一个月": "៣០ ថ្ងៃចុងក្រោយ",
  "页面.岗位.最近提交翻译时间": "ពេលដាក់ជូនពាក្យបកចុងក្រោយ",
  "页面.岗位.分数": "ពិន្ទុ",
  "页面.岗位.分配": "ចាត់ចែង",
  "页面.岗位.分配人": "អ្នកទទួលខុសត្រូវ",
  "页面.岗位.分配任务管理": "គ្រប់គ្រងការចាត់ចែងពិនិត្យ",
  "页面.岗位.分配工作台": "ផ្ទាំងការងារចាត់ចែង",
  "页面.岗位.分配成功": "ចាត់ចែងជោគជ័យ",
  "页面.岗位.分配数量": "ចំនួនចាត់ចែង",
  "页面.岗位.分配数量占位": "ទុកចោលដើម្បីចាត់ចែងទាំងអស់ក្នុងក្រុម",
  "页面.岗位.分配数量范围提示": "ចំនួនចាត់ចែងត្រូវរវាង 1 និង {max}",
  "页面.岗位.分配状态": "ស្ថានភាពចាត់ចែង",
  "页面.岗位.分配管理": "ការចាត់ចែង",
  "页面.岗位.分配结果": "លទ្ធផលចាត់ចែង",
  "页面.岗位.分配给该组": "ចាត់ចែងទៅ…",
  "页面.岗位.分配维度": "ចាត់ចែង",
  "页面.岗位.创建": "បង្កើត",
  "页面.岗位.创建时间": "បង្កើតនៅ",
  "页面.岗位.创建时间说明": "បង្កើតនៅ",
  "页面.岗位.删除岗位可恢复说明": "អាចយកវិញបាន ប៉ុន្តែមិនបង្ហាញក្នុងបញ្ជី។",
  "页面.岗位.刷新概览": "ផ្ទុកទិដ្ឋភាពទូទៅឡើងវិញ",
  "页面.岗位.区间止": "បញ្ចប់ជួរ (ឧ. 20250305-000200)",
  "页面.岗位.区间止简版": "លេខបញ្ចប់ (ជាលេខប៉ុណ្ណោះ)",
  "页面.岗位.区间起": "ចាប់ផ្តើមជួរ (ឧ. 20250305-000001)",
  "页面.岗位.区间起简版": "លេខចាប់ផ្តើម (ជាលេខប៉ុណ្ណោះ)",
  "页面.岗位.博士": "ថ្នាក់វិទ្យាល័យ",
  "页面.岗位.原文": "ដើម",
  "页面.岗位.发布": "ផ្សព្វផ្សាយ",
  "页面.岗位.发布失败": "ផ្សព្វផ្សាយបរាជ័យ",
  "页面.岗位.发布失败重试": "ផ្សព្វផ្សាយបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.发布成功": "ផ្សព្វផ្សាយជោគជ័យ",
  "页面.岗位.发布时间": "ផ្សព្វផ្សាយនៅ",
  "页面.岗位.发布来源": "ប្រភពបោះផ្សាយ",
  "页面.岗位.发布来源说明": "ច្រោះតាមថាតើការងារត្រូវបានបោះផ្សាយដោយអ្នកប្រើ C-side ឬអត់",
  "页面.岗位.发布状态": "ស្ថានភាពផ្សព្វផ្សាយ",
  "页面.岗位.取消分配": "ដកចាត់ចែង",
  "页面.岗位.取消分配成功": "ដកចាត់ចែងជោគជ័យ",
  "页面.岗位.取消分配数量": "ចំនួនដកចាត់ចែង",
  "页面.岗位.取消分配数量占位": "ទុកចោលដើម្បីដកចាត់ចែងទាំងអស់ក្នុងក្រុម",
  "页面.岗位.取消分配数量范围提示": "ចំនួនដកចាត់ចែងត្រូវរវាង 1 និង {max}",
  "页面.岗位.取消分配结果": "លទ្ធផលដកចាត់ចែង",
  "页面.岗位.取消岗位置顶失败": "ដកខ្ទាស់ការងារបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.取消岗位置顶成功": "បានដកខ្ទាស់ការងារ",
  "页面.岗位.取消置顶": "ដកខ្ទាស់",
  "页面.岗位.只支持文档和图片格式": "ឯកសារ និងរូបភាពប៉ុណ្ណោះ",
  "页面.岗位.合同工": "កិច្ចសន្យា",
  "页面.岗位.同步刷新": "ផ្ទុកឡើងវិញសមកាល",
  "页面.岗位.周": "សប្តាហ៍",
  "页面.岗位.周一": "ចន្ទ",
  "页面.岗位.周一上午": "ចន្ទ ព្រឹក",
  "页面.岗位.周一下午": "ចន្ទ ល្ងាច",
  "页面.岗位.周三": "ពុធ",
  "页面.岗位.周三上午": "ពុធ ព្រឹក",
  "页面.岗位.周三下午": "ពុធ ល្ងាច",
  "页面.岗位.周二": "អង្គារ",
  "页面.岗位.周二上午": "អង្គារ ព្រឹក",
  "页面.岗位.周二下午": "អង្គារ ល្ងាច",
  "页面.岗位.周五": "សុក្រ",
  "页面.岗位.周五上午": "សុក្រ ព្រឹក",
  "页面.岗位.周五下午": "សុក្រ ល្ងាច",
  "页面.岗位.周六": "សៅរ៍",
  "页面.岗位.周六上午": "សៅរ៍ ព្រឹក",
  "页面.岗位.周六下午": "សៅរ៍ ល្ងាច",
  "页面.岗位.周四": "ព្រហស្បតិ៍",
  "页面.岗位.周四上午": "ព្រហស្បតិ៍ ព្រឹក",
  "页面.岗位.周四下午": "ព្រហស្បតិ៍ ល្ងាច",
  "页面.岗位.周日": "អាទិត្យ",
  "页面.岗位.周日上午": "អាទិត្យ ព្រឹក",
  "页面.岗位.周日下午": "អាទិត្យ ល្ងាច",
  "页面.岗位.周结": "រាល់សប្តាហ៍",
  "页面.岗位.基础信息": "ព័ត៌មានមូលដ្ឋាន",
  "页面.岗位.填入区间": "បំពេញជួរ",
  "页面.岗位.复制失败请重试": "ចម្លងបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.大专": "វិទ្យាល័យ",
  "页面.岗位.女": "ស្រី",
  "页面.岗位.学历要求": "ការអប់រំ",
  "页面.岗位.完工结算": "ពេលរួច",
  "页面.岗位.定位": "កំណត់ទីតាំង",
  "页面.岗位.定位到我最后审核的": "ទៅពិនិត្យចុងក្រោយរបស់ខ្ញុំ",
  "页面.岗位.定位失败重试": "កំណត់ទីតាំងបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.实习": "បទពិសោធន៍",
  "页面.岗位.审核": "ពិនិត្យ",
  "页面.岗位.审核不通过": "បដិសេធ",
  "页面.岗位.审核人": "អ្នកពិនិត្យ",
  "页面.岗位.审核信息": "ព័ត៌មានពិនិត្យ",
  "页面.岗位.审核备注选填": "កំណត់សម្គាល់ពិនិត្យ",
  "页面.岗位.审核时间": "ពេលពិនិត្យ",
  "页面.岗位.审核状态": "ស្ថានភាពពិនិត្យ",
  "页面.岗位.审核通过": "អនុម័ត",
  "页面.岗位.审核通过但发布失败": "អនុម័តប៉ុន្តែផ្សព្វផ្សាយបរាជ័យ",
  "页面.岗位.审核通过并已自动发布": "អនុម័តនិងផ្សព្វផ្សាយ",
  "页面.岗位.审核通过自动发布": "ផ្សព្វផ្សាយដោយស្វ័យប្រវត្តិ",
  "页面.岗位.岗位ID": "ID ការងារ",
  "页面.岗位.岗位ID或编号": "ID ឬលេខការងារ",
  "页面.岗位.岗位ID点击详情": "ID ការងារ ចុចមើល",
  "页面.岗位.岗位ID精确查找": "ID ការងារពិតប្រាកដ",
  "页面.岗位.岗位信息": "ព័ត៌មានការងារ",
  "页面.岗位.岗位分组配置展示": "ការកំណត់ក្រុមការងារ",
  "页面.岗位.岗位原文主体语言": "ភាសាចំណងជើង",
  "页面.岗位.岗位原文主体语言说明": "ភាសាចម្បងនៃចំណងជើង៖ zh_CN / en_US / km_KH",
  "页面.岗位.岗位名称": "ឈ្មោះការងារ",
  "页面.岗位.岗位名称长度": "១-១០០ តួអក្សរ",
  "页面.岗位.岗位地址": "អាសយដ្ឋានការងារ",
  "页面.岗位.岗位地址tooltip": "ផែនទី ឬដៃ",
  "页面.岗位.岗位审核": "ពិនិត្យការងារ",
  "页面.岗位.岗位审核带ID": "ពិនិត្យការងារ ({id})",
  "页面.岗位.岗位审核带标题": "ពិនិត្យការងារ: {title}",
  "页面.岗位.岗位标签": "ស្លាកការងារ",
  "页面.岗位.岗位标签关键词": "ពាក្យគន្លឹះស្លាក",
  "页面.岗位.岗位标签关键词说明": "ស្វែងរកតាមពាក្យគន្លឹះស្លាក",
  "页面.岗位.岗位标签多选": "ស្លាកការងារ (ច្រើន)",
  "页面.岗位.岗位标签筛选说明": "ស្លាកការងារ",
  "页面.岗位.岗位生成": "បង្កើតការងារ",
  "页面.岗位.岗位等级": "កម្រិតការងារ",
  "页面.岗位.岗位等级筛选说明": "ចម្រោះតាមកម្រិតការងារ AI",
  "页面.岗位.岗位管理": "គ្រប់គ្រងការងារ",
  "页面.岗位.岗位编号": "លេខការងារ",
  "页面.岗位.岗位编号查找": "លេខការងារពិតប្រាកដ",
  "页面.岗位.岗位置顶失败": "ខ្ទាស់ការងារបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.岗位置顶成功": "បានខ្ទាស់ការងារ",
  "页面.岗位.岗位翻译管理": "គ្រប់គ្រងពាក្យបកការងារ",
  "页面.岗位.岗位翻译管理带标题": "ពាក្យបកការងារ: {title}",
  "页面.岗位.岗位职责": "ភារកិច្ចការងារ",
  "页面.岗位.岗位详情": "ព័ត៌មានការងារ",
  "页面.岗位.工作地点": "ទីតាំង",
  "页面.岗位.工作地点多选": "ទីតាំង (ច្រើន)",
  "页面.岗位.工作开始时间": "ពេលចាប់ផ្តើមការងារ",
  "页面.岗位.工作性质": "ប្រភេទការងារ",
  "页面.岗位.工作日安排": "កាលវិភាគថ្ងៃធ្វើការ",
  "页面.岗位.工作福利标签": "ស្លាកវចនានុក្រម",
  "页面.岗位.工作福利标签列表说明": "ពីវចនានុក្រមស្លាក (ច្រើនប្រភេទ)។ បញ្ជីចុះមានតែធាតុសកម្ម។ តារាងតាមភាសា UI។ សូមព្រីរលើស្លាកដើម្បីឃើញប្រភេទ",
  "页面.岗位.工作经验要求": "តម្រូវការបទពិសោធន៍",
  "页面.岗位.工作结束时间": "ពេលបញ្ចប់ការងារ",
  "页面.岗位.工作职责": "ទំនួលខុសត្រូវ",
  "页面.岗位.工作要求": "តម្រូវការការងារ",
  "页面.岗位.工种": "ប្រភេទការងារ",
  "页面.岗位.已Boost": "បាន Boost",
  "页面.岗位.已上架": "បានដាក់បង្ហាញ",
  "页面.岗位.已下架": "ដកចេញរួច",
  "页面.岗位.已关联企业": "ចាត់ចែងរួច",
  "页面.岗位.已分配": "ចាត់ចែងរួច",
  "页面.岗位.已发布": "ផ្សព្វផ្សាយរួច",
  "页面.岗位.已审核": "ពិនិត្យរួច",
  "页面.岗位.已提交翻译": "បានដាក់ជូនពាក្យបក",
  "页面.岗位.已标记为审核不通过": "បានបដិសេធ",
  "页面.岗位.已标记为稍后审核": "បានសម្គាល់ពិនិត្យពេលក្រោយ",
  "页面.岗位.已添加N个文件任务": "បានបន្ថែម {n} ឯកសារ",
  "页面.岗位.已置顶": "បានខ្ទាស់",
  "页面.岗位.已跳过": "រំលង",
  "页面.岗位.已选N条": "បានជ្រើស {n}",
  "页面.岗位.已预设企业不可修改": "ក្រុមហ៊ុនបានកំណត់",
  "页面.岗位.年龄要求": "តម្រូវការអាយុ",
  "页面.岗位.开始生成": "ចាប់ផ្តើម",
  "页面.岗位.当前圈定": "ជួរដែលបានជ្រើសបច្ចុប្បន្ន",
  "页面.岗位.当前岗位未发布是否仍复制链接": "ការងារនេះមិនទាន់ផ្សព្វផ្សាយ។ ចម្លងតំណដែរឬ?",
  "页面.岗位.当前数据条件": "តម្រងបច្ចុប្បន្ន",
  "页面.岗位.当前选中组": "ក្រុមដែលបានជ្រើស",
  "页面.岗位.当天": "ថ្ងៃនេះ",
  "页面.岗位.待分配": "មិនទាន់ចាត់ចែង",
  "页面.岗位.待发布": "រង់ចាំផ្សព្វផ្សាយ",
  "页面.岗位.待提交": "រង់ចាំ",
  "页面.岗位.快速创建企业": "បង្កើតក្រុមហ៊ុនរហ័ស",
  "页面.岗位.性别不限": "មិនកំណត់",
  "页面.岗位.性别要求": "តម្រូវការភេទ",
  "页面.岗位.成功N条失败N条": "ជោគជ័យ {success} បរាជ័យ {fail}",
  "页面.岗位.成功删除N个": "លុបរួច {n} ការងារ",
  "页面.岗位.成功删除部分失败": "លុបរួច {ok} បរាជ័យ {fail}",
  "页面.岗位.我审核的": "ពិនិត្យរបស់ខ្ញុំ",
  "页面.岗位.我的任务": "កិច្ចការរបស់ខ្ញុំ",
  "页面.岗位.所有任务执行失败": "បរាជ័យ {n}",
  "页面.岗位.所有任务执行完毕": "រួចរាល់ {n} ជោគជ័យ",
  "页面.岗位.手动圈定": "កំណត់ដោយដៃ",
  "页面.岗位.手动填写地址": "អាសយដ្ឋានដៃ៖ ",
  "页面.岗位.手动填写非标地址": "បញ្ចូលអាសយដ្ឋានដៃ",
  "页面.岗位.执行配置": "កំណត់រចនាសម្ព័ន្ធ",
  "页面.岗位.批次任务": "ក្រុម (ID: {id})",
  "页面.岗位.批量上传文件": "ផ្ទុកឯកសារ",
  "页面.岗位.技能要求": "ជំនាញ",
  "页面.岗位.拉取该语言预览": "ទាញយកមើលជាមុន",
  "页面.岗位.拖拉圈定": "អូសដើម្បីជ្រើសជួរ",
  "页面.岗位.招聘人数": "ចំនួនជួល",
  "页面.岗位.按分配人筛选": "ចម្រោះតាមអ្នកទទួលខុសត្រូវ",
  "页面.岗位.按区间分配": "ចាត់ចែងតាមជួរ",
  "页面.岗位.按区间取消分配": "ដកចាត់ចែងតាមជួរ",
  "页面.岗位.按天分配概览": "ទិដ្ឋភាពទូទៅចាត់ចែងប្រចាំថ្ងៃ",
  "页面.岗位.按编号分配": "ចាត់ចែងតាមលេខការងារ",
  "页面.岗位.按编号取消分配": "ដកចាត់ចែងតាមលេខការងារ",
  "页面.岗位.按选中分配": "ចាត់ចែងតាមដែលបានជ្រើស",
  "页面.岗位.按选中取消分配": "ដកចាត់ចែងតាមដែលបានជ្រើស",
  "页面.岗位.提交": "ដាក់ជូន",
  "页面.岗位.提交失败": "ដាក់ជូនបរាជ័យ",
  "页面.岗位.提交失败请重试": "ដាក់ជូនបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.提交失败重试": "ដាក់ជូនបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.提交并审核": "ដាក់ជូននិងពិនិត្យ",
  "页面.岗位.提交翻译": "ដាក់ជូនពាក្យបក",
  "页面.岗位.提交翻译成功": "ដាក់ជូនពាក្យបកជោគជ័យ",
  "页面.岗位.操作分配人": "អ្នកទទួលខុសត្រូវសម្រាប់ប្រតិបត្តិការ",
  "页面.岗位.操作失败": "បរាជ័យ",
  "页面.岗位.操作失败重试": "បរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.收起手动填写": "បិទបញ្ចូលដៃ",
  "页面.岗位.新建岗位": "ការងារថ្មី",
  "页面.岗位.无法获取当前用户信息": "មិនអាចយកអ្នកប្រើ",
  "页面.岗位.无额外条件": "គ្មានតម្រង (ទិន្នន័យទាំងអស់)",
  "页面.岗位.日": "ថ្ងៃ",
  "页面.岗位.日期提示文案": "ប្ដូរកាលបរិច្ឆេទនឹងផ្ទុកផ្នែកទាំងអស់សម្រាប់ថ្ងៃនោះឡើងវិញដោយស្វ័យប្រវត្តិ",
  "页面.岗位.日结": "រាល់ថ្ងៃ",
  "页面.岗位.时": "ម៉ោង",
  "页面.岗位.时间": "ពេល",
  "页面.岗位.时间信息": "ពេល",
  "页面.岗位.昨天": "ម្សិលមិញ",
  "页面.岗位.是否已提交翻译": "បានដាក់ជូនពាក្យបក",
  "页面.岗位.暂无任务请点击添加": "គ្មានកិច្ចការ ចុចបន្ថែម",
  "页面.岗位.暂无分组数据": "គ្មានទិន្នន័យក្រុម (ផ្គូផ្គងតម្រងបញ្ជីបច្ចុប្បន្ន)",
  "页面.岗位.暂无匹配岗位分组配置": "ស្លាកការងារដែលបានជ្រើសមិនត្រូវនឹងការកំណត់ក្រុមការងារណាមួយទេ",
  "页面.岗位.暂无您的审核记录": "គ្មានកំណត់ត្រាពិនិត្យរបស់អ្នក",
  "页面.岗位.更多": "បន្ថែម",
  "页面.岗位.更新时间": "ធ្វើបច្ចុប្បន្នភាពនៅ",
  "页面.岗位.月": "ខែ",
  "页面.岗位.月结": "រាល់ខែ",
  "页面.岗位.有未提交任务关闭说明": "កិច្ចការមិនរក្សានឹងត្រូវលុប។",
  "页面.岗位.未Boost": "មិនទាន់ Boost",
  "页面.岗位.未分配": "មិនទាន់ចាត់ចែង",
  "页面.岗位.未审核": "រង់ចាំ",
  "页面.岗位.本岗位审核记录": "កំណត់ត្រាពិនិត្យការងារនេះ",
  "页面.岗位.本次工作台数据共N条": "សរុប {n} ក្នុងផ្ទាំងការងារនេះ",
  "页面.岗位.本科": "បរិញ្ញាបត្រ",
  "页面.岗位.本组共N条": "ក្រុមនេះមាន {n}",
  "页面.岗位.条数": "ចំនួន",
  "页面.岗位.来自岗位详情接口切换Tab不会清空": "ពី API ព័ត៌មានការងារ ផ្លាស់ប្តូរ Tab រក្សាទិន្នន័យ។",
  "页面.岗位.某语言预览拉取成功": "{lang} មើលជាមុនដាក់ជោគជ័យ",
  "页面.岗位.查看原文": "មើលអត្ថបទដើម",
  "页面.岗位.查看审核记录": "មើលកំណត់ត្រាពិនិត្យ",
  "页面.岗位.查询成功": "ស្វែងរកជោគជ័យ",
  "页面.岗位.查询状态": "ស្វែងរកស្ថានភាព",
  "页面.岗位.查询翻译任务状态": "ស្ថានភាពពាក្យបក",
  "页面.岗位.校验失败": "ផ្ទៀងផ្ទាត់បរាជ័យ",
  "页面.岗位.正在上传文件并提交任务": "កំពុងផ្ទុកឡើង...",
  "页面.岗位.正在下架": "កំពុងដកចេញ...",
  "页面.岗位.正在创建": "កំពុងបង្កើត...",
  "页面.岗位.正在删除N个": "កំពុងលុប {n} ការងារ...",
  "页面.岗位.正在发布": "កំពុងផ្សព្វផ្សាយ...",
  "页面.岗位.正在取消置顶岗位": "កំពុងដកខ្ទាស់...",
  "页面.岗位.正在打开上一条岗位": "កំពុងបើកការងារមុន...",
  "页面.岗位.正在打开下一条待审核": "កំពុងបើកការងាររង់ចាំពិនិត្យបន្ទាប់...",
  "页面.岗位.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.岗位.正在标记稍后审核": "កំពុងសម្គាល់ពិនិត្យពេលក្រោយ...",
  "页面.岗位.正在置顶岗位": "កំពុងខ្ទាស់ការងារ...",
  "页面.岗位.步骤1选择数据段": "ជំហានទី1៖ ជ្រើសផ្នែកទិន្នន័យដែលត្រូវប្រតិបត្តិការ",
  "页面.岗位.步骤2调整并提交": "ជំហានទី2៖ កែសម្រួលជួរ និងដាក់ស្នើ",
  "页面.岗位.池与关联": "អាង/ក្រុមហ៊ុន",
  "页面.岗位.没有上一条可返回": "មិនមានការងារមុនសម្រាប់ត្រឡប់ទេ",
  "页面.岗位.没有更多待审核岗位": "មិនមានការងាររង់ចាំពិនិត្យទៀតទេ",
  "页面.岗位.添加生成任务": "បន្ថែមកិច្ចការ",
  "页面.岗位.添加纯文本任务": "បន្ថែមអត្ថបទ",
  "页面.岗位.清空": "សម្អាត",
  "页面.岗位.点击展开查看完整返回": "ចុចពង្រីក",
  "页面.岗位.用户": "អ្នកប្រើ",
  "页面.岗位.用户ID": "ID អ្នកប្រើ",
  "页面.岗位.用户ID说明": "ID អ្នកប្រើ",
  "页面.岗位.用户信息说明": "អ្នកប្រើ",
  "页面.岗位.男": "ប្រុស",
  "页面.岗位.目标语言": "ភាសាគោលដៅ",
  "页面.岗位.硕士": "ថ្នាក់អនុវិទ្យាល័យ",
  "页面.岗位.确定关闭": "បិទ",
  "页面.岗位.确定删除岗位": "លុបការងារនេះ?",
  "页面.岗位.确定取消该区间分配": "ដកចាត់ចែងជួរនេះ?",
  "页面.岗位.确定取消该组分配": "ដកចាត់ចែងក្រុមនេះ?",
  "页面.岗位.确认使用Urgent": "បញ្ជាក់ការប្រើ Urgent",
  "页面.岗位.确认关闭": "បិទ",
  "页面.岗位.福利待遇": "អត្ថប្រយោជន៍",
  "页面.岗位.稍后审核": "ពិនិត្យពេលក្រោយ",
  "页面.岗位.筛选.地点与标签": "ទីតាំង និងស្លាក",
  "页面.岗位.筛选.基础信息": "ព័ត៌មានមូលដ្ឋាន",
  "页面.岗位.筛选.岗位与池": "ការងារ និងអាង",
  "页面.岗位.筛选.数据源": "ប្រភពទិន្នន័យ",
  "页面.岗位.筛选.联系与渠道": "ទំនាក់ទំនង",
  "页面.岗位.筛选.薪资与任职": "ប្រាក់ខែ និងការងារ",
  "页面.岗位.管理分配任务": "គ្រប់គ្រងការចាត់ចែងពិនិត្យ",
  "页面.岗位.管理视角": "ទិដ្ឋភាពគ្រប់គ្រង",
  "页面.岗位.粘贴编号列表": "បិទភ្ជាប់បញ្ជីលេខការងារ",
  "页面.岗位.经验0到3年": "0-3 ឆ្នាំ",
  "页面.岗位.经验10年以上": "10 ឆ្នាំឡើង",
  "页面.岗位.经验1到3年": "1-3 ឆ្នាំ",
  "页面.岗位.经验1年以内": "ក្រោម 1 ឆ្នាំ",
  "页面.岗位.经验3到5年": "3-5 ឆ្នាំ",
  "页面.岗位.经验3年以上": "3 ឆ្នាំឡើង",
  "页面.岗位.经验5到10年": "5-10 ឆ្នាំ",
  "页面.岗位.经验不限": "មិនកំណត់",
  "页面.岗位.结构化内容": "មាតិការចនាសម្ព័ន្ធ",
  "页面.岗位.继续编辑": "កែតម្រូវ",
  "页面.岗位.编号列表提示": "បំបែកដោយក្បៀស គម្លាត ឬបន្ទាត់ថ្មី",
  "页面.岗位.编号区间": "ជួរលេខការងារ",
  "页面.岗位.编号日期": "កាលបរិច្ឆេទលេខការងារ",
  "页面.岗位.编辑岗位": "កែការងារ",
  "页面.岗位.置顶": "ខ្ទាស់",
  "页面.岗位.翻译": "បកប្រែ",
  "页面.岗位.翻译预览": "មើលជាមុនពាក្យបក",
  "页面.岗位.职位描述": "ភារកិច្ចការងារ",
  "页面.岗位.联系人": "ទំនាក់ទំនង",
  "页面.岗位.联系人姓名": "ឈ្មោះទំនាក់ទំនង",
  "页面.岗位.联系人电话": "ទូរស័ព្ទ",
  "页面.岗位.联系时间": "ពេលទាក់ទង",
  "页面.岗位.联系时间说明": "ពេលមើល",
  "页面.岗位.联系电话": "ទូរស័ព្ទ",
  "页面.岗位.联系电话运营商": "ប្រតិបត្តិករទូរស័ព្ទ",
  "页面.岗位.联系电话运营商说明": "ស្លាកប្រតិបត្តិករទូរស័ព្ទ (តាមកំណត់) សម្រាប់ចម្រោះត្រឹមត្រូវ",
  "页面.岗位.自动创建岗位": "បង្កើតការងារដោយស្វ័យប្រវត្តិ",
  "页面.岗位.自动发布岗位": "ផ្សព្វផ្សាយដោយស្វ័យប្រវត្តិ",
  "页面.岗位.自发布": "បោះផ្សាយដោយខ្លួនឯង",
  "页面.岗位.英文标签": "អង់គ្លេស (en_US)",
  "页面.岗位.草稿": "ព្រាង",
  "页面.岗位.获取任务详情失败": "ផ្ទុកកិច្ចការបរាជ័យ",
  "页面.岗位.获取任务详情失败重试": "ផ្ទុកកិច្ចការបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.获取企业详情失败": "ផ្ទុកក្រុមហ៊ុនបរាជ័យ",
  "页面.岗位.获取企业详情失败重试": "ផ្ទុកក្រុមហ៊ុនបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.获取岗位详情失败": "ផ្ទុកព័ត៌មានការងារបរាជ័យ",
  "页面.岗位.获取岗位详情失败重试": "ផ្ទុកព័ត៌មានការងារបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.获取批次任务失败": "ផ្ទុកក្រុមបរាជ័យ",
  "页面.岗位.获取批次任务失败重试": "ផ្ទុកក្រុមបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.获取详情失败": "ផ្ទុកព័ត៌មានបរាជ័យ",
  "页面.岗位.获取详情失败重试": "ផ្ទុកព័ត៌មានបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位.获取链接": "យកតំណ",
  "页面.岗位.薪资": "ប្រាក់ខែ",
  "页面.岗位.薪资时间单位": "ឯកតាប្រាក់ខែ",
  "页面.岗位.薪资结算单位": "ឯកតាទូទាត់",
  "页面.岗位.薪资结算单位说明": "ចម្រោះតាមឯកតាទូទាត់",
  "页面.岗位.薪资说明": "ជួរប្រាក់ខែ",
  "页面.岗位.薪资面议": "ប្រាក់ខែចរចារ",
  "页面.岗位.被联系次数": "ចំនួនទំនាក់ទំនង",
  "页面.岗位.被联系次数说明": "ចំនួនមើល",
  "页面.岗位.被联系用户": "អ្នកប្រើដែលទាក់ទង",
  "页面.岗位.被联系用户带标题": "ទាក់ទង: {title}",
  "页面.岗位.证书资质": "វិញ្ញាបនបត្រ",
  "页面.岗位.该岗位不在当前列表条件下": "ការងារមិននៅក្នុងបញ្ជី",
  "页面.岗位.该批次暂无任务": "គ្មានកិច្ចការក្នុងក្រុម",
  "页面.岗位.该日暂无岗位数据": "គ្មានការងារសម្រាប់ថ្ងៃនេះ",
  "页面.岗位.详细描述": "ការពិពណ៌នា",
  "页面.岗位.请从列表点击审核打开": "ចុចពិនិត្យក្នុងបញ្ជី",
  "页面.岗位.请先加载列表后再定位": "ផ្ទុកបញ្ជីមុន",
  "页面.岗位.请先选择一个数据段": "សូមជ្រើសផ្នែកទិន្នន័យពីខាងឆ្វេងជាមុន",
  "页面.岗位.请先选择操作分配人": "សូមជ្រើសអ្នកទទួលខុសត្រូវសម្រាប់ប្រតិបត្តិការជាមុន",
  "页面.岗位.请求失败": "ស្នើបរាជ័យ",
  "页面.岗位.请输入任职要求": "បញ្ចូលតម្រូវការ",
  "页面.岗位.请输入企业全称": "បញ្ចូលឈ្មោះក្រុមហ៊ុនពេញ (២-២០០)",
  "页面.岗位.请输入最大薪资": "បញ្ចូលប្រាក់ខែអតិបរមា",
  "页面.岗位.请输入最小薪资": "បញ្ចូលប្រាក់ខែអប្បបរមា",
  "页面.岗位.请输入完整编号区间": "សូមបញ្ចូលជួរលេខការងារឲ្យពេញលេញ",
  "页面.岗位.请输入审核备注": "បញ្ចូលកំណត់សម្គាល់",
  "页面.岗位.请输入岗位ID或编号": "បញ្ចូល ID ឬលេខការងារ",
  "页面.岗位.请输入岗位名称": "បញ្ចូលឈ្មោះការងារ",
  "页面.岗位.请输入岗位地址非标地址": "បញ្ចូលអាសយដ្ឋានការងារ",
  "页面.岗位.请输入岗位职责": "បញ្ចូលភារកិច្ចការងារ",
  "页面.岗位.请输入工作职责": "បញ្ចូលទំនួលខុសត្រូវ",
  "页面.岗位.请输入工作要求": "បញ្ចូលតម្រូវការការងារ",
  "页面.岗位.请输入技能要求": "បញ្ចូលជំនាញ",
  "页面.岗位.请输入招聘人数": "បញ្ចូលចំនួនជួល",
  "页面.岗位.请输入福利待遇": "បញ្ចូលអត្ថប្រយោជន៍",
  "页面.岗位.请输入职位描述": "បញ្ចូលភារកិច្ចការងារ",
  "页面.岗位.请输入联系人姓名": "បញ្ចូលឈ្មោះទំនាក់ទំនង",
  "页面.岗位.请输入联系电话": "បញ្ចូលទូរស័ព្ទ",
  "页面.岗位.请输入至少2个字符": "បញ្ចូលយ៉ាងហោចណាស់ ២ តួ",
  "页面.岗位.请输入至少一个岗位编号": "សូមបញ្ចូលយ៉ាងហោចណាស់លេខការងារមួយ",
  "页面.岗位.请输入证书资质": "បញ្ចូលវិញ្ញាបនបត្រ",
  "页面.岗位.请输入飞机号": "បញ្ចូល Telegram",
  "页面.岗位.请选择不通过原因": "ជ្រើសរើសមូលហេតុបដិសេធ",
  "页面.岗位.请选择分配人": "ជ្រើសរើសអ្នកទទួលខុសត្រូវ",
  "页面.岗位.请选择学历要求": "ជ្រើសរើសការអប់រំ",
  "页面.岗位.请选择岗位标签可多选": "ជ្រើសរើសស្លាកការងារ",
  "页面.岗位.请选择岗位标签后展示岗位分组配置": "ជ្រើសស្លាកការងារ ដើម្បីបង្ហាញការកំណត់ក្រុមការងារដែលត្រូវគ្នា",
  "页面.岗位.请选择工作地点": "ជ្រើសរើសទីតាំង",
  "页面.岗位.请选择工作性质": "ជ្រើសរើសប្រភេទការងារ",
  "页面.岗位.请选择工作福利标签可多选": "ជ្រើសស្លាកវចនានុក្រម (ច្រើន)៖ លក្ខខណ្ឌ សុខុមាលភាព របៀបការងារ ស្ថានភាពវេទិកា ជាដើម",
  "页面.岗位.请选择工作经验要求": "ជ្រើសរើសបទពិសោធន៍",
  "页面.岗位.请选择工种": "ជ្រើសរើសប្រភេទការងារ",
  "页面.岗位.请选择开始时间": "សូមជ្រើសពេលចាប់ផ្តើម",
  "页面.岗位.请选择性别要求": "ជ្រើសរើសតម្រូវការភេទ",
  "页面.岗位.请选择结束时间": "សូមជ្រើសពេលបញ្ចប់",
  "页面.岗位.请选择编号日期": "ជ្រើសរើសកាលបរិច្ឆេទលេខការងារ",
  "页面.岗位.请选择至少一个不通过原因": "សូមជ្រើសរើសយ៉ាងហោចណាស់មូលហេតុបដិសេធមួយ",
  "页面.岗位.请选择至少一条岗位": "សូមជ្រើសយ៉ាងហោចណាស់ការងារមួយ",
  "页面.岗位.请选择薪资时间单位": "ជ្រើសរើសឯកតាប្រាក់ខែ",
  "页面.岗位.请选择薪资结算单位": "ជ្រើសរើសឯកតាទូទាត់",
  "页面.岗位.输入内容": "ការបញ្ចូល",
  "页面.岗位.运营录入": "បញ្ចូលដោយប្រតិបត្តិការ",
  "页面.岗位.返回上一条": "ត្រឡប់ទៅមុន",
  "页面.岗位.返回非成功": "ការឆ្លើយតបមិនជោគជ័យ",
  "页面.岗位.选择一组进行操作": "ជ្រើសរើសក្រុមដើម្បីចាត់ចែង ឬដកចាត់ចែង",
  "页面.岗位.选择分配人并确认": "ជ្រើសអ្នកទទួលខុសត្រូវ និងបញ្ជាក់",
  "页面.岗位.选择日期": "ជ្រើសរើសកាលបរិច្ឆេទ",
  "页面.岗位.部分成功部分失败": "{ok} ជោគជ័យ {fail} បរាជ័យ",
  "页面.岗位.链接已复制": "ចម្លងតំណរួចរាល់",
  "页面.岗位.非结构化企业名称": "ឈ្មោះក្រុមហ៊ុន",
  "页面.岗位.面谈": "ចរចារ",
  "页面.岗位.预览返回异常": "មើលជាមុនមានកំហុស",
  "页面.岗位.飞机号": "Telegram",
  "页面.岗位.首次提交翻译时间": "ពេលដាក់ជូនពាក្យបកដំបូង",
  "页面.岗位.高中": "មធ្យមសិក្សា",
  "页面.岗位.高棉语标签": "ខ្មែរ (km_KH)",
  "页面.岗位分组配置.一级组名称": "ឈ្មោះក្រុមកម្រិតលើ",
  "页面.岗位分组配置.一级组集合": "បណ្តុំកម្រិតលើ",
  "页面.岗位分组配置.关联工种": "ក្រុមការងារពាក់ព័ន្ធ",
  "页面.岗位分组配置.关联工种最多5个": "អាចជ្រើសរើសក្រុមការងារពាក់ព័ន្ធបានច្រើនបំផុត 5",
  "页面.岗位分组配置.关联工种说明": "ជ្រើសបានតែក្រុមរង ច្រើនបំផុត 5",
  "页面.岗位分组配置.子级组列表": "បញ្ជីក្រុមរង",
  "页面.岗位分组配置.子级组名称": "ឈ្មោះក្រុមរង",
  "页面.岗位分组配置.子级组集合": "បណ្តុំក្រុមរង",
  "页面.岗位分组配置.子级组集合ID": "ID បណ្តុំក្រុមរង",
  "页面.岗位分组配置.子级组集合ID不能为空": "ID បណ្តុំក្រុមរងមិនអាចទុកទទេបាន",
  "页面.岗位分组配置.子级组集合ID不能重复": "ID បណ្តុំក្រុមរងមិនអាចស្ទួនបានទេ",
  "页面.岗位分组配置.子级组集合为空说明": "មិនមានស្លាកសម្រាប់ជ្រើសរើសក្រោមកម្រិតលើបច្ចុប្បន្នទេ។ សូមជ្រើសរើសស្លាកកម្រិតលើដែលមានស្លាកកូន។",
  "页面.岗位分组配置.子级组集合只允许来自一级组集合的子集": "ID បណ្តុំក្រុមរងត្រូវតែជ្រើសពីស្លាកកូននៃបណ្តុំកម្រិតលើដែលបានជ្រើសរើស",
  "页面.岗位分组配置.子级集合为空说明": "មិនមានស្លាកសម្រាប់ជ្រើសរើសក្រោមកម្រិតលើបច្ចុប្បន្នទេ។ សូមជ្រើសរើសស្លាកកម្រិតលើដែលមានស្លាកកូន។",
  "页面.岗位分组配置.岗位分组配置管理": "ការកំណត់ក្រុមការងារ",
  "页面.岗位分组配置.排序": "លំដាប់",
  "页面.岗位分组配置.排序顺序说明": "លេខតូចជាង = លំដាប់ខ្ពស់ជាង",
  "页面.岗位分组配置.数据已同步服务端提示": "ការកំណត់ត្រូវបានរក្សាទុកនៅម៉ាស៊ីនមេ និងផ្ទៀងផ្ទាត់ជាមួយស្លាកការងារ។",
  "页面.岗位分组配置.新增一级组": "បន្ថែមក្រុមកម្រិតលើ",
  "页面.岗位分组配置.是否热门": "ពេញនិយម",
  "页面.岗位分组配置.添加子级组": "បន្ថែមក្រុមរង",
  "页面.岗位分组配置.热门": "ពេញនិយម",
  "页面.岗位分组配置.热门排序": "លំដាប់ពេញនិយម",
  "页面.岗位分组配置.热门排序说明": "លេខតូចជាង = ខ្ពស់ជាង ក្នុងបញ្ជីពេញនិយមប៉ុណ្ណោះ",
  "页面.岗位分组配置.状态": "ស្ថានភាព",
  "页面.岗位分组配置.确认删除该配置": "តើអ្នកប្រាកដថាចង់លុបការកំណត់ក្រុមការងារនេះឬ?",
  "页面.岗位分组配置.编辑一级组": "កែសម្រួលក្រុមកម្រិតលើ",
  "页面.岗位分组配置.请至少添加一个子级组": "សូមបន្ថែមក្រុមរងយ៉ាងហោចណាស់មួយ",
  "页面.岗位分组配置.请输入一级组名称": "បញ្ចូលឈ្មោះក្រុមកម្រិតលើ",
  "页面.岗位分组配置.请输入子级组名称": "បញ្ចូលឈ្មោះក្រុមរង",
  "页面.岗位分组配置.请输入排序": "សូមបញ្ចូលលំដាប់",
  "页面.岗位分组配置.请输入热门排序": "សូមបញ្ចូលលំដាប់ពេញនិយម",
  "页面.岗位分组配置.请选择一级组集合": "សូមជ្រើសរើសបណ្តុំកម្រិតលើ",
  "页面.岗位分组配置.请选择关联工种": "សូមជ្រើសរើសក្រុមការងារពាក់ព័ន្ធ",
  "页面.岗位分组配置.请选择子级组集合": "សូមជ្រើសរើសបណ្តុំក្រុមរង",
  "页面.岗位分组配置.请选择子级组集合ID": "សូមជ្រើសរើស ID បណ្តុំក្រុមរង",
  "页面.岗位分组配置.非热门": "មិនពេញនិយម",
  "页面.岗位生成.CamHR": "CamHR",
  "页面.岗位生成.config_category_id": "ID ប្រភេទ",
  "页面.岗位生成.config_category_name": "ឈ្មោះប្រភេទ",
  "页面.岗位生成.config_entity_id": "ID អង្គភាព",
  "页面.岗位生成.config_entity_name": "ឈ្មោះអង្គភាព",
  "页面.岗位生成.Dashboard.一级汇总": "សង្ខេបប្រភព",
  "页面.岗位生成.Dashboard.不通过原因分布": "មូលហេតុបដិសេធ",
  "页面.岗位生成.Dashboard.任务失败率": "អត្រាបរាជ័យកិច្ចការ",
  "页面.岗位生成.Dashboard.任务失败率说明": "បរាជ័យ/(ជោគជ័យ+បរាជ័យ)",
  "页面.岗位生成.Dashboard.任务完成率": "អត្រាបញ្ចប់កិច្ចការ",
  "页面.岗位生成.Dashboard.任务完成率说明": "(ជោគជ័យ+បរាជ័យ)/សរុប",
  "页面.岗位生成.Dashboard.任务成功率": "អត្រាជោគជ័យកិច្ចការ",
  "页面.岗位生成.Dashboard.任务成功率说明": "ជោគជ័យ/(ជោគជ័យ+បរាជ័យ)",
  "页面.岗位生成.Dashboard.任务级未创建原因": "មូលហេតុរំលងកម្រិតកិច្ចការ",
  "页面.岗位生成.Dashboard.任务级未创建原因说明": "មូលហេតុគ្មានចន្លោះការងារ",
  "页面.岗位生成.Dashboard.任务维度统计": "ស្ថិតិកិច្ចការ",
  "页面.岗位生成.Dashboard.任务进行中占比": "ភាគរយកិច្ចការកំពុងដំណើរការ",
  "页面.岗位生成.Dashboard.任务进行中占比说明": "(រង់ចាំ+ដំណើរការ)/សរុប",
  "页面.岗位生成.Dashboard.入口名称": "ឈ្មោះអង្គភាព",
  "页面.岗位生成.Dashboard.入口按钮": "ផ្ទាំងទិន្នន័យ",
  "页面.岗位生成.Dashboard.全部外部": "ខាងក្រៅទាំងអស់",
  "页面.岗位生成.Dashboard.全量暂无数据": "គ្មានទិន្នន័យ",
  "页面.岗位生成.Dashboard.全量查询等待提示": "ការស្វែងរកទិន្នន័យពេញអាចយូរ សូមរង់ចាំ…",
  "页面.岗位生成.Dashboard.创建异常条数": "ធាតុបង្កើតបរាជ័យ",
  "页面.岗位生成.Dashboard.创建异常条数说明": "ធាតុបង្កើតបរាជ័យ",
  "页面.岗位生成.Dashboard.占比": "ភាគរយ",
  "页面.岗位生成.Dashboard.场景1": "សង្ខេបមួយវិមាត្រ",
  "页面.岗位生成.Dashboard.场景2": "ពេញតាមប្រភព/អង្គភាព",
  "页面.岗位生成.Dashboard.实际创建岗位数": "ការងារដែលបង្កើតជាក់ស្តែង",
  "页面.岗位生成.Dashboard.实际创建岗位数说明": "ផលបូក ID ការងារបង្កើតក្នុងមួយកិច្ចការ",
  "页面.岗位生成.Dashboard.审核不通过": "បដិសេធ",
  "页面.岗位生成.Dashboard.审核通过": "អនុម័ត",
  "页面.岗位生成.Dashboard.审核通过率": "អត្រាអនុម័ត",
  "页面.岗位生成.Dashboard.岗位创建率": "អត្រាបង្កើតការងារ",
  "页面.岗位生成.Dashboard.岗位创建率说明": "ការងារបង្កើត/ចំនួនភារកិច្ច",
  "页面.岗位生成.Dashboard.岗位条创建异常率": "អត្រាកំហុសបង្កើតធាតុ",
  "页面.岗位生成.Dashboard.岗位条创建异常率说明": "creation_failed/ចន្លោះសរុប",
  "页面.岗位生成.Dashboard.岗位条创建转化率": "អត្រាប្តូរធាតុ→ការងារ",
  "页面.岗位生成.Dashboard.岗位条创建转化率说明": "បង្កើត/ចន្លោះសរុប",
  "页面.岗位生成.Dashboard.岗位条结果排行": "ចំណាត់ថ្នាក់លទ្ធផលធាតុ",
  "页面.岗位生成.Dashboard.岗位条维度统计": "ស្ថិតិធាតុការងារ",
  "页面.岗位生成.Dashboard.已创建岗位审核": "ពិនិត្យការងារបង្កើត",
  "页面.岗位生成.Dashboard.已创建条数": "ធាតុបង្កើត",
  "页面.岗位生成.Dashboard.已创建条数说明": "ធាតុដែលក្លាយជាការងារ",
  "页面.岗位生成.Dashboard.平均每任务创建岗位数": "មធ្យមការងារក្នុង 1 កិច្ចការ",
  "页面.岗位生成.Dashboard.平均每任务创建岗位数说明": "បង្កើតសរុប/កិច្ចការសរុប",
  "页面.岗位生成.Dashboard.平均每任务解析岗位条": "មធ្យមធាតុវិភាគក្នុងមួយកិច្ចការ",
  "页面.岗位生成.Dashboard.平均每任务解析岗位条说明": "ចន្លោះសរុប/កិច្ចការសរុប",
  "页面.岗位生成.Dashboard.开始查询": "ស្វែងរក",
  "页面.岗位生成.Dashboard.弹窗标题": "ខាងក្រៅ · ផ្ទាំងទិន្នន័យការងារ",
  "页面.岗位生成.Dashboard.待审": "រង់ចាំពិនិត្យ",
  "页面.岗位生成.Dashboard.总任务数": "កិច្ចការសរុប",
  "页面.岗位生成.Dashboard.总任务数说明": "កិច្ចការសរុបក្នុងជួរពេលនិងប្រភព",
  "页面.岗位生成.Dashboard.总岗位槽位数": "ចន្លោះការងារសរុប",
  "页面.岗位生成.Dashboard.总岗位槽位数说明": "ផលបូកធាតុការងារពីកិច្ចការទាំងអស់",
  "页面.岗位生成.Dashboard.成功任务中已创建占比": "ភាគរយកិច្ចការជោគជ័យយ៉ាងហោច 1",
  "页面.岗位生成.Dashboard.成功任务中已创建占比说明": "created/success",
  "页面.岗位生成.Dashboard.成功任务中未创建占比": "ភាគរយកិច្ចការជោគជ័យគ្មានការងារ",
  "页面.岗位生成.Dashboard.成功任务中未创建占比说明": "skipped/success",
  "页面.岗位生成.Dashboard.按数据源分组": "ចំណាត់ថ្នាក់តាមប្រភព",
  "页面.岗位生成.Dashboard.按状态分布": "តាមស្ថានភាព",
  "页面.岗位生成.Dashboard.按状态分布说明": "រង់ចាំ/ដំណើរការ/ជោគជ័យ/បរាជ័យ",
  "页面.岗位生成.Dashboard.按结果类型分布": "តាមប្រភេទលទ្ធផល",
  "页面.岗位生成.Dashboard.按结果类型分布说明": "បង្កើត/រំលង/បរាជ័យ",
  "页面.岗位生成.Dashboard.数据源池": "អាងប្រភព",
  "页面.岗位生成.Dashboard.数据源池说明": "ទទេ=ទាំងអស់",
  "页面.岗位生成.Dashboard.数据源维度": "ប្រភពទិន្នន័យ",
  "页面.岗位生成.Dashboard.数据源维度说明": "ចម្រោះតាមឆានែល",
  "页面.岗位生成.Dashboard.数据统计时间": "ពេលវេលាស្ថិតិ",
  "页面.岗位生成.Dashboard.时间区间": "ជួរពេល",
  "页面.岗位生成.Dashboard.时间区间说明": "ស្ថិតិកិច្ចការក្នុងរយៈពេលនេះ",
  "页面.岗位生成.Dashboard.暂无排行数据": "គ្មានទិន្នន័យចំណាត់ថ្នាក់",
  "页面.岗位生成.Dashboard.未创建原因细分": "រំលងតាមមូលហេតុ",
  "页面.岗位生成.Dashboard.未创建原因细分说明": "ចំនួនតាមកូដមូលហេតុ",
  "页面.岗位生成.Dashboard.未创建岗位条占比": "ភាគរយធាតុមិនបានបង្កើត",
  "页面.岗位生成.Dashboard.未创建岗位条占比说明": "មិនបានបង្កើត/សរុប",
  "页面.岗位生成.Dashboard.未创建岗位条数": "ចំនួនធាតុមិនបានបង្កើត",
  "页面.岗位生成.Dashboard.未创建岗位条数说明": "សរុប - បានបង្កើត - បរាជ័យ",
  "页面.岗位生成.Dashboard.条入口": " អង្គភាព",
  "页面.岗位生成.Dashboard.查看看板": "មើលផ្ទាំង",
  "页面.岗位生成.Dashboard.查询条件": "លក្ខខណ្ឌ",
  "页面.岗位生成.Dashboard.核心概览": "ទិដ្ឋភាពស្នូល",
  "页面.岗位生成.Dashboard.每已完成任务创建岗位数": "ការងារក្នុងមួយកិច្ចការបានបញ្ចប់",
  "页面.岗位生成.Dashboard.每已完成任务创建岗位数说明": "ការងារសរុប/(ជោគជ័យ+បរាជ័យ)",
  "页面.岗位生成.Dashboard.绝对值": "ចំនួន",
  "页面.岗位生成.Dashboard.自定义": "ផ្ទាល់ខ្លួន",
  "页面.岗位生成.Dashboard.获取失败": "ផ្ទុកផ្ទាំងបរាជ័យ",
  "页面.岗位生成.Dashboard.请选择时间": "ជ្រើសរើសជួរពេល",
  "页面.岗位生成.Dashboard.转化率与漏斗": "អត្រាប្តូរ",
  "页面.岗位生成.Dashboard.选择条件": "ជ្រើសរើសលក្ខខណ្ឌ",
  "页面.岗位生成.Dashboard.页面标题": "ផ្ទាំងទិន្នន័យការងារ",
  "页面.岗位生成.entity_type": "ប្រភេទអង្គភាព",
  "页面.岗位生成.entity_url": "ភ្ជាប់អង្គភាព",
  "页面.岗位生成.Facebook": "Facebook",
  "页面.岗位生成.LLM原始响应": "LLM raw",
  "页面.岗位生成.LLM原始响应说明": "LLM raw",
  "页面.岗位生成.source_label": "ឈ្មោះប្រភព",
  "页面.岗位生成.TG": "TG",
  "页面.岗位生成.任务ID说明": "ID កិច្ចការ",
  "页面.岗位生成.任务创建时间": "បង្កើតនៅ",
  "页面.岗位生成.任务级原因码": "កូដមូលហេតុកម្រិតកិច្ចការ",
  "页面.岗位生成.任务队列统计": "ស្ថិតិគណនី",
  "页面.岗位生成.全部": "ទាំងអស់",
  "页面.岗位生成.全部外部": "ខាងក្រៅទាំងអស់",
  "页面.岗位生成.全部外部数据源": "ខាងក្រៅទាំងអស់",
  "页面.岗位生成.其他": "ផ្សេងទៀត",
  "页面.岗位生成.刷新": "ធ្វើឱ្យស្រស់",
  "页面.岗位生成.原因码": "កូដមូលហេតុ",
  "页面.岗位生成.原因码.all_format_validation_failed": "ការផ្ទៀងផ្ទាត់ទម្រង់បរាជ័យ",
  "页面.岗位生成.原因码.all_jd_creation_failed": "ការបង្កើត JD បរាជ័យ",
  "页面.岗位生成.原因码.content_irrelevant": "មាតិកាមិនពាក់ព័ន្ធ",
  "页面.岗位生成.原因码.creation_failed": "បង្កើតបរាជ័យ",
  "页面.岗位生成.原因码.duplicate": "ការងារស្ទួន",
  "页面.岗位生成.原因码.format_validation_failed": "ការផ្ទៀងផ្ទាត់ទម្រង់បរាជ័យ",
  "页面.岗位生成.原因码.missing_contact_phone": "ខ្វះទូរស័ព្ទ",
  "页面.岗位生成.原因码.missing_location": "ខ្វះទីតាំង",
  "页面.岗位生成.原因码.missing_title": "ខ្វះចំណងជើង",
  "页面.岗位生成.原因码.no_jobs_extracted": "គ្មានការងារដកយក",
  "页面.岗位生成.原因码.salary_max_invalid": "ប្រាក់ខែអតិបរមាមិនត្រឹមត្រូវ",
  "页面.岗位生成.原因码.salary_min_invalid": "ប្រាក់ខែអប្បបរមាត្រូវ≥0",
  "页面.岗位生成.原因码.salary_negative": "ជួរប្រាក់ខែមិនអវិជ្ជមាន",
  "页面.岗位生成.原因码.salary_range_invalid": "ជួរប្រាក់ខែមិនត្រឹមត្រូវ",
  "页面.岗位生成.原因码.salary_type_invalid": "ប្រាក់ខែត្រូវជាលេខ",
  "页面.岗位生成.原因码.title_length_invalid": "រយៈចំណងជើងមិនត្រឹមត្រូវ",
  "页面.岗位生成.原因码.unknown": "មិនស្គាល់",
  "页面.岗位生成.原因码分组.任务级": "កម្រិតកិច្ចការ",
  "页面.岗位生成.原因码分组.单条岗位": "ការងារតែមួយ",
  "页面.岗位生成.原因码分组.质量去重": "គុណភាព/ដកចេញស្ទួន",
  "页面.岗位生成.原因码占位": "វាយបញ្ចូលកូដ",
  "页面.岗位生成.后台创建": "បង្កើតដោយគ្រប់គ្រង",
  "页面.岗位生成.外部": "ខាងក្រៅ",
  "页面.岗位生成.外部数据源": "ខាងក្រៅ",
  "页面.岗位生成.外部数据源渠道": "ប្រភពខាងក្រៅ",
  "页面.岗位生成.岗位ID说明": "ID ការងារដែលបង្កើត",
  "页面.岗位生成.岗位明细": "ព័ត៌មានធាតុ",
  "页面.岗位生成.已创建岗位": "បានបង្កើតការងារ",
  "页面.岗位生成.并发": "ប្រកាស",
  "页面.岗位生成.开始时间": "ពេលចាប់ផ្តើម",
  "页面.岗位生成.待执行": "រង់ចាំ",
  "页面.岗位生成.总计": "សរុប",
  "页面.岗位生成.我创建的": "បង្កើតដោយខ្ញុំ",
  "页面.岗位生成.我创建的说明": "តែកិច្ចការរបស់ខ្ញុំ",
  "页面.岗位生成.执行中": "កំពុងដំណើរការ",
  "页面.岗位生成.执行失败": "បរាជ័យ",
  "页面.岗位生成.执行开始时间": "ពេលចាប់ផ្តើម",
  "页面.岗位生成.执行异常": "កំហុស",
  "页面.岗位生成.执行成功": "ជោគជ័យ",
  "页面.岗位生成.执行结束时间": "ពេលបញ្ចប់",
  "页面.岗位生成.批次ID": "ID ក្រុម",
  "页面.岗位生成.批次ID说明": "ID ក្រុម",
  "页面.岗位生成.按任务状态筛选": "ចម្រោះតាមស្ថានភាព",
  "页面.岗位生成.按原因码筛选": "ចម្រោះតាមកូដមូលហេតុ",
  "页面.岗位生成.按数据源筛选": "ចម្រោះតាមប្រភព",
  "页面.岗位生成.按结果类型筛选": "ចម្រោះតាមប្រភេទ",
  "页面.岗位生成.数据源": "ប្រភពទិន្នន័យ",
  "页面.岗位生成.数据源信息": "ព័ត៌មានប្រភព",
  "页面.岗位生成.无": "គ្មាន",
  "页面.岗位生成.暂无数据": "គ្មានទិន្នន័យ",
  "页面.岗位生成.有": "មាន",
  "页面.岗位生成.未创建不符合": "រំលង",
  "页面.岗位生成.来源": "ប្រភព",
  "页面.岗位生成.来源说明": "ប្រភពកិច្ចការ",
  "页面.岗位生成.槽位": "ចន្លោះ",
  "页面.岗位生成.状态": "ស្ថានភាព",
  "页面.岗位生成.状态说明": "ស្ថានភាពកិច្ចការ",
  "页面.岗位生成.结束时间": "ពេលបញ្ចប់",
  "页面.岗位生成.结果原因": "មូលហេតុលទ្ធផល",
  "页面.岗位生成.结果原因说明": "កូដមូលហេតុ",
  "页面.岗位生成.结果类型": "ប្រភេទលទ្ធផល",
  "页面.岗位生成.结果类型说明": "ប្រភេទលទ្ធផល",
  "页面.岗位生成.自动刷新": "ធ្វើឱ្យស្រស់ដោយស្វ័យប្រវត្តិ",
  "页面.岗位生成.获取队列统计失败": "ផ្ទុកស្ថិតិបរាជ័យ",
  "页面.岗位生成.请选择数据源": "ជ្រើសរើសប្រភព",
  "页面.岗位生成.请选择状态": "ជ្រើសរើសស្ថានភាព",
  "页面.岗位生成.请选择结果类型": "ជ្រើសរើសប្រភេទលទ្ធផល",
  "页面.岗位生成.运营后台": "គ្រប់គ្រង",
  "页面.岗位生成.错误信息": "សារកំហុស",
  "页面.岗位生成.错误信息说明": "សារកំហុស",
  "页面.岗位生成.队列": "ជួរ",
  "页面.岗位黑名单.作用字段": "វាល",
  "页面.岗位黑名单.保存失败": "រក្សាទុកបរាជ័យ",
  "页面.岗位黑名单.关键词": "ពាក្យគន្លឹះ",
  "页面.岗位黑名单.关键词占位": "ស្វែងរកមាតិកា",
  "页面.岗位黑名单.内容占位": "លេខទូរស័ព្ទមួយ ឬ Telegram មួយ ឬឈ្មោះក្រុមហ៊ុនមួយ",
  "页面.岗位黑名单.内容字段说明": "មួយតម្លៃក្នុងមួយលើក; ផ្គូផ្គងពេញលេញបន្ទាប់ពីបញ្ចូលទម្រង់។ បំបែកលេខច្រើនជាច្បាប់ដាច់ដោយឡែក។ មិនគាំទ្រ t.me/+។",
  "页面.岗位黑名单.创建失败": "បង្កើតបរាជ័យ",
  "页面.岗位黑名单.创建成功建议预览": "បានបង្កើត។ សូមមើលផ្គូផ្គងមុនបើក។",
  "页面.岗位黑名单.删除": "លុប",
  "页面.岗位黑名单.删除失败": "លុបបរាជ័យ",
  "页面.岗位黑名单.删除失败重试": "លុបបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位黑名单.加载中": "កំពុងផ្ទុក…",
  "页面.岗位黑名单.加载配置失败": "ផ្ទុកបរាជ័យ",
  "页面.岗位黑名单.包含已软删岗位": "រួមបញ្ចូលការងារបានលុបទន់",
  "页面.岗位黑名单.启用": "បើកច្បាប់",
  "页面.岗位黑名单.启用状态": "បើក",
  "页面.岗位黑名单.命中数量": "ចំនួនការងារផ្គូផ្គង",
  "页面.岗位黑名单.命中条数": "ចំនួន",
  "页面.岗位黑名单.命中记录": "កំណត់ត្រាផ្គូផ្គង",
  "页面.岗位黑名单.填写说明简": "មួយតម្លៃក្នុងមួយច្បាប់។ លេខទូរស័ព្ទច្រើន បំបែកជាច្រើនច្បាប់។ Telegram៖ t.me ឬ @ — មិនគាំទ្រ t.me/+។",
  "页面.岗位黑名单.填写说明链": "របៀបបំពេញ",
  "页面.岗位黑名单.备注": "កំណត់សម្គាល់",
  "页面.岗位黑名单.备注清空说明": "ទុកចោល រួចរក្សាទុកដើម្បីលុបកំណត់សម្គាល់",
  "页面.岗位黑名单.字段.企业名称": "ឈ្មោះក្រុមហ៊ុន",
  "页面.岗位黑名单.字段.联系电话": "ទូរស័ព្ទ",
  "页面.岗位黑名单.字段.飞机号": "Telegram",
  "页面.岗位黑名单.岗位ID占位": "ID ការងារត្រឹមត្រូវ",
  "页面.岗位黑名单.岗位侧归一化值": "តម្លៃបន្ទាប់ពីបញ្ចូលទម្រង់",
  "页面.岗位黑名单.已保存": "បានរក្សាទុក",
  "页面.岗位黑名单.已停用": "បិទ",
  "页面.岗位黑名单.已删除": "បានលុប",
  "页面.岗位黑名单.已启用": "បើក",
  "页面.岗位黑名单.归一化比对值": "តម្លៃបញ្ចូលទម្រង់",
  "页面.岗位黑名单.操作": "សកម្មភាព",
  "页面.岗位黑名单.新建内容占位": "[របៀបបំពេញ — បញ្ចូលតម្លៃតែមួយដែលត្រូវរារាំង]\n\n① មួយតម្លៃប៉ុណ្ណោះ។ លេខច្រើន / Telegram ច្រើន / ឈ្មោះក្រុមហ៊ុនច្រើន → បង្កើតច្បាប់ដាច់ដោយឡែក។\n② ទូរស័ព្ទ៖ + គម្លាត - បាន។ កុំប្រើ / ឬ | ភ្ជាប់លេខច្រើន។\n③ Telegram៖ https://t.me/xxx ឬ @xxx — មិនគាំទ្រ t.me/+។\n④ ឈ្មោះក្រុមហ៊ុន៖ ផ្គូផ្គងពេញលេញ — កុំផ្សំពីរឈ្មោះក្នុងក្រឡាតែមួយ។\n⑤ បន្ទាប់ពីរក្សាទុក បញ្ចូលទម្រង់ជាមួយវាលការងារ ត្រូវតែត្រូវគ្នាពេញលេញ។",
  "页面.岗位黑名单.新建内容标签附注": "អានការណែនាំក្នុងប្រអប់ រួចបញ្ចូលតម្លៃមួយ",
  "页面.岗位黑名单.新建配置": "បន្ថែម",
  "页面.岗位黑名单.是否立即预览": "មើលចំនួនផ្គូផ្គងឥឡូវ?",
  "页面.岗位黑名单.更新失败": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ",
  "页面.岗位黑名单.更新失败重试": "ធ្វើបច្ចុប្បន្នភាពបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.岗位黑名单.状态已更新": "បានធ្វើបច្ចុប្បន្នភាព",
  "页面.岗位黑名单.确认删除配置": "លុបការកំណត់នេះ?",
  "页面.岗位黑名单.示例岗位": "ឧទាហរណ៍ ID ការងារ",
  "页面.岗位黑名单.示例条数": "គំរូអតិបរមា",
  "页面.岗位黑名单.筛选岗位ID": "ID ការងារ",
  "页面.岗位黑名单.编辑": "កែ",
  "页面.岗位黑名单.编辑配置": "កែការកំណត់",
  "页面.岗位黑名单.规则ID": "លេខច្បាប់",
  "页面.岗位黑名单.记录ID": "លេខកំណត់ត្រាផ្គូផ្គង",
  "页面.岗位黑名单.请填写内容": "សូមបញ្ចូលមាតិកា",
  "页面.岗位黑名单.配置ID": "លេខសម្គាល់",
  "页面.岗位黑名单.配置内容": "មាតិកា",
  "页面.岗位黑名单.配置列表": "ការកំណត់",
  "页面.岗位黑名单.配置原文": "អត្ថបទដើម",
  "页面.岗位黑名单.重新统计": "គណនាឡើងវិញ",
  "页面.岗位黑名单.页面标题": "បញ្ជីខ្មៅការងារ",
  "页面.岗位黑名单.预览命中": "មើលផ្គូផ្គង",
  "页面.岗位黑名单.预览失败": "មើលមុនបរាជ័យ",
  "页面.岗位黑名单.预览失败重试": "មើលមុនបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.工种搜索反馈.匿名ID": "ID អនាមិក",
  "页面.工种搜索反馈.处理": "ដំណើរការ",
  "页面.工种搜索反馈.处理反馈": "ដំណើរការមតិ",
  "页面.工种搜索反馈.处理成功": "បានធ្វើបច្ចុប្បន្នភាព",
  "页面.工种搜索反馈.处理状态": "ស្ថានភាពដំណើរការ",
  "页面.工种搜索反馈.已处理": "បានដំណើរការ",
  "页面.工种搜索反馈.已忽略": "បានមិនអើពើ",
  "页面.工种搜索反馈.平台": "វេទិកា",
  "页面.工种搜索反馈.待处理": "កំពុងរង់ចាំ",
  "页面.工种搜索反馈.提交时间": "ពេលដាក់ស្នើ",
  "页面.工种搜索反馈.搜索词": "ពាក្យស្វែងរក",
  "页面.工种搜索反馈.操作": "សកម្មភាព",
  "页面.工种搜索反馈.来源页面": "ទំព័រប្រភព",
  "页面.工种搜索反馈.状态": "ស្ថានភាព",
  "页面.工种搜索反馈.用户ID": "ID អ្នកប្រើ",
  "页面.工种搜索反馈.语言": "ភាសា",
  "页面.工种搜索反馈.运营备注": "កំណត់សម្គាល់ប្រតិបត្តិការ",
  "页面.工种搜索反馈.页面标题": "មតិស្វែងរកការងារ",
  "页面.布局.用户布局标题": "វេទិកាជ្រើសរើសជំនាន់ថ្មីដែលដំណើរការដោយ AI",
  "页面.推送测试.App版本": "កំណែ App",
  "页面.推送测试.Facebook不符合条件": "អ្នកប្រើនេះមិនអាចទទួលការជូនដំណឹងសាកល្បង Facebook បានទេ",
  "页面.推送测试.Facebook仅Push说明": "មិនកំណត់ Facebook App ID ទេ។ របៀបនេះសាកល្បងតែការទទួលការជូនដំណឹង និងការបើក App ប៉ុណ្ណោះ ហើយមិនបង្កើតលក្ខខណ្ឌសាកល្បងផ្ទាំង ឬបើកទំព័រគណនីភាគីទីបីដោយផ្ទាល់ទេ។",
  "页面.推送测试.Facebook仅最新设备": "ដូចកិច្ចការផ្លូវការ ការមើលជាមុនជ្រើសតែឧបករណ៍សកម្មចុងក្រោយមួយ។",
  "页面.推送测试.Facebook原因.已迁移": "អត្តសញ្ញាណ Facebook បានប្តូរទៅ App ID បច្ចុប្បន្នរួចហើយ។",
  "页面.推送测试.Facebook原因.无设备": "អ្នកប្រើមិនមានឧបករណ៍ជូនដំណឹងចល័តសកម្មទេ។",
  "页面.推送测试.Facebook原因.无身份": "រកមិនឃើញអត្តសញ្ញាណ Facebook សកម្ម ឬមិនអាចទាក់ទងអ្នកប្រើបាន។",
  "页面.推送测试.Facebook原因.未知": "ការផ្ទៀងផ្ទាត់លក្ខខណ្ឌមិនបានឆ្លងកាត់។",
  "页面.推送测试.Facebook完整联调说明": "មិនកំណត់ Facebook App ID ទេ។ ពេលផ្ញើ ប្រព័ន្ធនឹងបើកវគ្គសាកល្បងដាច់ដោយឡែក 24 ម៉ោងសម្រាប់អត្តសញ្ញាណមិនចាស់ ដើម្បីសាកល្បងផ្ទាំង និងការចូល ដោយមិនកែ provider_tenant ពិត។",
  "页面.推送测试.Facebook当前Tenant": "Tenant បច្ចុប្បន្ន",
  "页面.推送测试.Facebook正式规则说明": "កិច្ចការផ្លូវការម៉ោង 17:00 នៅតែផ្ញើតែទៅ Facebook tenant ចាស់។ ទំព័រនេះដាច់ដោយឡែកពីក្រុមគោលដៅ និងកម្រិតប្រចាំថ្ងៃផ្លូវការ។",
  "页面.推送测试.Facebook正式资格": "លក្ខខណ្ឌអត្តសញ្ញាណចាស់ពិត",
  "页面.推送测试.Facebook测试模式": "របៀបសាកល្បង",
  "页面.推送测试.Facebook测试模式.仅Push": "សាកល្បងតែការទទួល Push",
  "页面.推送测试.Facebook测试模式.完整联调": "សាកល្បងការអនុញ្ញាតឡើងវិញពេញលេញ (ណែនាំ)",
  "页面.推送测试.Facebook测试轮次": "វគ្គសាកល្បងដាច់ដោយឡែក / ផុតកំណត់",
  "页面.推送测试.Facebook真实发送提醒": "សូមមើលលក្ខខណ្ឌជាមុន។ ការផ្ញើពិតជូនដំណឹងភ្លាមៗតែទៅឧបករណ៍សកម្មចុងក្រោយដែលបានជ្រើស។",
  "页面.推送测试.Facebook确认发送说明": "ការជូនដំណឹងនឹងផ្ញើទៅឧបករណ៍សកម្មចុងក្រោយរបស់អ្នកប្រើ និងកត់ត្រាជាការសាកល្បងដាច់ដោយឡែក។ វាមិនប្រើកម្រិតផ្ញើប្រចាំថ្ងៃផ្លូវការទេ។",
  "页面.推送测试.Facebook确认发送说明.仅Push": "ការជូនដំណឹងនឹងផ្ញើទៅឧបករណ៍សកម្មចុងក្រោយដោយមិនបង្កើតវគ្គសាកល្បង។ វាផ្ទៀងផ្ទាត់តែការទទួល Push និងការបើក App ប៉ុណ្ណោះ។ បើមិនត្រូវការអនុញ្ញាតឡើងវិញ នឹងមិនបង្ហាញផ្ទាំង ឬបើកទំព័រទេ។",
  "页面.推送测试.Facebook确认发送说明.完整联调": "ការជូនដំណឹងនឹងផ្ញើទៅឧបករណ៍សកម្មចុងក្រោយ។ សម្រាប់អ្នកប្រើដែលមិនមែន App ID ចាស់ ប្រព័ន្ធនឹងបើកវគ្គសាកល្បងដាច់ដោយឡែក ហើយការបញ្ចប់មិនកែអត្តសញ្ញាណ Facebook ពិតទេ។",
  "页面.推送测试.Facebook符合条件": "អ្នកប្រើនេះអាចទទួលការជូនដំណឹងសាកល្បង Facebook",
  "页面.推送测试.Facebook结束轮次": "បញ្ចប់វគ្គសាកល្បង",
  "页面.推送测试.Facebook结束轮次成功": "វគ្គសាកល្បងត្រូវបានបញ្ចប់។",
  "页面.推送测试.Facebook结束轮次确认": "បញ្ចប់វគ្គសាកល្បងបច្ចុប្បន្ន?",
  "页面.推送测试.Facebook身份Tenant": "Tenant អត្តសញ្ញាណ",
  "页面.推送测试.Facebook运行配置": "ការកំណត់ដំណើរការអនុញ្ញាត Facebook ឡើងវិញ",
  "页面.推送测试.Facebook重新授权": "ការអនុញ្ញាត Facebook ឡើងវិញ",
  "页面.推送测试.Facebook重置轮次": "កំណត់វគ្គសាកល្បងឡើងវិញ",
  "页面.推送测试.Facebook重置轮次成功": "វគ្គសាកល្បងត្រូវបានកំណត់ឡើងវិញ។ សូមមើលជាមុនម្ដងទៀតមុនផ្ញើ។",
  "页面.推送测试.Facebook重置轮次确认": "បញ្ចប់វគ្គបច្ចុប្បន្ន ហើយបង្កើតវគ្គសាកល្បងថ្មីរយៈពេល 24 ម៉ោង?",
  "页面.推送测试.仅预览": "មើលជាមុនប៉ុណ្ណោះ",
  "页面.推送测试.促活策略": "យុទ្ធសាស្ត្រជំរុញសកម្មភាព",
  "页面.推送测试.最近注册": "ចុះឈ្មោះចុងក្រោយ",
  "页面.推送测试.功能通知": "ការជូនដំណឹងមុខងារ",
  "页面.推送测试.加载岗位失败": "មិនអាចផ្ទុកការងារបាន",
  "页面.推送测试.加载选项失败": "មិនអាចផ្ទុកជម្រើសការជូនដំណឹងបាន",
  "页面.推送测试.匿名用户": "អ្នកប្រើអនាមិក",
  "页面.推送测试.匿名用户ID": "លេខសម្គាល់អនាមិក",
  "页面.推送测试.参数.企业ID": "លេខសម្គាល់ក្រុមហ៊ុន",
  "页面.推送测试.参数.会话ID": "លេខសម្គាល់ការសន្ទនា",
  "页面.推送测试.参数.岗位": "ការងារ",
  "页面.推送测试.参数.工作经历ID": "លេខសម្គាល់បទពិសោធន៍",
  "页面.推送测试.参数.工种": "ប្រភេទការងារ",
  "页面.推送测试.参数.工种名称": "ឈ្មោះប្រភេទការងារ",
  "页面.推送测试.参数.教育经历ID": "លេខសម្គាល់ការអប់រំ",
  "页面.推送测试.参数.来源": "ប្រភព",
  "页面.推送测试.参数.标签页": "ផ្ទាំង",
  "页面.推送测试.参数.模块": "ផ្នែកប្រវត្តិរូប",
  "页面.推送测试.参数.简历ID": "លេខសម្គាល់ប្រវត្តិរូប",
  "页面.推送测试.参数.链接": "តំណ",
  "页面.推送测试.参数必填": "ត្រូវបញ្ចូល {name}",
  "页面.推送测试.发送到设备": "ផ្ញើទៅឧបករណ៍",
  "页面.推送测试.发送失败": "ការផ្ញើបានបរាជ័យ៖ ជោគជ័យ {success} និងបរាជ័យ {failed}។",
  "页面.推送测试.发送成功": "ការផ្ញើបានបញ្ចប់",
  "页面.推送测试.可选设置": "ការកំណត់ជម្រើស",
  "页面.推送测试.合同Profile": "ប្រភេទកិច្ចសន្យា",
  "页面.推送测试.合同版本": "កំណែកិច្ចសន្យា",
  "页面.推送测试.否": "ទេ",
  "页面.推送测试.岗位数量": "ចំនួនការងារ",
  "页面.推送测试.岗位数量说明": "ប្រើសម្រាប់ខ្លឹមសារដែលបង្ហាញចំនួនការងារ។",
  "页面.推送测试.已发送": "បានផ្ញើ",
  "页面.推送测试.投递状态.失败": "បរាជ័យ",
  "页面.推送测试.投递状态.已发送": "បានផ្ញើ",
  "页面.推送测试.投递状态.已跳过": "បានរំលង",
  "页面.推送测试.投递状态.重复": "ស្ទួន",
  "页面.推送测试.投递状态.预览": "មើលជាមុន",
  "页面.推送测试.推送配置": "ការកំណត់ការជូនដំណឹង",
  "页面.推送测试.搜索岗位": "ស្វែងរកការងារដែលបានផ្សព្វផ្សាយ",
  "页面.推送测试.支持路由数": "គាំទ្រផ្លូវ {count}",
  "页面.推送测试.无需额外参数": "ប្រភេទនេះមិនត្រូវការប៉ារ៉ាម៉ែត្របន្ថែមទេ។",
  "页面.推送测试.是": "បាទ/ចាស",
  "页面.推送测试.暂无结果": "បំពេញការកំណត់ ដើម្បីបង្កើតការមើលជាមុន",
  "页面.推送测试.未上报": "មិនបានរាយការណ៍",
  "页面.推送测试.标题正文成对": "ត្រូវបញ្ចូលចំណងជើង និងខ្លឹមសារជាមួយគ្នា",
  "页面.推送测试.模板文案说明": "ទុកចំណងជើង និងខ្លឹមសារទទេ ដើម្បីប្រើគំរូភាសាដែលបានជ្រើស។ បើបញ្ចូល ត្រូវបញ្ចូលទាំងពីរ។",
  "页面.推送测试.消息类型": "ប្រភេទសារ",
  "页面.推送测试.状态": "ស្ថានភាព",
  "页面.推送测试.用户ID": "លេខសម្គាល់អ្នកប្រើ",
  "页面.推送测试.登录用户": "អ្នកប្រើដែលបានចូល",
  "页面.推送测试.目标与内容": "គោលដៅ និងខ្លឹមសារ",
  "页面.推送测试.目标身份": "អត្តសញ្ញាណគោលដៅ",
  "页面.推送测试.真实发送提醒": "ការផ្ញើទៅឧបករណ៍នឹងផ្ញើការជូនដំណឹងពិតភ្លាមៗ។ សូមមើលជាមុន។",
  "页面.推送测试.确认发送": "ផ្ញើឥឡូវនេះ",
  "页面.推送测试.确认发送标题": "បញ្ជាក់ការផ្ញើការជូនដំណឹងពិត?",
  "页面.推送测试.确认发送说明": "ការជូនដំណឹងនឹងត្រូវផ្ញើទៅគ្រប់ឧបករណ៍សកម្ម និងរក្សាទុកកំណត់ត្រា។",
  "页面.推送测试.结果": "លទ្ធផលការផ្ញើ",
  "页面.推送测试.自定义标题": "ចំណងជើងផ្ទាល់ខ្លួន",
  "页面.推送测试.自定义正文": "ខ្លឹមសារផ្ទាល់ខ្លួន",
  "页面.推送测试.角标数量": "ចំនួនផ្លាកសញ្ញា",
  "页面.推送测试.设备合同": "កិច្ចសន្យាឧបករណ៍",
  "页面.推送测试.设备统计": "សង្ខេបឧបករណ៍",
  "页面.推送测试.设备统计值": "សរុប {total} ជោគជ័យ {success} បរាជ័យ {failed}",
  "页面.推送测试.请求失败": "ប្រតិបត្តិការបរាជ័យ។ ពិនិត្យការកំណត់ ហើយសាកល្បងម្តងទៀត។",
  "页面.推送测试.请输入匿名用户ID": "បញ្ចូលលេខសម្គាល់អនាមិក",
  "页面.推送测试.请输入用户ID": "បញ្ចូលលេខសម្គាល់អ្នកប្រើ",
  "页面.推送测试.请选择参数": "ជ្រើស ឬបញ្ចូល {name}",
  "页面.推送测试.请选择消息类型": "ជ្រើសប្រភេទសារ",
  "页面.推送测试.路由参数": "ប៉ារ៉ាម៉ែត្រអាជីវកម្ម",
  "页面.推送测试.路由已降级": "បន្ថយផ្លូវ៖ {requested} → {actual}",
  "页面.推送测试.选择工种": "ជ្រើសប្រភេទការងារ",
  "页面.推送测试.通知ID": "លេខសម្គាល់ការជូនដំណឹង",
  "页面.推送测试.通知ID说明": "ប្រើសម្រាប់ការពារការផ្ញើស្ទួន។ ទុកទទេដើម្បីបង្កើតស្វ័យប្រវត្តិ។",
  "页面.推送测试.通知语言": "ភាសាការជូនដំណឹង",
  "页面.推送测试.部分发送失败": "ការផ្ញើបានជោគជ័យ {success} និងបរាជ័យ {failed}។",
  "页面.推送测试.页面标题": "សាកល្បងការជូនដំណឹង",
  "页面.推送测试.页面说明": "មើលជាមុន និងផ្ញើការជូនដំណឹងពិតទៅអ្នកប្រើ ឬភ្ញៀវអនាមិក។",
  "页面.推送测试.页面路由": "ផ្លូវក្នុងកម្មវិធី",
  "页面.推送测试.预览": "មើលជាមុន",
  "页面.推送测试.预览成功": "បានបង្កើតការមើលជាមុន",
  "页面.查询表格.万": "ពាន់",
  "页面.查询表格.上次调度时间": "ដំណើរការចុងក្រោយ",
  "页面.查询表格.基本信息": "ព័ត៌មានមូលដ្ឋាន",
  "页面.查询表格.已选择": "បានជ្រើស",
  "页面.查询表格.开始时间": "ពេលចាប់ផ្តើម",
  "页面.查询表格.批量删除": "លុបជាក្រុម",
  "页面.查询表格.批量审批": "អនុម័តជាក្រុម",
  "页面.查询表格.描述": "ការពិពណ៌នា",
  "页面.查询表格.操作": "សកម្មភាព",
  "页面.查询表格.新建": "ថ្មី",
  "页面.查询表格.新建规则": "ច្បាប់ថ្មី",
  "页面.查询表格.服务调用次数": "ការហៅសេវា",
  "页面.查询表格.服务调用次数总计": "ការហៅសរុប",
  "页面.查询表格.标题": "តារាងស្វែងរក",
  "页面.查询表格.状态": "ស្ថានភាព",
  "页面.查询表格.状态.关闭": "បិទ",
  "页面.查询表格.状态.已上线": "អនឡាញ",
  "页面.查询表格.状态.异常": "មិនធម្មតា",
  "页面.查询表格.状态.运行中": "កំពុងដំណើរការ",
  "页面.查询表格.监控对象": "វត្ថុ",
  "页面.查询表格.规则名称": "ឈ្មោះច្បាប់",
  "页面.查询表格.规则名称必填": "ឈ្មោះច្បាប់ត្រូវតែបំពេញ",
  "页面.查询表格.规则名称标签": "ឈ្មោះច្បាប់",
  "页面.查询表格.规则描述占位": "យ៉ាងហោចណាស់ 5 តួអក្សរ",
  "页面.查询表格.规则描述必填": "យ៉ាងហោចណាស់ 5 តួអក្សរ!",
  "页面.查询表格.规则描述标签": "ការពិពណ៌នាច្បាប់",
  "页面.查询表格.规则模板": "គំរូ",
  "页面.查询表格.规则类型": "ប្រភេទ",
  "页面.查询表格.规则配置": "ការកំណត់ច្បាប់",
  "页面.查询表格.订阅警报": "ជាវ",
  "页面.查询表格.设定调度周期": "កាលវិភាគ",
  "页面.查询表格.请输入异常原因": "សូមបញ្ចូលមូលហេតុ!",
  "页面.查询表格.请输入规则名称": "សូមបញ្ចូលឈ្មោះច្បាប់!",
  "页面.查询表格.请选择开始时间": "សូមជ្រើសពេលចាប់ផ្តើម!",
  "页面.查询表格.配置": "ការកំណត់",
  "页面.查询表格.配置规则属性": "លក្ខណៈច្បាប់",
  "页面.查询表格.项": "ធាតុ",
  "页面.欢迎.主标题": "សូមស្វាគមន៍មកកាន់ DodoJob គ្រប់គ្រង",
  "页面.欢迎.了解antd": "អំពី Ant Design",
  "页面.欢迎.了解antd描述": "antd គឺជាបណ្ណាល័យ React UI ផ្អែកលើ Ant Design។",
  "页面.欢迎.了解Pro": "អំពី Pro Components",
  "页面.欢迎.了解Pro描述": "ProComponents ផ្តល់កុំព័ង្គគំរូកម្រិតខ្ពស់។",
  "页面.欢迎.了解umi": "អំពី umi",
  "页面.欢迎.了解umi描述": "umi គឺជាក្របគ្រង frontend កម្រិតសហគ្រាស។",
  "页面.欢迎.了解更多": "រៀនបន្ថែម",
  "页面.欢迎.副标题": "DodoJob គ្រប់គ្រងផ្ទះបាយ សង់ដោយ Umi + React + Ant Design Pro។",
  "页面.欢迎.重型组件提示": "កុំព័ង្គទំនើប និងខ្លាំងជាងមុន បានចេញផ្សាយ។",
  "页面.求职用户.3到64字符唯一": "3-64 តួអក្សរ មួយគត់",
  "页面.求职用户.上传时间": "ពេលបង្ហោះ",
  "页面.求职用户.专业": "ជំនាញ",
  "页面.求职用户.个人基础信息": "ព័ត៌មានផ្ទាល់ខ្លួន",
  "页面.求职用户.中文": "ចិន",
  "页面.求职用户.中文能力": "ចិន ≥",
  "页面.求职用户.会员有效期": "រយៈពេលសមាជិកចាស់",
  "页面.求职用户.会员有效期说明": "ប្រើសម្រាប់តែកូតាចាស់។ ធាតុថ្មីប្រើថ្ងៃផុតកំណត់នៃបាច់សិទ្ធិ។",
  "页面.求职用户.会员权益": "សិទ្ធិសមាជិក",
  "页面.求职用户.会员权益更新成功": "បានធ្វើបច្ចុប្បន្នភាពសិទ្ធិសមាជិក",
  "页面.求职用户.会员权益配置说明": "កំណត់បានតែអ្នកប្រើ B។ ការបង្ហោះការងារប្រើធាតុមួយ ហើយការលុបការងារមិនសងធាតុដែលបានប្រើទេ។",
  "页面.求职用户.保存会员权益失败": "រក្សាទុកសិទ្ធិសមាជិកបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.求职用户.全部": "ទាំងអស់",
  "页面.求职用户.全部简历": "ប្រវត្តិរូបទាំងអស់",
  "页面.求职用户.公司": "ក្រុមហ៊ុន",
  "页面.求职用户.公开状态": "ស្ថានភាពផ្សព្វផ្សាយ",
  "页面.求职用户.公开状态说明": "ព្រាង / ដកចេញ / ផ្សព្វផ្សាយ",
  "页面.求职用户.公海未关联": "អាង (មិនបានភ្ជាប់)",
  "页面.求职用户.公海池": "អាងហែលទឹក",
  "页面.求职用户.关键词": "ពាក្យគន្លឹះ",
  "页面.求职用户.关键词搜索": "ពាក្យគន្លឹះ",
  "页面.求职用户.关键词说明": "ឈ្មោះ ណែនាំ ជំនាញ",
  "页面.求职用户.内容摘要说明": "យេនឌ័រ ឈ្មោះ អាយុ ការអប់រំ",
  "页面.求职用户.内容范围": "វិសាលភាពមាតិកា",
  "页面.求职用户.内容范围说明": "ព្រាង / ផ្សព្វផ្សាយ / ទាំងអស់",
  "页面.求职用户.出生年月": "ថ្ងៃកំណើត",
  "页面.求职用户.创建": "បង្កើត",
  "页面.求职用户.创建失败": "បង្កើតបរាជ័យ",
  "页面.求职用户.创建开始时间": "បង្កើតចាប់ពី",
  "页面.求职用户.创建成功": "បង្កើតជោគជ័យ",
  "页面.求职用户.创建时间": "បង្កើតនៅ",
  "页面.求职用户.创建时间标签": "បង្កើតនៅ",
  "页面.求职用户.创建时间说明": "បង្កើតនៅ",
  "页面.求职用户.创建用户": "បង្កើតអ្នកប្រើ",
  "页面.求职用户.创建结束时间": "បង្កើតរហូតដល់",
  "页面.求职用户.加载会员权益失败": "ផ្ទុកសិទ្ធិសមាជិកបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.求职用户.加载求职意向详情": "កំពុងផ្ទុកចំណាប់អារម្មណ៍...",
  "页面.求职用户.加载用户详情": "កំពុងផ្ទុកអ្នកប្រើ...",
  "页面.求职用户.加载简历详情": "កំពុងផ្ទុកប្រវត្តិរូប...",
  "页面.求职用户.原因": "មូលហេតុ",
  "页面.求职用户.发岗上限": "ដែនកំណត់ប្រកាសការងារ",
  "页面.求职用户.发岗上限不能小于已发岗数": "ដែនកំណត់ប្រកាសការងារមិនអាចតិចជាងការងារ {count} ដែលបានបង្កើតរួចទេ",
  "页面.求职用户.发岗上限说明": "ដែនកំណត់បង្កើតការងារសរុបសម្រាប់គណនីនេះ មិនអាចតិចជាងចំនួនដែលបានបង្កើតរួចទេ",
  "页面.求职用户.发布内容": "មាតិកាផ្សព្វផ្សាយ",
  "页面.求职用户.发送岗位加急道具": "ផ្ញើធាតុ Boost ការងារ",
  "页面.求职用户.发送岗位加急道具失败": "ផ្ញើមិនបាន សូមព្យាយាមម្តងទៀត",
  "页面.求职用户.发送岗位加急道具成功": "បានផ្ញើធាតុ Boost ការងារ",
  "页面.求职用户.发送岗位加急道具确认": "ផ្ញើធាតុ Boost ការងារ 1 ទៅ {username} មែនទេ? មានសុពលភាព 30 ថ្ងៃ។",
  "页面.求职用户.发送岗位发布道具": "ផ្ញើធាតុបង្ហោះការងារ",
  "页面.求职用户.发送岗位发布道具失败": "ផ្ញើមិនបាន សូមព្យាយាមម្តងទៀត",
  "页面.求职用户.发送岗位发布道具成功": "បានផ្ញើធាតុបង្ហោះការងារ",
  "页面.求职用户.发送岗位发布道具确认": "ផ្ញើធាតុបង្ហោះការងារ 1 ទៅ {username} មែនទេ? មានសុពលភាព 30 ថ្ងៃ។",
  "页面.求职用户.发送简历联系道具": "ផ្ញើធាតុទាក់ទងប្រវត្តិរូប",
  "页面.求职用户.发送简历联系道具失败": "ផ្ញើមិនបាន សូមព្យាយាមម្តងទៀត",
  "页面.求职用户.发送简历联系道具成功": "បានផ្ញើធាតុទាក់ទងប្រវត្តិរូប",
  "页面.求职用户.发送简历联系道具确认": "ផ្ញើធាតុទាក់ទងប្រវត្តិរូប 1 ទៅ {username} មែនទេ? មានសុពលភាព 30 ថ្ងៃ។",
  "页面.求职用户.只搜发布": "ផ្សព្វផ្សាយប៉ុណ្ណោះ",
  "页面.求职用户.只搜草稿": "ព្រាងប៉ុណ្ណោះ",
  "页面.求职用户.基本信息": "ព័ត៌មានមូលដ្ឋាន",
  "页面.求职用户.头像": "រូបថត",
  "页面.求职用户.女": "ស្រី",
  "页面.求职用户.姓名": "ឈ្មោះ",
  "页面.求职用户.姓名说明": "ផ្គូផ្គងឈ្មោះ",
  "页面.求职用户.学历": "ការអប់រំ",
  "页面.求职用户.学历说明": "កម្រិតអប់រំ",
  "页面.求职用户.学校": "សាលា",
  "页面.求职用户.审核时间": "ពេលពិនិត្យ",
  "页面.求职用户.审核来源": "ប្រភពពិនិត្យ",
  "页面.求职用户.审核状态": "ស្ថានភាពពិនិត្យ",
  "页面.求职用户.密码": "លេខសម្ងាត់",
  "页面.求职用户.密码至少8字符": "លេខសម្ងាត់យ៉ាងហោចណាស់ 8 តួអក្សរ",
  "页面.求职用户.密码需包含字母和数字": "ត្រូវមានទាំងអក្សរ និងលេខ",
  "页面.求职用户.岁": " ឆ្នាំ",
  "页面.求职用户.岗位加急道具": "ធាតុ Boost ការងារ",
  "页面.求职用户.岗位加急道具余额": "អាចប្រើបាន៖ {count}",
  "页面.求职用户.岗位加急道具说明": "ការបញ្ជាក់ម្តងផ្ញើធាតុ 1 ដែលមានសុពលភាព 30 ថ្ងៃ។ មើលកំណត់ត្រាក្នុងបញ្ជីសិទ្ធិ។",
  "页面.求职用户.岗位发布道具": "ធាតុបង្ហោះការងារ",
  "页面.求职用户.岗位发布道具余额": "អាចប្រើបាន៖ {count}",
  "页面.求职用户.岗位发布道具说明": "ការបញ្ជាក់ម្តងផ្ញើធាតុ 1 ដែលមានសុពលភាព 30 ថ្ងៃ។ មើលកំណត់ត្រាក្នុងបញ្ជីសិទ្ធិ។",
  "页面.求职用户.工作内容": "ការពិពណ៌នា",
  "页面.求职用户.工作经历": "បទពិសោធន៍ការងារ",
  "页面.求职用户.已下架": "ដកចេញរួច",
  "页面.求职用户.已关联用户": "ចាត់ចែងរួច",
  "页面.求职用户.已发布": "ផ្សព្វផ្សាយរួច",
  "页面.求职用户.已封禁": "រារ",
  "页面.求职用户.已选用户": "អ្នកប្រើដែលបានជ្រើស",
  "页面.求职用户.已选用户数量": "{count}",
  "页面.求职用户.已通过": "បានអនុម័ត",
  "页面.求职用户.已驳回": "បានបដិសេធ",
  "页面.求职用户.待审核": "កំពុងរង់ចាំ",
  "页面.求职用户.性别": "យេនឌ័រ",
  "页面.求职用户.意向ID": "ID ចំណាប់អារម្មណ៍",
  "页面.求职用户.意向ID标签": "ID ចំណាប់អារម្មណ៍",
  "页面.求职用户.意向ID说明": "ID ចុចមើល",
  "页面.求职用户.手机号": "ទូរស័ព្ទ",
  "页面.求职用户.批量减少道具": "កាត់ធាតុជាបាច់",
  "页面.求职用户.批量发放道具原因": "ផ្តល់ធាតុជាបាច់ពីផ្ទៃគ្រប់គ្រង",
  "页面.求职用户.批量处理成功": "បានដំណើរការ​អ្នកប្រើ {count} នាក់",
  "页面.求职用户.批量处理部分失败": "ជោគជ័យ {successCount} បរាជ័យ {failedCount}",
  "页面.求职用户.批量扣减道具原因": "កាត់ធាតុជាបាច់ពីផ្ទៃគ្រប់គ្រង",
  "页面.求职用户.批量添加道具": "បន្ថែមធាតុជាបាច់",
  "页面.求职用户.批量调整道具失败": "ការកែតម្រូវជាបាច់បរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.求职用户.招聘者": "អ្នកជួយ",
  "页面.求职用户.括号无": "(គ្មាន)",
  "页面.求职用户.搜索用户名昵称邮箱手机号": "ស្វែងរកឈ្មោះ និយម អ៉ីមែល ទូរស័ព្ទ",
  "页面.求职用户.操作": "សកម្មភាព",
  "页面.求职用户.教育经历": "ការអប់រំ",
  "页面.求职用户.数量": "ចំនួន",
  "页面.求职用户.文件名": "ឈ្មោះឯកសារ",
  "页面.求职用户.文件大小": "ទំហំឯកសារ",
  "页面.求职用户.文件无法读取": "មិនអាចអានឯកសារ",
  "页面.求职用户.无关键信息": "គ្មានព័ត៌មានគន្លឹះ",
  "页面.求职用户.时间": "ពេលវេលា",
  "页面.求职用户.昵称": "ឈ្មោះនិយម",
  "页面.求职用户.暂无数据": "គ្មានទិន្នន័យ",
  "页面.求职用户.更新时间": "ធ្វើបច្ចុប្បន្នភាពនៅ",
  "页面.求职用户.更新时间标签": "ធ្វើបច្ចុប្បន្នភាពនៅ",
  "页面.求职用户.更新时间说明": "ធ្វើបច្ចុប្បន្នភាពនៅ",
  "页面.求职用户.期望地点": "ទីតាំងចង់បាន",
  "页面.求职用户.期望地点标签": "ទីតាំងចង់បាន",
  "页面.求职用户.期望地点说明": "ទីតាំងពិតប្រាកដ",
  "页面.求职用户.期望岗位": "តំណាងចង់បាន",
  "页面.求职用户.期望岗位标签": "តំណាងចង់បាន",
  "页面.求职用户.期望薪资上限": "ប្រាក់ខែអតិបរមា",
  "页面.求职用户.期望薪资上限说明": "ចម្រោះប្រាក់ខែអតិបរមា",
  "页面.求职用户.期望薪资下限": "ប្រាក់ខែអប្បបរមា",
  "页面.求职用户.期望薪资下限说明": "ចម្រោះប្រាក់ខែអប្បបរមា",
  "页面.求职用户.期望薪资美元": "ប្រាក់ខែចង់បាន",
  "页面.求职用户.期望薪资美元标签": "ប្រាក់ខែចង់បាន",
  "页面.求职用户.期望薪资范围": "ជួរប្រាក់ខែ",
  "页面.求职用户.未提供jobIntentionId或jobIntention": "មិនបានផ្តល់ jobIntentionId ឬ jobIntention",
  "页面.求职用户.未提供resumeId或resume": "មិនបានផ្តល់ resumeId ឬ resume",
  "页面.求职用户.未提供userId或user": "មិនបានផ្តល់ userId ឬ user",
  "页面.求职用户.未激活": "អសកម្ម",
  "页面.求职用户.来源文件": "ឯកសារប្រភព",
  "页面.求职用户.柬文": "ខ្មែរ",
  "页面.求职用户.柬文能力": "ខ្មែរ ≥",
  "页面.求职用户.核心技能": "ជំនាញគន្លឹះ",
  "页面.求职用户.核心技能说明": "ផ្គូផ្គងជំនាញ",
  "页面.求职用户.求职岗位列表": "បញ្ជីតំណាង",
  "页面.求职用户.求职岗位筛选": "ចម្រោះតំណាង",
  "页面.求职用户.求职意向": "ចំណាប់អារម្មណ៍ការងារ",
  "页面.求职用户.求职意向信息": "ព័ត៌មានចំណាប់អារម្មណ៍",
  "页面.求职用户.求职意向详情": "ព័ត៌មានចំណាប់អារម្មណ៍",
  "页面.求职用户.求职档案": "ប្រវត្តិរកការងារ",
  "页面.求职用户.求职者": "អ្នករកការងារ",
  "页面.求职用户.注册方式": "វិធីចុះឈ្មោះ",
  "页面.求职用户.注册方式BotStart": "Bot /start",
  "页面.求职用户.注册方式GoogleOAuth": "ចូលដោយ Google",
  "页面.求职用户.注册方式TelegramOAuth": "ចូលដោយ Telegram",
  "页面.求职用户.注册方式后台创建": "បង្កើតពីផ្ទាំងគ្រប់គ្រង",
  "页面.求职用户.注册方式后台手动": "បញ្ចូលដោយដៃ",
  "页面.求职用户.注册方式小程序授权": "ការអនុញ្ញាត Mini App",
  "页面.求职用户.注册方式说明": "របៀបចុះឈ្មោះ (ទិន្នន័យចាស់អាចទទេ)",
  "页面.求职用户.注册端App": "App",
  "页面.求职用户.注册端TelegramBot": "Telegram Bot",
  "页面.求职用户.注册端Telegram小程序": "Telegram Mini App",
  "页面.求职用户.注册端管理后台": "កុងសូលអ្នកគ្រប់គ្រង",
  "页面.求职用户.注册端类型": "ប្រភេទចុះឈ្មោះ",
  "页面.求职用户.注册端类型说明": "កម្មវិធីពេលចុះឈ្មោះ (ទិន្នន័យចាស់អាចទទេ)",
  "页面.求职用户.活跃": "សកម្ម",
  "页面.求职用户.状态": "ស្ថានភាព",
  "页面.求职用户.状态说明": "សកម្ម / អសកម្ម / រារ",
  "页面.求职用户.用户ID": "ID អ្នកប្រើ",
  "页面.求职用户.用户ID标签": "ID អ្នកប្រើ",
  "页面.求职用户.用户ID点击详情": "ID ចុចមើល",
  "页面.求职用户.用户ID过滤": "ចម្រោះតាម ID",
  "页面.求职用户.用户ID过滤公海": "ID ចុចមើលអ្នកប្រើ",
  "页面.求职用户.用户名": "ឈ្មោះអ្នកប្រើ",
  "页面.求职用户.用户名3到64字符": "ឈ្មោះអ្នកប្រើ 3-64 តួអក្សរ",
  "页面.求职用户.用户管理": "គ្រប់គ្រងអ្នកប្រើ",
  "页面.求职用户.用户详情": "ព័ត៌មានអ្នកប្រើ",
  "页面.求职用户.用户身份说明": "អ្នករកការងារ / អ្នកជួយ",
  "页面.求职用户.电话": "ទូរស័ព្ទ",
  "页面.求职用户.男": "ប្រុស",
  "页面.求职用户.确认发送": "បញ្ជាក់ការផ្ញើ",
  "页面.求职用户.确认通过附件": "អនុម័តឯកសារប្រវត្តិរូបនេះ?",
  "页面.求职用户.确认驳回附件": "បដិសេធឯកសារប្រវត្តិរូបនេះ?",
  "页面.求职用户.空": "(ទទេ)",
  "页面.求职用户.简历ID": "ID ប្រវត្តិរូប",
  "页面.求职用户.简历ID标签": "ID ប្រវត្តិរូប",
  "页面.求职用户.简历ID点击详情": "ID ចុចមើល",
  "页面.求职用户.简历ID说明": "ID ចុចមើល",
  "页面.求职用户.简历管理": "គ្រប់គ្រងប្រវត្តិរូប",
  "页面.求职用户.简历联系道具": "ធាតុទាក់ទងប្រវត្តិរូប",
  "页面.求职用户.简历联系道具余额": "អាចប្រើបាន៖ {count}",
  "页面.求职用户.简历联系道具说明": "ការបញ្ជាក់ម្តងផ្ញើធាតុ 1 ដែលមានសុពលភាព 30 ថ្ងៃ។ មើលកំណត់ត្រាក្នុងបញ្ជីសិទ្ធិ។",
  "页面.求职用户.简历详情": "ព័ត៌មានប្រវត្តិរូប",
  "页面.求职用户.简历附件审核": "ពិនិត្យឯកសារប្រវត្តិរូប",
  "页面.求职用户.累计已发岗数": "ចំនួនការងារបានបង្កើតសរុប៖ {count}",
  "页面.求职用户.累计已发岗数说明": "រាប់បញ្ចូលការងារដែលបានលុប ហើយការលុបការងារមិនស្តារកូតាប្រកាសឡើងវិញទេ",
  "页面.求职用户.编辑会员权益标题": "កែសិទ្ធិសមាជិករបស់ {username}",
  "页面.求职用户.美元": "ដុល្លារ",
  "页面.求职用户.职位": "តួនាទី",
  "页面.求职用户.联系次数": "ចំនួនទំនាក់ទំនង",
  "页面.求职用户.联系次数说明": "ចំនួនប្រវត្តិរូបដែលអ្នកប្រើ B អាចទាក់ទងបានក្នុងឃ្លាំងបេក្ខជន; អប្បបរមា 0",
  "页面.求职用户.能力说明": "0-4",
  "页面.求职用户.自我介绍": "ណែនាំខ្លួន",
  "页面.求职用户.自我介绍说明": "ផ្គូផ្គង",
  "页面.求职用户.至今": "បច្ចុប្បន្ន",
  "页面.求职用户.至少8个字符": "យ៉ាងហោចណាស់ 8 តួអក្សរ",
  "页面.求职用户.英文": "អង់គ្លេស",
  "页面.求职用户.英文能力": "អង់គ្លេស ≥",
  "页面.求职用户.草稿": "ព្រាង",
  "页面.求职用户.草稿内容": "មាតិកាព្រាង",
  "页面.求职用户.获取详情失败": "ផ្ទុកព័ត៌មានបរាជ័យ",
  "页面.求职用户.证书": "វិញ្ញាបនប័ត្រ",
  "页面.求职用户.证书名称": "ឈ្មោះវិញ្ញាបនប័ត្រ",
  "页面.求职用户.证书图片": "រូបវិញ្ញាបនប័ត្រ",
  "页面.求职用户.该简历暂无发布内容": "គ្មានមាតិកាផ្សព្វផ្សាយ",
  "页面.求职用户.该简历暂无草稿内容": "គ្មានមាតិកាព្រាង",
  "页面.求职用户.语言等级商务": "អាជីវកម្ម",
  "页面.求职用户.语言等级基础": "មូលដ្ឋាន",
  "页面.求职用户.语言等级无": "គ្មាន",
  "页面.求职用户.语言等级日常": "ប្រចាំថ្ងៃ",
  "页面.求职用户.语言等级母语": "ភាសាកំណើត",
  "页面.求职用户.语言能力": "ភាសា",
  "页面.求职用户.请求失败": "ស្នើសុំបរាជ័យ",
  "页面.求职用户.请输入原因": "បញ្ចូលមូលហេតុ",
  "页面.求职用户.请输入发岗上限": "បញ្ចូលដែនកំណត់ប្រកាសការងារ",
  "页面.求职用户.请输入密码": "សូមបញ្ចូលលេខសម្ងាត់",
  "页面.求职用户.请输入数量": "បញ្ចូលចំនួន",
  "页面.求职用户.请输入用户名": "សូមបញ្ចូលឈ្មោះអ្នកប្រើ",
  "页面.求职用户.请输入联系次数": "បញ្ចូលចំនួនទំនាក់ទំនង",
  "页面.求职用户.请选择会员有效期": "ជ្រើសរើសរយៈពេលសមាជិកភាព",
  "页面.求职用户.请选择地区": "ជ្រើសរើសទីតាំង",
  "页面.求职用户.请选择岗位可多选": "ជ្រើសរើសតំណាង (ច្រើន)",
  "页面.求职用户.请选择道具类型": "ជ្រើសប្រភេទធាតុ",
  "页面.求职用户.账号信息": "ព័ត៌មានគណនី",
  "页面.求职用户.账号手机号": "ទូរស័ព្ទគណនី",
  "页面.求职用户.账号邮箱": "អ៉ីមែលគណនី",
  "页面.求职用户.账号限制.封禁": "បិទគណនី",
  "页面.求职用户.账号限制.封禁成功": "បានបិទគណនីអ្នកប្រើ",
  "页面.求职用户.账号限制.已封禁": "បានបិទគណនី",
  "页面.求职用户.账号限制.已禁言": "បានបិទសារ",
  "页面.求职用户.账号限制.操作失败": "ប្រតិបត្តិការបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.求职用户.账号限制.正常": "ធម្មតា",
  "页面.求职用户.账号限制.状态": "ការរឹតត្បិត",
  "页面.求职用户.账号限制.状态说明": "ស្ថានភាពបិទសារ ឬបិទគណនីបច្ចុប្បន្ន",
  "页面.求职用户.账号限制.确认封禁": "បិទគណនីអ្នកប្រើនេះមែនទេ?",
  "页面.求职用户.账号限制.确认封禁说明": "អ្នកប្រើនឹងមិនអាចប្រើ API ដែលត្រូវចូលបានទេ ប៉ុន្តែនៅតែអាចដាក់បណ្តឹងតវ៉ា។",
  "页面.求职用户.账号限制.确认禁言": "បិទសារអ្នកប្រើនេះមែនទេ?",
  "页面.求职用户.账号限制.确认禁言说明": "អ្នកប្រើនៅតែអាចចូលបាន ប៉ុន្តែមិនអាចផ្ញើសារ IM បានទេ។",
  "页面.求职用户.账号限制.确认解除": "ដោះការរឹតត្បិតបច្ចុប្បន្នមែនទេ?",
  "页面.求职用户.账号限制.禁言": "បិទសារ",
  "页面.求职用户.账号限制.禁言成功": "បានបិទសារអ្នកប្រើ",
  "页面.求职用户.账号限制.解除": "ដោះលែង",
  "页面.求职用户.账号限制.解除成功": "បានដោះការរឹតត្បិតគណនី",
  "页面.求职用户.身份": "អត្តសញ្ញាណ",
  "页面.求职用户.身份筛选": "ចម្រោះអត្តសញ្ញាណ",
  "页面.求职用户.选填最大128字符": "ជម្រើស អតិបរមា 128 តួអក្សរ",
  "页面.求职用户.选填唯一": "ជម្រើស មួយគត់",
  "页面.求职用户.通过审核": "អនុម័ត",
  "页面.求职用户.道具类型": "ប្រភេទធាតុ",
  "页面.求职用户.邮箱": "អ៉ីមែល",
  "页面.求职用户.附件ID": "ID ឯកសារ",
  "页面.求职用户.附件审核失败": "ការពិនិត្យបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.求职用户.附件审核成功": "បានធ្វើបច្ចុប្បន្នភាពការពិនិត្យ",
  "页面.求职用户.附件预览失败": "មើលជាមុនបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.求职用户.非简历文件": "មិនមែនប្រវត្តិរូប",
  "页面.求职用户.颁发日期": "ថ្ងៃចេញ",
  "页面.求职用户.颁发机构": "អង្គភាពចេញ",
  "页面.求职用户.预览附件": "មើលជាមុន",
  "页面.求职用户.驳回原因": "មូលហេតុបដិសេធ",
  "页面.求职用户.驳回附件": "បដិសេធ",
  "页面.求职用户.默认求职者": "អ្នករកការងារលំនាំដើម",
  "页面.热门分组配置.上传配图提示": "ផ្ទុករូបភាពស្លាកឡើង",
  "页面.热门分组配置.岗位标签集": "សំណុំស្លាកការងារ",
  "页面.热门分组配置.岗位标签集支持说明": "កម្រិត 1 សម្រាប់បង្ហាញក្រុមប៉ុណ្ណោះ។ ជ្រើសបានតែកម្រិត 2",
  "页面.热门分组配置.拖拽调整展示顺序": "អូសដើម្បីផ្លាស់ប្តូរលំដាប់",
  "页面.热门分组配置.排序": "លំដាប់",
  "页面.热门分组配置.新增标签": "បន្ថែមស្លាក",
  "页面.热门分组配置.标签名称": "ឈ្មោះស្លាក",
  "页面.热门分组配置.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.热门分组配置.正在更新排序": "កំពុងធ្វើបច្ចុប្បន្នភាពលំដាប់",
  "页面.热门分组配置.状态": "ស្ថានភាព",
  "页面.热门分组配置.确认删除该标签": "តើអ្នកប្រាកដថាចង់លុបស្លាកនេះឬ?",
  "页面.热门分组配置.编辑标签": "កែសម្រួលស្លាក",
  "页面.热门分组配置.请输入排序": "សូមបញ្ចូលលំដាប់",
  "页面.热门分组配置.请输入标签名称": "សូមបញ្ចូលឈ្មោះស្លាក",
  "页面.热门分组配置.请选择岗位标签集": "សូមជ្រើសរើសសំណុំស្លាកការងារ",
  "页面.热门分组配置.配图": "រូបភាព",
  "页面.登录.失败": "ចូលបរាជ័យ សូមព្យាយាមម្តងទៀត។",
  "页面.登录.密码占位": "លេខសម្ងាត់",
  "页面.登录.密码必填": "សូមបញ្ចូលលេខសម្ងាត់!",
  "页面.登录.忘记密码": "ភ្លេចលេខសម្ងាត់",
  "页面.登录.成功": "ចូលជោគជ័យ!",
  "页面.登录.提交": "ចូល",
  "页面.登录.用户名占位": "ឈ្មោះអ្នកប្រើ",
  "页面.登录.用户名必填": "សូមបញ្ចូលឈ្មោះ!",
  "页面.登录.自动登录": "ចងចាំខ្ញុំ",
  "页面.登录.账户或密码错误": "ឈ្មោះឬលេខសម្ងាត់មិនត្រឹមត្រូវ",
  "页面.登录.账户登录": "ចូលគណនី",
  "页面.管理.仅管理员可看": "ទំព័រនេះមានតែអ្នកគ្រប់គ្រងអាចមើលបាន",
  "页面.管理.使用区块": "ប្រើ block",
  "页面.管理.标题": "DodoJob គ្រប់គ្រង",
  "页面.管理.添加页面提示": "ចង់បន្ថែមទំព័រ? សូមយោង",
  "页面.配置.地区.Tab标准": "ទីតាំងស្តង់ដារ",
  "页面.配置.地区.Tab非标": "ទីតាំងមិនស្តង់ដារ",
  "页面.配置.地区.上移": "ឡើង",
  "页面.配置.地区.下移": "ចុះ",
  "页面.配置.地区.仅一二级可设热门": "មានតែកម្រិត 1 ឬ 2 អាចកំណត់ពេញនិយម",
  "页面.配置.地区.仅一二级可设热门提示": "មានតែកម្រិត 1 ឬ 2",
  "页面.配置.地区.可选一级或二级": "ជ្រើសរើសកម្រិត 1 ឬ 2",
  "页面.配置.地区.同步": "ធ្វើឱ្យរួមបញ្ចូលគ្នា",
  "页面.配置.地区.同步成功条": "ធ្វើឱ្យរួមបញ្ចូលគ្នារួច {count} ទីតាំង",
  "页面.配置.地区.否": "ទេ",
  "页面.配置.地区.启用国家": "បើកប្រទេស",
  "页面.配置.地区.启用国家同步后可启用": "បើកប្រទេស (បន្ទាប់ពីធ្វើឱ្យរួមបញ្ចូលគ្នា)",
  "页面.配置.地区.启用失败": "បើកបរាជ័យ",
  "页面.配置.地区.启用失败重试": "បើកបរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.配置.地区.启用成功": "បើកជោគជ័យ",
  "页面.配置.地区.地区排序说明": "មាន {count} ទីតាំង។ ឡើង/ចុះផ្លាស់ប្តូរលំដាប់កម្រិតដូចគ្នា។",
  "页面.配置.地区.地区树": "ដើមឈើទីតាំង",
  "页面.配置.地区.多语言名称": "ឈ្មោះពហុភាសា",
  "页面.配置.地区.展示排序": "លំដាប់បង្ហាញ",
  "页面.配置.地区.展示排序提示": "លេខតូចជាងនៅមុខ។ អនុវត្តចំពោះទីតាំងទាំងអស់ និងពេញនិយម។",
  "页面.配置.地区.已启用": "បើករួចហើយ",
  "页面.配置.地区.已在热门列表中": "មានក្នុងបញ្ជីពេញនិយមរួចហើយ",
  "页面.配置.地区.当前仅支持同步柬埔寨": "គាំទ្រតែកម្ពុជា (KH)",
  "页面.配置.地区.当前仅支持启用柬埔寨": "អាចបើកបានតែកម្ពុជា (KH)",
  "页面.配置.地区.排序": "លំដាប់",
  "页面.配置.地区.是": "យាយ",
  "页面.配置.地区.是否启用": "សកម្ម",
  "页面.配置.地区.显示名称": "ឈ្មោះបង្ហាញ",
  "页面.配置.地区.显示名称说明": "បង្ហាញ: zh_CN → en_US → name_en",
  "页面.配置.地区.暂无可排序地区": "គ្មានទីតាំងសម្រាប់តម្រៀប",
  "页面.配置.地区.暂无可用国家": "គ្មានប្រទេស។ ពិនិត្យ backend។",
  "页面.配置.地区.暂无热门地区": "គ្មានទីតាំងពេញនិយម។ បន្ថែមពីខាងលើ។",
  "页面.配置.地区.标准名称": "ឈ្មោះស្តង់ដារ",
  "页面.配置.地区.标准名称说明": "ឈ្មោះអង់គ្លេស អានតែប៉ុណ្ណោះ",
  "页面.配置.地区.添加": "បន្ថែម",
  "页面.配置.地区.热门": "ពេញនិយម",
  "页面.配置.地区.热门排序": "លំដាប់ពេញនិយម",
  "页面.配置.地区.热门排序提示": "លេខតូចជាង = ខ្ពស់ជាង",
  "页面.配置.地区.热门顺序说明": "លំដាប់ = លំដាប់បង្ហាញទីតាំងពេញនិយម។ អាចឡើង/ចុះ។",
  "页面.配置.地区.移除": "យកចេញ",
  "页面.配置.地区.管理地区排序": "គ្រប់គ្រងលំដាប់ទីតាំង",
  "页面.配置.地区.管理热门城市": "គ្រប់គ្រងទីក្រុងពេញនិយម",
  "页面.配置.地区.级别": "កម្រិត",
  "页面.配置.地区.编码": "កូដ",
  "页面.配置.地区.编辑地区": "កែទីតាំង",
  "页面.配置.地区.自动生成多语言": "បង្កើតដោយស្វ័យប្រវត្តి",
  "页面.配置.地区.该国家尚未同步": "ប្រទេសនេះមិនទាន់ធ្វើឱ្យរួមបញ្ចូលគ្នាទេ។ ចុច Sync។",
  "页面.配置.地区.请填写不小于0的整数": "បញ្ចូលចំនួនគត់ ≥ 0",
  "页面.配置.地区.请输入名称": "បញ្ចូលឈ្មោះ {label}",
  "页面.配置.岗位反馈类型.创建时间": "បង្កើតនៅ",
  "页面.配置.岗位反馈类型.创建时间说明": "បង្កើតនៅ",
  "页面.配置.岗位反馈类型.名称说明": "ឈ្មោះ (value)",
  "页面.配置.岗位反馈类型.岗位反馈类型ID": "ID ប្រភេទមតិយោបល់ការងារ",
  "页面.配置.岗位反馈类型.岗位反馈类型管理": "ប្រភេទមតិយោបល់ការងារ",
  "页面.配置.岗位反馈类型.成功删除N个": "លុបរួច {n} ប្រភេទមតិយោបល់ការងារ",
  "页面.配置.岗位反馈类型.成功删除部分失败": "លុបរួច {ok} បរាជ័យ {fail}",
  "页面.配置.岗位反馈类型.排序": "លំដាប់",
  "页面.配置.岗位反馈类型.排序说明": "តូចជាង = ខ្ពស់ជាង",
  "页面.配置.岗位反馈类型.是否启用": "សកម្ម",
  "页面.配置.岗位反馈类型.正在删除N个": "កំពុងលុប {n} ប្រភេទមតិយោបល់ការងារ...",
  "页面.配置.岗位反馈类型.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.配置.岗位反馈类型.正在添加": "កំពុងបន្ថែម...",
  "页面.配置.岗位反馈类型.确定删除岗位反馈类型": "លុបប្រភេទមតិយោបល់ការងារនេះ?",
  "页面.配置.岗位投诉类型.创建时间": "បង្កើតនៅ",
  "页面.配置.岗位投诉类型.创建时间说明": "បង្កើតនៅ",
  "页面.配置.岗位投诉类型.名称说明": "ឈ្មោះ (value)",
  "页面.配置.岗位投诉类型.岗位投诉类型ID": "ID ប្រភេទបរិហារ",
  "页面.配置.岗位投诉类型.岗位投诉类型管理": "ប្រភេទបរិហារ",
  "页面.配置.岗位投诉类型.成功删除N个": "លុបរួច {n} ប្រភេទបរិហារ",
  "页面.配置.岗位投诉类型.成功删除部分失败": "លុបរួច {ok} បរាជ័យ {fail}",
  "页面.配置.岗位投诉类型.排序": "លំដាប់",
  "页面.配置.岗位投诉类型.排序说明": "តូចជាង = ខ្ពស់ជាង",
  "页面.配置.岗位投诉类型.是否启用": "សកម្ម",
  "页面.配置.岗位投诉类型.正在删除N个": "កំពុងលុប {n} ប្រភេទបរិហារ...",
  "页面.配置.岗位投诉类型.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.配置.岗位投诉类型.正在添加": "កំពុងបន្ថែម...",
  "页面.配置.岗位投诉类型.确定删除岗位投诉类型": "លុបប្រភេទបរិហារនេះ?",
  "页面.配置.岗位标签.Tab标准": "តួនាទីស្តង់ដារ",
  "页面.配置.岗位标签.Tab非标": "ស្លាកការងារមិនស្តង់ដារ",
  "页面.配置.岗位标签.多语言显示文本": "អត្ថបទពហុភាសា",
  "页面.配置.岗位标签.多语言显示文本说明": "ជម្រើសសម្រាប់ i18n",
  "页面.配置.岗位标签.导出全量": "នាំចេញទាំងអស់",
  "页面.配置.岗位标签.导出密码": "លេខសម្ងាត់",
  "页面.配置.岗位标签.导出成功": "នាំចេញជោគជ័យ",
  "页面.配置.岗位标签.导出标准岗位标签全量": "នាំចេញតួនាទីស្តង់ដារ",
  "页面.配置.岗位标签.导出用户名": "ឈ្មោះអ្នកប្រើ",
  "页面.配置.岗位标签.导出非标岗位标签全量": "នាំចេញស្លាកការងារមិនស្តង់ដារ",
  "页面.配置.岗位标签.岗位数": "ចំនួនការងារ",
  "页面.配置.岗位标签.岗位数说明": "ចំនួនការងារប្រើស្លាកនេះ",
  "页面.配置.岗位标签.岗位标签管理": "តួនាទីការងារ",
  "页面.配置.岗位标签.成功删除N个": "លុបរួច {n} តួនាទី",
  "页面.配置.岗位标签.成功删除部分失败": "លុបរួច {ok} បរាជ័យ {fail}",
  "页面.配置.岗位标签.按原始文本关键词搜索": "បញ្ចូលពាក្យគន្លឹះស្វែងរក",
  "页面.配置.岗位标签.新建岗位标签": "តួនាទីថ្មី",
  "页面.配置.岗位标签.新建标签": "ស្លាកថ្មី",
  "页面.配置.岗位标签.是否启用": "សកម្ម",
  "页面.配置.岗位标签.标签ID": "ID ស្លាក",
  "页面.配置.岗位标签.标签代码": "កូដ",
  "页面.配置.岗位标签.标签名称": "ឈ្មោះស្លាក",
  "页面.配置.岗位标签.标签名称value": "ឈ្មោះស្លាក (value)",
  "页面.配置.岗位标签.标签名称不能超过128": "ឈ្មោះស្លាកអតិបរមា 128",
  "页面.配置.岗位标签.标签名称多语言": "ឈ្មោះស្លាក (i18n)",
  "页面.配置.岗位标签.标签名称必填": "ឈ្មោះស្លាកត្រូវតែបំពេញ",
  "页面.配置.岗位标签.标签配图": "រូបស្លាក",
  "页面.配置.岗位标签.标签配图tips": "កាត់ 1:1 ជាមុន ប្រព័ន្ធបង្កើត 1x (88×88) និង 2x (176×176) ហើយផ្ទុកឡើង។ សម្រាប់គុណភាពល្អ ប្រើរូបយ៉ាងហោចណាស់ 176×176 ក្រោយកាត់ ជ្រុងខ្លី≥176px។",
  "页面.配置.岗位标签.正在删除N个": "កំពុងលុប {n} តួនាទី...",
  "页面.配置.岗位标签.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.配置.岗位标签.正在添加": "កំពុងបន្ថែម...",
  "页面.配置.岗位标签.添加子级": "បន្ថែមកូន",
  "页面.配置.岗位标签.确定删除岗位标签": "លុបតួនាទីនេះ? កូននឹងត្រូវលុបផង។",
  "页面.配置.岗位标签.编辑岗位标签": "កែតួនាទី",
  "页面.配置.岗位标签.至少填写一个语言": "យ៉ាងហោចណាស់មួយភាសា",
  "页面.配置.岗位标签.至少填写中文或英文": "យ៉ាងហោចណាស់ចិនឬអង់គ្លេស",
  "页面.配置.岗位标签.请输入导出密码": "បញ្ចូលលេខសម្ងាត់",
  "页面.配置.岗位标签.请输入导出用户名": "បញ្ចូលឈ្មោះអ្នកប្រើ",
  "页面.配置.岗位标签.请输入标签名称": "ឧ. វិស្វករសូហ្វវែរ",
  "页面.配置.岗位标签.选择图片并裁剪": "ជ្រើសរូបហើយកាត់ 1:1",
  "页面.配置.岗位标签.配图": "រូបភាព",
  "页面.配置.岗位标签.配图尺寸过小": "បន្ទាប់ពីកាត់ ជ្រុងខ្លីត្រូវតែយ៉ាងហោចណាស់ {min}px (បច្ចុប្បន្ន {current}px)",
  "页面.配置.岗位标签.配图规格说明": "1x {w1}×{h1}px, 2x {w2}×{h2}px",
  "页面.配置.岗位标签.非标出现次数": "ចំនួនដង",
  "页面.配置.岗位标签.非标出现次数说明": "សម្រាប់វិភាគនិងតម្រៀប",
  "页面.配置.岗位标签.非标原始文本": "អត្ថបទដើម",
  "页面.配置.岗位标签.非标原始文本说明": "អត្ថបទដើមពេលគ្មានស្លាកត្រូវគ្នា",
  "页面.配置.岗位标签.非标类型": "ប្រភេទ",
  "页面.配置.岗位标签.非标类型岗位标签": "ស្លាកតួនាទី",
  "页面.配置.岗位标签.非标类型工作地点": "ទីតាំងការងារ",
  "页面.配置.游客联系限制.中度不能小于轻度": "កម្រិតមធ្យមមិនអាចតិចជាងកម្រិតស្រាលបានទេ",
  "页面.配置.游客联系限制.中度联系": "ទាក់ទងកម្រិតមធ្យម",
  "页面.配置.游客联系限制.中度联系阈值": "កម្រិតទាក់ទងមធ្យម",
  "页面.配置.游客联系限制.加载失败": "ផ្ទុកការកំណត់បរាជ័យ",
  "页面.配置.游客联系限制.加载失败重试": "ផ្ទុកការកំណត់បរាជ័យ សូមព្យាយាមម្តងទៀត",
  "页面.配置.游客联系限制.周": "សប្តាហ៍",
  "页面.配置.游客联系限制.周期单位": "ឯកតារយៈពេល",
  "页面.配置.游客联系限制.周期数值": "តម្លៃរយៈពេល",
  "页面.配置.游客联系限制.天": "ថ្ងៃ",
  "页面.配置.游客联系限制.当前生效配置": "ការកំណត់កំពុងប្រើ",
  "页面.配置.游客联系限制.月": "ខែ",
  "页面.配置.游客联系限制.次": "ដង",
  "页面.配置.游客联系限制.正在保存": "កំពុងរក្សាទុកការកំណត់...",
  "页面.配置.游客联系限制.统计周期": "រយៈពេលរាប់",
  "页面.配置.游客联系限制.说明内容": "C-end អានពី /api/v1/config ដើម្បីបែងចែកចំនួនការទាក់ទងការងាររបស់ភ្ញៀវក្នុងរយៈពេលបានកំណត់។",
  "页面.配置.游客联系限制.说明标题": "កិច្ចសន្យា C-end",
  "页面.配置.游客联系限制.请输入中度阈值": "សូមបញ្ចូលកម្រិតទាក់ទងមធ្យម",
  "页面.配置.游客联系限制.请输入周期数值": "សូមបញ្ចូលតម្លៃរយៈពេល",
  "页面.配置.游客联系限制.请输入轻度阈值": "សូមបញ្ចូលកម្រិតទាក់ទងស្រាល",
  "页面.配置.游客联系限制.请选择周期单位": "សូមជ្រើសរើសឯកតារយៈពេល",
  "页面.配置.游客联系限制.轻度联系": "ទាក់ទងកម្រិតស្រាល",
  "页面.配置.游客联系限制.轻度联系阈值": "កម្រិតទាក់ទងស្រាល",
  "页面.配置.游客联系限制.重新加载": "ផ្ទុកឡើងវិញ",
  "页面.配置.游客联系限制.页面标题": "កំណត់ការទាក់ទងភ្ញៀវ",
  "页面.配置.游客联系限制.频次限制": "រយៈពេលកំណត់",
  "页面.配置.热搜词配置.创建时间": "បង្កើតនៅ",
  "页面.配置.热搜词配置.创建时间说明": "បង្កើតនៅ",
  "页面.配置.热搜词配置.成功删除N个": "លុបរួច {n} ពាក្យស្វែងរកពេញនិយម",
  "页面.配置.热搜词配置.成功删除部分失败": "លុបរួច {ok} បរាជ័យ {fail}",
  "页面.配置.热搜词配置.排序": "លំដាប់",
  "页面.配置.热搜词配置.排序说明": "តូចជាង = ខ្ពស់ជាង",
  "页面.配置.热搜词配置.新建按钮": "បន្ថែមពាក្យស្វែងរកពេញនិយម",
  "页面.配置.热搜词配置.新建标题": "បន្ថែមពាក្យស្វែងរកពេញនិយម",
  "页面.配置.热搜词配置.是否启用": "សកម្ម",
  "页面.配置.热搜词配置.正在删除N个": "កំពុងលុប {n} ពាក្យស្វែងរកពេញនិយម...",
  "页面.配置.热搜词配置.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.配置.热搜词配置.正在添加": "កំពុងបន្ថែម...",
  "页面.配置.热搜词配置.热搜词": "ពាក្យស្វែងរកពេញនិយម",
  "页面.配置.热搜词配置.热搜词ID": "ID ពាក្យស្វែងរកពេញនិយម",
  "页面.配置.热搜词配置.热搜词说明": "តម្លៃវចនានុក្រម រក្សាទុកជា type=hot_search",
  "页面.配置.热搜词配置.确定删除热搜词": "លុបពាក្យស្វែងរកពេញនិយមនេះ?",
  "页面.配置.热搜词配置.编辑标题": "កែពាក្យស្វែងរកពេញនិយម",
  "页面.配置.热搜词配置.请输入热搜词": "បញ្ចូលពាក្យស្វែងរកពេញនិយម",
  "页面.配置.热搜词配置.页面标题": "ពាក្យស្វែងរកពេញនិយម",
  "页面.配置.福利与保障标签.中文标签": "ស្លាកចិន",
  "页面.配置.福利与保障标签.全部分类": "ប្រភេទទាំងអស់",
  "页面.配置.福利与保障标签.关键词": "ពាក្យគន្លឹះ",
  "页面.配置.福利与保障标签.关键词说明": "ស្វែងតាមប្រភេទ កូដ ឬស្លាក",
  "页面.配置.福利与保障标签.分类.benefit_guarantee": "ស្លាកសុខុមាលភាព",
  "页面.配置.福利与保障标签.分类.job_requirement": "ស្លាកលក្ខខណ្ឌការងារ",
  "页面.配置.福利与保障标签.分类.platform_status": "ស្លាកវេទិកា / ស្ថានភាព",
  "页面.配置.福利与保障标签.分类.work_mode": "ស្លាករបៀបការងារ",
  "页面.配置.福利与保障标签.创建时间": "បង្កើតនៅ",
  "页面.配置.福利与保障标签.创建时间说明": "បង្កើតនៅ",
  "页面.配置.福利与保障标签.字段必填": "តម្រូវឱ្យបំពេញ",
  "页面.配置.福利与保障标签.成功删除N个": "លុបរួច {n} ស្លាក",
  "页面.配置.福利与保障标签.成功删除部分失败": "លុបរួច {ok} បរាជ័យ {fail}",
  "页面.配置.福利与保障标签.排序": "លំដាប់",
  "页面.配置.福利与保障标签.排序说明": "តូចជាង = ខ្ពស់ជាង",
  "页面.配置.福利与保障标签.新建按钮": "បន្ថែមស្លាក",
  "页面.配置.福利与保障标签.新建标题": "បន្ថែមស្លាក",
  "页面.配置.福利与保障标签.是否启用": "សកម្ម",
  "页面.配置.福利与保障标签.标签ID": "ID ស្លាក",
  "页面.配置.福利与保障标签.标签分类": "ប្រភេទស្លាក",
  "页面.配置.福利与保障标签.正在删除N个": "កំពុងលុប {n} ស្លាក...",
  "页面.配置.福利与保障标签.正在更新": "កំពុងធ្វើបច្ចុប្បន្នភាព...",
  "页面.配置.福利与保障标签.正在添加": "កំពុងបន្ថែម...",
  "页面.配置.福利与保障标签.确定删除": "លុបស្លាកនេះ?",
  "页面.配置.福利与保障标签.编码": "កូដ",
  "页面.配置.福利与保障标签.编码只读说明": "មិនអាចកែបន្ទាប់ពីបង្កើត",
  "页面.配置.福利与保障标签.编码说明": "បង្កើតដោយប្រព័ន្ធ មិនកែដៃ",
  "页面.配置.福利与保障标签.编辑标题": "កែស្លាក",
  "页面.配置.福利与保障标签.英文标签": "ស្លាកអង់គ្លេស",
  "页面.配置.福利与保障标签.页面标题": "ឃ្លាំងស្លាក",
  "页面.配置.福利与保障标签.高棉语标签": "ស្លាកខ្មែរ",
  "页面.配置.销售联系方式.Telegram占位": "ឈ្មោះអ្នកប្រើ @ឈ្មោះ ឬតំណ t.me",
  "页面.配置.销售联系方式.Telegram标题": "Telegram",
  "页面.配置.销售联系方式.加载失败": "ផ្ទុកទំនាក់ទំនងផ្នែកលក់បរាជ័យ សូមព្យាយាមម្តងទៀត។",
  "页面.配置.销售联系方式.启用": "បើកប្រើ",
  "页面.配置.销售联系方式.正在保存": "កំពុងរក្សាទុកទំនាក់ទំនងផ្នែកលក់...",
  "页面.配置.销售联系方式.添加联系方式": "បន្ថែមទំនាក់ទំនង",
  "页面.配置.销售联系方式.电话占位": "ឧទាហរណ៍៖ +855 12 345 678",
  "页面.配置.销售联系方式.电话标题": "ទូរស័ព្ទ",
  "页面.配置.销售联系方式.类型": "ប្រភេទ",
  "页面.配置.销售联系方式.联系方式": "ព័ត៌មានទំនាក់ទំនង",
  "页面.配置.销售联系方式.说明内容": "ប្រើសម្រាប់ច្រកទាក់ទងផ្នែកលក់ នៅពេលនិយោជកដល់កំណត់បង្ហោះ។ អាចបន្ថែម Telegram និងលេខទូរស័ព្ទច្រើន ហើយមានតែទំនាក់ទំនងដែលបានបើកប៉ុណ្ណោះដែលត្រូវបានផ្ញើទៅកម្មវិធី។",
  "页面.配置.销售联系方式.说明标题": "ច្បាប់បង្ហាញក្នុងកម្មវិធី",
  "页面.配置.销售联系方式.请输入Telegram": "សូមបញ្ចូលឈ្មោះអ្នកប្រើ Telegram",
  "页面.配置.销售联系方式.请输入电话": "សូមបញ្ចូលលេខទូរស័ព្ទ",
  "页面.配置.销售联系方式.重新加载": "ផ្ទុកឡើងវិញ",
  "页面.配置.销售联系方式.页面标题": "ទំនាក់ទំនងផ្នែកលក់",
  "页面.首页金刚位.保存排序": "រក្សាទុកលំដាប់",
  "页面.首页金刚位.双页排序": "រៀបលំដាប់ផ្លូវកាត់ទំព័រដើម",
  "页面.首页金刚位.双页排序说明": "ទំព័រទាំងពីរបង្ហាញធាតុដែលបានបើកទាំងអស់។ អូសធាតុដែលមិនបានកំណត់ទីតាំង ដើម្បីរៀបលំដាប់។",
  "页面.首页金刚位.固定第N位": "កំណត់ទីតាំងទី {position}",
  "页面.首页金刚位.已是最前可调整位置": "ស្ថិតនៅទីតាំងដែលអាចផ្លាស់ទីបានមុខបំផុតរួចហើយ",
  "页面.首页金刚位.已移到最前": "បានផ្លាស់ទីទៅមុខបំផុត",
  "页面.首页金刚位.拖拽调整顺序": "អូសដើម្បីរៀបលំដាប់",
  "页面.首页金刚位.排序": "រៀបលំដាប់",
  "页面.首页金刚位.排序保存失败": "រក្សាទុកលំដាប់មិនបាន សូមព្យាយាមម្តងទៀត",
  "页面.首页金刚位.排序保存成功": "បានរក្សាទុកលំដាប់",
  "页面.首页金刚位.排序已保存列表刷新失败": "បានរក្សាទុកលំដាប់ ប៉ុន្តែមិនអាចផ្ទុកបញ្ជីឡើងវិញបានទេ។ សូមផ្ទុកទំព័រឡើងវិញដើម្បីពិនិត្យ",
  "页面.首页金刚位.移到最前": "ផ្លាស់ទីទៅមុខបំផុត",
  "页面.首页金刚位.移到最前失败": "ផ្លាស់ទីមិនបាន ហើយលំដាប់មុនត្រូវបានស្ដារឡើងវិញ",
  "页面.首页金刚位.第N页": "ទំព័រ {page}",
  "页面.首页金刚位.顺序": "លំដាប់",
  "顶栏.个人设置": "ការកំណត់",
  "顶栏.帮助": "ឯកសារ",
  "顶栏.搜索": "ស្វែងរក",
  "顶栏.用户": "អ្នកប្រើ",
  "顶栏.角色": "តួនាទី",
  "顶栏.语言": "ភាសា",
  "顶栏.退出登录": "ចាកចេញ",
  "顶栏.通知": "ការជូនដំណឹង"
};
